var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1537.96 385.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119{stroke-width:0px;}.cls-2{fill:#1b75bc;}.cls-2,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-43,.cls-86,.cls-120,.cls-93,.cls-94,.cls-98,.cls-102,.cls-104,.cls-118{mix-blend-mode:multiply;}.cls-3{fill:url(#linear-gradient-30);}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-92,.cls-103,.cls-105{opacity:.5;}.cls-4{fill:url(#linear-gradient-34);}.cls-5{fill:url(#linear-gradient-11);}.cls-6{fill:url(#linear-gradient-18);}.cls-7{fill:url(#linear-gradient-16);}.cls-8{fill:#414042;}.cls-9{fill:url(#New_Gradient_Swatch_4);}.cls-10{fill:url(#New_Gradient_Swatch_3);}.cls-121{mask:url(#mask-41);}.cls-122{mask:url(#mask-40);}.cls-123{mask:url(#mask-35);}.cls-124{mask:url(#mask-31);}.cls-125{mask:url(#mask-30);}.cls-126{mask:url(#mask-32);}.cls-127{mask:url(#mask-34);}.cls-128{mask:url(#mask-33);}.cls-129{mask:url(#mask-22);}.cls-130{mask:url(#mask-23);}.cls-131{mask:url(#mask-24);}.cls-132{mask:url(#mask-25);}.cls-133{mask:url(#mask-15);}.cls-134{mask:url(#mask-17);}.cls-135{mask:url(#mask-18);}.cls-136{mask:url(#mask-14);}.cls-137{mask:url(#mask-13);}.cls-138{mask:url(#mask-19);}.cls-139{mask:url(#mask-12);}.cls-140{mask:url(#mask-20);}.cls-141{mask:url(#mask-21);}.cls-142{mask:url(#mask-37);}.cls-143{mask:url(#mask-36);}.cls-144{mask:url(#mask-38);}.cls-145{mask:url(#mask-39);}.cls-146{mask:url(#mask-11);}.cls-147{mask:url(#mask-16);}.cls-148{mask:url(#mask-10);}.cls-149{mask:url(#mask-27);}.cls-150{mask:url(#mask-28);}.cls-151{mask:url(#mask-29);}.cls-152{mask:url(#mask-26);}.cls-153{filter:url(#luminosity-noclip-9);}.cls-154{filter:url(#luminosity-noclip-7);}.cls-155{filter:url(#luminosity-noclip-3);}.cls-156{filter:url(#luminosity-noclip-5);}.cls-11{fill:url(#linear-gradient-24);}.cls-12{fill:url(#linear-gradient-26);}.cls-13{fill:url(#linear-gradient-25);}.cls-14{fill:url(#linear-gradient-33);}.cls-15{fill:url(#linear-gradient-29);}.cls-16{fill:url(#linear-gradient-37);}.cls-17{fill:url(#linear-gradient-35);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-23);}.cls-20{fill:url(#linear-gradient-15);}.cls-21{fill:url(#linear-gradient-22);}.cls-22{fill:url(#linear-gradient-17);}.cls-23{fill:url(#linear-gradient-82);}.cls-24{fill:url(#linear-gradient-80);}.cls-25{fill:url(#linear-gradient-68);}.cls-26{fill:url(#linear-gradient-65);}.cls-27{fill:url(#linear-gradient-63);}.cls-28{fill:url(#linear-gradient-66);}.cls-29{fill:url(#linear-gradient-61);}.cls-30{fill:url(#linear-gradient-70);}.cls-31{fill:url(#linear-gradient-78);}.cls-32{fill:url(#linear-gradient-74);}.cls-33{fill:url(#linear-gradient-76);}.cls-34{fill:url(#linear-gradient-57);}.cls-35{fill:url(#linear-gradient-59);}.cls-36{fill:url(#linear-gradient-55);}.cls-37{fill:url(#linear-gradient-58);}.cls-38{fill:url(#linear-gradient-53);}.cls-39{fill:url(#New_Gradient_Swatch_3-2);}.cls-40{fill:url(#New_Gradient_Swatch_4-2);}.cls-41{fill:#f7941d;}.cls-157{mask:url(#mask);}.cls-42{fill:#ffde17;}.cls-43,.cls-103,.cls-117{fill:#fff;}.cls-44{fill:#ed1c24;}.cls-45{fill:url(#linear-gradient);}.cls-158{filter:url(#luminosity-noclip);}.cls-46{fill:#ef4136;}.cls-47{fill:#6d6e71;}.cls-48,.cls-92{fill:#f15a29;}.cls-49{fill:url(#linear-gradient-38);}.cls-50{fill:url(#linear-gradient-32);}.cls-51{fill:url(#linear-gradient-31);}.cls-52{fill:url(#linear-gradient-36);}.cls-53{fill:url(#linear-gradient-39);}.cls-54{fill:url(#linear-gradient-28);}.cls-55{fill:url(#linear-gradient-12);}.cls-56{fill:url(#linear-gradient-13);}.cls-57{fill:url(#linear-gradient-19);}.cls-58{fill:url(#linear-gradient-21);}.cls-59{fill:url(#linear-gradient-14);}.cls-60{fill:url(#linear-gradient-20);}.cls-61{fill:url(#linear-gradient-27);}.cls-62{fill:url(#linear-gradient-45);}.cls-63{fill:url(#linear-gradient-46);}.cls-64{fill:url(#linear-gradient-44);}.cls-65{fill:url(#linear-gradient-48);}.cls-66{fill:url(#linear-gradient-49);}.cls-67{fill:url(#linear-gradient-47);}.cls-68{fill:url(#linear-gradient-42);}.cls-69{fill:url(#linear-gradient-43);}.cls-70{fill:url(#linear-gradient-40);}.cls-71{fill:url(#linear-gradient-41);}.cls-72{fill:url(#linear-gradient-51);}.cls-73{fill:url(#linear-gradient-52);}.cls-74{fill:url(#linear-gradient-50);}.cls-75{fill:url(#linear-gradient-62);}.cls-76{fill:url(#linear-gradient-79);}.cls-77{fill:url(#linear-gradient-77);}.cls-78{fill:url(#linear-gradient-75);}.cls-79{fill:url(#linear-gradient-69);}.cls-80{fill:url(#linear-gradient-64);}.cls-81{fill:url(#linear-gradient-71);}.cls-82{fill:url(#linear-gradient-72);}.cls-83{fill:url(#linear-gradient-73);}.cls-84{fill:url(#linear-gradient-83);}.cls-85{fill:url(#linear-gradient-81);}.cls-86,.cls-96,.cls-105{fill:#000;}.cls-159{filter:url(#luminosity-noclip-41);}.cls-160{filter:url(#luminosity-noclip-35);}.cls-161{filter:url(#luminosity-noclip-33);}.cls-162{filter:url(#luminosity-noclip-39);}.cls-163{filter:url(#luminosity-noclip-31);}.cls-164{filter:url(#luminosity-noclip-37);}.cls-165{filter:url(#luminosity-noclip-17);}.cls-166{filter:url(#luminosity-noclip-15);}.cls-167{filter:url(#luminosity-noclip-25);}.cls-168{filter:url(#luminosity-noclip-27);}.cls-169{filter:url(#luminosity-noclip-29);}.cls-170{filter:url(#luminosity-noclip-19);}.cls-171{filter:url(#luminosity-noclip-13);}.cls-172{filter:url(#luminosity-noclip-11);}.cls-173{filter:url(#luminosity-noclip-21);}.cls-174{filter:url(#luminosity-noclip-23);}.cls-87{fill:#f1f2f2;}.cls-88{fill:#58595b;}.cls-89,.cls-98{fill:#bcbec0;}.cls-90{fill:#39b54a;}.cls-91{fill:#808285;}.cls-93{fill:url(#linear-gradient-67);}.cls-93,.cls-94,.cls-99,.cls-100{opacity:.7;}.cls-94{fill:url(#linear-gradient-60);}.cls-95{fill:#860e19;}.cls-97,.cls-102{fill:#a7a9ac;}.cls-99{fill:url(#linear-gradient-54);}.cls-100{fill:url(#linear-gradient-56);}.cls-101{fill:#be1e2d;}.cls-104{fill:#e6e7e8;}.cls-106{fill:url(#linear-gradient-4);}.cls-107{fill:url(#linear-gradient-2);}.cls-108{fill:url(#linear-gradient-3);}.cls-109{fill:url(#linear-gradient-8);}.cls-110{fill:url(#linear-gradient-9);}.cls-111{fill:url(#linear-gradient-7);}.cls-112{fill:url(#linear-gradient-5);}.cls-113{fill:url(#linear-gradient-6);}.cls-114,.cls-118{fill:#939598;}.cls-175{isolation:isolate;}.cls-115{fill:#c49a6c;}.cls-116{fill:#d1d3d4;}.cls-176{mask:url(#mask-3);}.cls-177{mask:url(#mask-2);}.cls-178{mask:url(#mask-5);}.cls-179{mask:url(#mask-4);}.cls-180{mask:url(#mask-1);}.cls-181{mask:url(#mask-7);}.cls-182{mask:url(#mask-6);}.cls-183{mask:url(#mask-8);}.cls-184{mask:url(#mask-9);}.cls-119{fill:#231f20;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 366.13,
    y1: 385.94,
    x2: 366.13,
    y2: 265.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 366.13,
    y1: 276.81,
    x2: 366.13,
    y2: 378.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 366.13,
    y1: 294.05,
    x2: 366.13,
    y2: 358.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 366.13,
    y1: 345.26,
    x2: 366.13,
    y2: 306.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 366.13,
    y1: 363.32,
    x2: 366.13,
    y2: 289.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 366.13,
    y1: 315.55,
    x2: 366.13,
    y2: 337.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 334.86,
    y2: 317.61,
    gradientTransform: "translate(13.86 -14.92) rotate(2.38)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 1116.53,
    x2: 1116.53,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 1116.53,
    x2: 1116.53,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1116.53,
    x2: 1116.53,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1116.51,
    y1: 293.54,
    x2: 1116.51,
    y2: 357.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#929495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1116.53,
    y1: 337.92,
    x2: 1116.53,
    y2: 314,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1116.53,
    y1: 334.78,
    x2: 1116.53,
    y2: 317.68,
    gradientTransform: "translate(13.34 -42.61) rotate(2.2)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 217.72,
    y: 275.86,
    width: 1.04,
    height: 11.77,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 217.72,
    y: -10571,
    width: 1.04,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 217.72,
    y: -10571,
    width: 1.04,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 218.24,
    y1: 275.96,
    x2: 218.24,
    y2: 287.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 217.72,
    y: 275.86,
    width: 1.04,
    height: 11.77,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "218.76 287.64 217.72 287.64 217.72 275.86 218.22 275.86 218.76 287.64"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 218.24,
    y1: 275.96,
    x2: 218.24,
    y2: 287.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 228.26,
    y1: 245.79,
    x2: 225.68,
    y2: 245.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#b71c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a51624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#870e19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860e19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 232.72,
    y1: 267.97,
    x2: 219.78,
    y2: 267.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#bb1d2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#b41b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#a61724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#94121e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860e19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 227.18,
    y1: 247.36,
    x2: 227.18,
    y2: 289.93,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 220.9,
    y: 248.97,
    width: 1.26,
    height: 34.99,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 220.9,
    y: -10571,
    width: 1.26,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 220.9,
    y: -10571,
    width: 1.26,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 221.53,
    y1: 249.02,
    x2: 221.53,
    y2: 283.87,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 220.9,
    y: 248.97,
    width: 1.26,
    height: 34.99,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M222.15,248.97h.01v34.99h-1.26v-33.75c0-.69.56-1.25,1.25-1.25Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 221.53,
    y1: 249.02,
    x2: 221.53,
    y2: 283.87,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 229.27,
    y: 248.97,
    width: 2.91,
    height: 34.99,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 229.27,
    y: -10571,
    width: 2.91,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 229.27,
    y: -10571,
    width: 2.91,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 230.72,
    y1: 249.02,
    x2: 230.72,
    y2: 283.87,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 229.27,
    y: 248.97,
    width: 2.91,
    height: 34.99,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M229.58,248.97h1.59c.56,0,1.01.45,1.01,1.01v33.98h-2.91v-34.68c0-.17.14-.31.31-.31Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 230.72,
    y1: 249.02,
    x2: 230.72,
    y2: 283.87,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 233.33,
    y1: 250.81,
    x2: 219.6,
    y2: 250.81,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 226.4,
    y1: 288.27,
    x2: 226.4,
    y2: 289.8,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 233.05,
    y1: 272.19,
    x2: 215.75,
    y2: 272.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#b2b4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a4a6a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#929496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808285"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 682.88,
    y: 289.94,
    width: 191.61,
    height: 21.9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 682.88,
    y: -10571,
    width: 191.61,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 682.88,
    y: -10571,
    width: 191.61,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -2910.88,
    y1: 1829.24,
    x2: -2910.88,
    y2: 1806.64,
    gradientTransform: "translate(3689.57 -1517.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 682.88,
    y: 289.94,
    width: 191.61,
    height: 21.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 682.88,
    y: 289.94,
    width: 191.61,
    height: 21.9,
    transform: "translate(1557.37 601.79) rotate(180)"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -2910.88,
    y1: 1829.24,
    x2: -2910.88,
    y2: 1806.64,
    gradientTransform: "translate(3689.57 -1517.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d3d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#a7a8aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#87888a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#747477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 84.33,
    y: 289.94,
    width: 191.61,
    height: 21.9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 84.33,
    y: -10571,
    width: 191.61,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 84.33,
    y: -10571,
    width: 191.61,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -2312.33,
    x2: -2312.33,
    gradientTransform: "translate(2492.46 -1517.17)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 84.33,
    y: 289.94,
    width: 191.61,
    height: 21.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-184"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 84.33,
    y: 289.94,
    width: 191.61,
    height: 21.9,
    transform: "translate(360.26 601.79) rotate(180)"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -2312.33,
    x2: -2312.33,
    gradientTransform: "translate(2492.46 -1517.17)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 781.54,
    y1: 344.34,
    x2: 781.54,
    y2: 52.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#a4a5aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#9b9ca5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8b8c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#75758f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#59587f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#37346c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262262"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 478.69,
    y1: 32.52,
    x2: 478.69,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#b2b4b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1083.01,
    x2: 1083.01,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-11",
    x: 41.23,
    y: 29.03,
    width: 54.19,
    height: 11.54,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-12",
    x: 41.23,
    y: -10571,
    width: 54.19,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 41.23,
    y: -10571,
    width: 54.19,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 68.33,
    y1: 40.57,
    x2: 68.33,
    y2: 29.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 41.23,
    y: 29.03,
    width: 54.19,
    height: 11.54,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 41.23,
    y: 29.03,
    width: 54.19,
    height: 11.54
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 68.33,
    y1: 40.57,
    x2: 68.33,
    y2: 29.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 780.85,
    y1: 349.98,
    x2: 780.85,
    y2: 21.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9abae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#c3c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#eaeaeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#eaebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 783.75,
    y1: 237.07,
    x2: 783.75,
    y2: 40.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2e2b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-13",
    x: 95.42,
    y: 24.25,
    width: 1405.09,
    height: 9.56,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-14",
    x: 95.42,
    y: -10571,
    width: 1405.09,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 95.42,
    y: -10571,
    width: 1405.09,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 797.97,
    y1: 33.81,
    x2: 797.97,
    y2: 24.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 95.42,
    y: 24.25,
    width: 1405.09,
    height: 9.56,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-137"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1490.96,33.81H104.98c-5.28,0-9.56-4.28-9.56-9.56h1405.09c0,5.28-4.28,9.56-9.56,9.56Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 797.97,
    y1: 33.81,
    x2: 797.97,
    y2: 24.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#efeff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-15",
    x: 77.66,
    y: 48.21,
    width: 1415.22,
    height: 16.37,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-16",
    x: 77.66,
    y: -10571,
    width: 1415.22,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 77.66,
    y: -10571,
    width: 1415.22,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 785.27,
    y1: 64.58,
    x2: 785.27,
    y2: 48.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 77.66,
    y: 48.21,
    width: 1415.22,
    height: 16.37,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1492.88,64.58H77.66l2.67-7.85c1.73-5.09,6.51-8.52,11.89-8.52h1384.3c9.04,0,16.37,7.33,16.37,16.37h0Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 785.27,
    y1: 64.58,
    x2: 785.27,
    y2: 48.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1429.72,
    y1: 327.95,
    x2: 1429.72,
    y2: 317.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1417.17,
    y1: 320.51,
    x2: 1417.17,
    y2: 325.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1441.3,
    x2: 1441.3,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1429.24,
    y1: 321.12,
    x2: 1429.24,
    y2: 324.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 31.28,
    y1: 301.37,
    x2: 31.28,
    y2: 323.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 274.15,
    y1: 300.47,
    x2: 274.15,
    y2: 307.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 457.26,
    x2: 457.26,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1024.43,
    x2: 1024.43,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1207.19,
    x2: 1207.19,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 457.26,
    y1: 41.31,
    x2: 457.26,
    y2: 48.5,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1207.19,
    y1: 41.31,
    x2: 1207.19,
    y2: 48.5,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1533.52,
    y1: 301.76,
    x2: 1533.52,
    y2: 252.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    y1: 285.2,
    y2: 268.68,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1534.64,
    y1: 285.55,
    x2: 1534.64,
    y2: 301.57,
    gradientTransform: "translate(3069.28 586.9) rotate(-180)",
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1534.64,
    y1: 252.57,
    x2: 1534.64,
    y2: 268.59,
    gradientTransform: "translate(3069.28 520.93) rotate(-180)",
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -694.52,
    y1: 4969.5,
    x2: -694.52,
    y2: 4984.28,
    gradientTransform: "translate(2229.06 -4699.99)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-17",
    x: 283.46,
    y: 250.13,
    width: 164.85,
    height: 101.9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-18",
    x: 283.46,
    y: -10571,
    width: 164.85,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    x: 283.46,
    y: -10571,
    width: 164.85,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 365.88,
    y1: 352.04,
    x2: 365.88,
    y2: 250.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 283.46,
    y: 250.13,
    width: 164.85,
    height: 101.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M444.77,312.61c-3.35-35.39-34.13-62.48-71-62.48h-15.79c-36.86,0-67.65,27.09-71,62.48l-3.54,37.37,18.03,2.05,2.21-30.08c2.64-33.41,26.9-58.98,55.96-58.98h12.44c29.06,0,53.32,25.57,55.96,58.98l2.21,30.08,18.03-2.05-3.54-37.37Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 365.88,
    y1: 352.04,
    x2: 365.88,
    y2: 250.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-19",
    x: 1033.86,
    y: 250.13,
    width: 164.85,
    height: 101.9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-20",
    x: 1033.86,
    y: -10571,
    width: 164.85,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    x: 1033.86,
    y: -10571,
    width: 164.85,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1116.28,
    x2: 1116.28,
    xlinkHref: "#linear-gradient-53"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    x: 1033.86,
    y: 250.13,
    width: 164.85,
    height: 101.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1195.17,312.61c-3.35-35.39-34.13-62.48-71-62.48h-15.79c-36.86,0-67.65,27.09-71,62.48l-3.54,37.37,18.03,2.05,2.21-30.08c2.64-33.41,26.9-58.98,55.96-58.98h12.44c29.06,0,53.32,25.57,55.96,58.98l2.21,30.08,18.03-2.05-3.54-37.37Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1116.28,
    x2: 1116.28,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 50.75,
    y1: 245.41,
    x2: 50.75,
    y2: 73.6,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-21",
    x: 95.42,
    y: 311.66,
    width: 169.42,
    height: 32.49,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-22",
    x: 95.42,
    y: -10571,
    width: 169.42,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    x: 95.42,
    y: -10571,
    width: 169.42,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -2312.33,
    y1: 1807.64,
    x2: -2312.33,
    y2: 1774.11,
    gradientTransform: "translate(2492.46 -1463.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    x: 95.42,
    y: 311.66,
    width: 169.42,
    height: 32.49,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 95.42,
    y: 311.66,
    width: 169.42,
    height: 32.49,
    transform: "translate(360.26 655.81) rotate(180)"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -2312.33,
    y1: 1807.64,
    x2: -2312.33,
    y2: 1774.11,
    gradientTransform: "translate(2492.46 -1463.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#dededf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#bbbcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#9f9fa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#88898c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#797a7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6f7073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 180.13,
    y1: 344.15,
    x2: 180.13,
    y2: 86.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5d5e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-23",
    x: 111.22,
    y: 112.38,
    width: 54.34,
    height: 62.22,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-24",
    x: 111.22,
    y: -10571,
    width: 54.34,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    x: 111.22,
    y: -10571,
    width: 54.34,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 138.39,
    y1: 174.59,
    x2: 138.39,
    y2: 112.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    x: 111.22,
    y: 112.38,
    width: 54.34,
    height: 62.22,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M131.99,170.34l-9.16,3.64c-5.57,2.21-11.61-1.89-11.61-7.88v-45.25c0-4.68,3.8-8.48,8.48-8.48h37.38c4.68,0,8.48,3.8,8.48,8.48h0c0,21.81-13.3,41.42-33.57,49.48Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 138.39,
    y1: 174.59,
    x2: 138.39,
    y2: 112.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-25",
    x: 195.63,
    y: 112.38,
    width: 54.34,
    height: 62.22,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-26",
    x: 195.63,
    y: -10571,
    width: 54.34,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    x: 195.63,
    y: -10571,
    width: 54.34,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 222.8,
    x2: 222.8,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    x: 195.63,
    y: 112.38,
    width: 54.34,
    height: 62.22,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M216.4,170.34l-9.16,3.64c-5.57,2.21-11.61-1.89-11.61-7.88v-45.25c0-4.68,3.8-8.48,8.48-8.48h37.39c4.68,0,8.48,3.8,8.48,8.48h0c0,21.81-13.3,41.42-33.57,49.48Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 222.8,
    x2: 222.8,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-27",
    x: 693.98,
    y: 311.66,
    width: 169.42,
    height: 32.49,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-28",
    x: 693.98,
    y: -10571,
    width: 169.42,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-27",
    x: 693.98,
    y: -10571,
    width: 169.42,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -2910.88,
    x2: -2910.88,
    gradientTransform: "translate(3689.57 -1463.15)",
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    x: 693.98,
    y: 311.66,
    width: 169.42,
    height: 32.49,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 693.98,
    y: 311.66,
    width: 169.42,
    height: 32.49,
    transform: "translate(1557.37 655.81) rotate(180)"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -2910.88,
    x2: -2910.88,
    gradientTransform: "translate(3689.57 -1463.15)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 778.69,
    x2: 778.69,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-29",
    x: 709.78,
    y: 112.38,
    width: 54.34,
    height: 62.22,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-30",
    x: 709.78,
    y: -10571,
    width: 54.34,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-29",
    x: 709.78,
    y: -10571,
    width: 54.34,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 736.95,
    x2: 736.95,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    x: 709.78,
    y: 112.38,
    width: 54.34,
    height: 62.22,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M730.55,170.34l-9.16,3.64c-5.57,2.21-11.61-1.89-11.61-7.88v-45.25c0-4.68,3.8-8.48,8.48-8.48h37.38c4.68,0,8.48,3.8,8.48,8.48h0c0,21.81-13.3,41.42-33.57,49.48Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 736.95,
    x2: 736.95,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-31",
    x: 794.19,
    y: 112.38,
    width: 54.34,
    height: 62.22,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-32",
    x: 794.19,
    y: -10571,
    width: 54.34,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    x: 794.19,
    y: -10571,
    width: 54.34,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 821.36,
    x2: 821.36,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    x: 794.19,
    y: 112.38,
    width: 54.34,
    height: 62.22,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M814.96,170.34l-9.16,3.64c-5.57,2.21-11.61-1.89-11.61-7.88v-45.25c0-4.68,3.8-8.48,8.48-8.48h37.39c4.68,0,8.48,3.8,8.48,8.48h0c0,21.81-13.3,41.42-33.57,49.48Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 821.36,
    x2: 821.36,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -1673.21,
    y1: 615.73,
    x2: -1666.28,
    y2: 636.14,
    gradientTransform: "translate(1770.69 504.11) rotate(30.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 13.9,
    y1: 109.34,
    x2: 13.9,
    y2: 178.79,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-33",
    x: 300.46,
    y: 77.49,
    width: 170.02,
    height: 50.32,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-34",
    x: 300.46,
    y: -10571,
    width: 170.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-33",
    x: 300.46,
    y: -10571,
    width: 170.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 385.47,
    y1: 127.81,
    x2: 385.47,
    y2: 77.49,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    x: 300.46,
    y: 77.49,
    width: 170.02,
    height: 50.32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M310.58,77.49h159.89c0,27.77-22.55,50.32-50.32,50.32h-119.7v-40.19c0-5.59,4.54-10.13,10.13-10.13Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 385.47,
    y1: 127.81,
    x2: 385.47,
    y2: 77.49,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-35",
    x: 498.7,
    y: 77.49,
    width: 170.02,
    height: 50.32,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-36",
    x: 498.7,
    y: -10571,
    width: 170.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-35",
    x: 498.7,
    y: -10571,
    width: 170.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 583.71,
    y1: 127.81,
    x2: 583.71,
    y2: 77.49,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    x: 498.7,
    y: 77.49,
    width: 170.02,
    height: 50.32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M498.7,77.49h170.02c0,27.77-22.55,50.32-50.32,50.32h-119.7v-50.32h0Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 583.71,
    y1: 127.81,
    x2: 583.71,
    y2: 77.49,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-37",
    x: 890.78,
    y: 77.49,
    width: 170.02,
    height: 50.32,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-38",
    x: 890.78,
    y: -10571,
    width: 170.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-37",
    x: 890.78,
    y: -10571,
    width: 170.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 975.79,
    y1: 127.81,
    x2: 975.79,
    y2: 77.49,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    x: 890.78,
    y: 77.49,
    width: 170.02,
    height: 50.32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M890.78,77.49h170.02c0,27.77-22.55,50.32-50.32,50.32h-119.7v-50.32h0Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 975.79,
    y1: 127.81,
    x2: 975.79,
    y2: 77.49,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-39",
    x: 1086.82,
    y: 77.49,
    width: 170.02,
    height: 50.32,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-40",
    x: 1086.82,
    y: -10571,
    width: 170.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-39",
    x: 1086.82,
    y: -10571,
    width: 170.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 1171.84,
    y1: 127.81,
    x2: 1171.84,
    y2: 77.49,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-38",
    x: 1086.82,
    y: 77.49,
    width: 170.02,
    height: 50.32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1086.82,77.49h170.02c0,27.77-22.55,50.32-50.32,50.32h-119.7v-50.32h0Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1171.84,
    y1: 127.81,
    x2: 1171.84,
    y2: 77.49,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-41",
    x: 1284.86,
    y: 77.49,
    width: 170.02,
    height: 50.32,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-42",
    x: 1284.86,
    y: -10571,
    width: 170.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-41",
    x: 1284.86,
    y: -10571,
    width: 170.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 1369.87,
    y1: 127.81,
    x2: 1369.87,
    y2: 77.49,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    x: 1284.86,
    y: 77.49,
    width: 170.02,
    height: 50.32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1284.86,77.49h170.02c0,27.77-22.55,50.32-50.32,50.32h-119.7v-50.32h0Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1369.87,
    y1: 127.81,
    x2: 1369.87,
    y2: 77.49,
    xlinkHref: "#linear-gradient-62"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M272,292.63v55.35h24.94c6.91-4.53,35.26-7.92,69.19-7.92s62.29,3.39,69.19,7.92h611.76c6.91-4.53,35.26-7.92,69.19-7.92s62.28,3.39,69.19,7.92h87.75v-55.35H272Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M272,256.52v55.35h24.94c6.91-4.53,35.26-7.92,69.19-7.92s62.29,3.39,69.19,7.92h611.76c6.91-4.53,35.26-7.92,69.19-7.92s62.28,3.39,69.19,7.92h87.75v-55.35H272Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M366.13,267.7c-32.25,0-58.39,26.14-58.39,58.39s26.14,58.39,58.39,58.39,58.39-26.14,58.39-58.39-26.14-58.39-58.39-58.39ZM366.13,356.34c-16.71,0-30.25-13.54-30.25-30.25s13.54-30.25,30.25-30.25,30.25,13.54,30.25,30.25-13.54,30.25-30.25,30.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M425.42,327.83v-3.03h-3.73c-.01-.61-.03-1.22-.06-1.82l3.71-.32-.26-3.02-3.7.32c-.07-.61-.14-1.21-.23-1.81l3.67-.65-.53-2.98-3.65.64c-.12-.6-.26-1.19-.4-1.78l3.6-.96-.78-2.92-3.59.96c-.17-.58-.35-1.16-.54-1.74l3.5-1.27-1.04-2.84-3.49,1.27c-.22-.57-.44-1.13-.68-1.69l3.37-1.57-1.28-2.74-3.36,1.57c-.27-.55-.54-1.09-.83-1.62l3.22-1.86-1.51-2.62-3.21,1.85c-.32-.52-.65-1.03-.98-1.53l3.06-2.14-1.74-2.48-3.04,2.13c-.36-.49-.73-.97-1.11-1.44l2.86-2.4-1.95-2.32-2.85,2.39c-.4-.46-.81-.9-1.23-1.35l2.64-2.64-2.14-2.14-2.64,2.64c-.44-.42-.88-.84-1.33-1.24l2.4-2.86-2.32-1.95-2.39,2.85c-.47-.38-.95-.76-1.43-1.13l2.13-3.05-2.48-1.74-2.13,3.04c-.5-.34-1.02-.66-1.53-.98l1.86-3.23-2.62-1.51-1.85,3.21c-.53-.29-1.08-.57-1.62-.84l1.58-3.38-2.74-1.28-1.57,3.36c-.56-.24-1.12-.48-1.68-.7l1.27-3.5-2.84-1.04-1.27,3.49c-.58-.19-1.15-.39-1.73-.56l.96-3.59-2.92-.78-.96,3.59c-.59-.14-1.18-.29-1.78-.41l.65-3.66-2.98-.53-.64,3.65c-.6-.09-1.2-.16-1.81-.23l.33-3.72-3.02-.26-.32,3.71c-.6-.04-1.21-.06-1.82-.08v-3.74h-3.03v3.73c-.61.01-1.22.03-1.82.06l-.32-3.71-3.02.26.32,3.7c-.61.07-1.21.14-1.81.23l-.65-3.67-2.98.53.64,3.65c-.6.12-1.19.26-1.78.4l-.96-3.6-2.92.78.96,3.59c-.58.17-1.16.35-1.74.54l-1.27-3.5-2.84,1.04,1.27,3.49c-.57.22-1.13.44-1.69.68l-1.57-3.37-2.74,1.28,1.57,3.36c-.55.27-1.09.54-1.62.83l-1.86-3.22-2.62,1.51,1.85,3.21c-.52.32-1.03.65-1.53.98l-2.14-3.06-2.48,1.74,2.13,3.04c-.49.36-.97.73-1.44,1.11l-2.4-2.86-2.32,1.95,2.39,2.85c-.46.4-.91.81-1.35,1.23l-2.64-2.64-2.14,2.14,2.64,2.64c-.42.44-.84.88-1.24,1.33l-2.86-2.4-1.95,2.32,2.85,2.39c-.38.47-.76.95-1.13,1.43l-3.05-2.13-1.74,2.48,3.04,2.13c-.34.5-.66,1.02-.98,1.53l-3.23-1.86-1.51,2.62,3.21,1.85c-.29.53-.57,1.08-.84,1.62l-3.38-1.58-1.28,2.74,3.36,1.57c-.24.56-.48,1.12-.7,1.68l-3.5-1.27-1.04,2.85,3.49,1.27c-.19.58-.39,1.15-.56,1.73l-3.59-.96-.78,2.92,3.59.96c-.14.59-.29,1.18-.41,1.78l-3.66-.65-.53,2.98,3.65.64c-.09.6-.16,1.2-.23,1.81l-3.72-.33-.26,3.02,3.71.32c-.04.6-.06,1.21-.08,1.82h-3.74v3.03h3.73c.01.61.03,1.22.06,1.82l-3.71.32.26,3.02,3.7-.32c.07.61.14,1.21.23,1.81l-3.67.65.53,2.98,3.65-.64c.12.6.26,1.19.4,1.78l-3.6.96.78,2.92,3.59-.96c.17.58.35,1.17.54,1.74l-3.5,1.27,1.04,2.85,3.49-1.27c.22.57.44,1.13.68,1.69l-3.37,1.57,1.28,2.74,3.36-1.57c.27.55.54,1.09.83,1.62l-3.22,1.86,1.51,2.62,3.21-1.85c.32.52.65,1.03.98,1.53l-3.06,2.14,1.74,2.48,3.04-2.13c.36.49.73.97,1.11,1.44l-2.86,2.4,1.95,2.32,2.85-2.39c.4.46.81.91,1.23,1.35l-2.64,2.64,2.14,2.14,2.64-2.64c.44.42.88.84,1.33,1.24l-2.4,2.86,2.32,1.95,2.39-2.85c.47.38.95.76,1.43,1.13l-2.13,3.05,2.48,1.74,2.13-3.04c.5.34,1.02.66,1.53.98l-1.86,3.23,2.62,1.51,1.85-3.21c.53.29,1.08.57,1.62.84l-1.58,3.38,2.74,1.28,1.57-3.36c.56.24,1.12.48,1.68.7l-1.27,3.5,2.84,1.04,1.27-3.49c.58.19,1.15.39,1.73.56l-.96,3.59,2.92.78.96-3.59c.59.14,1.18.29,1.78.41l-.65,3.66,2.98.53.64-3.65c.6.09,1.2.16,1.81.23l-.33,3.72,3.02.26.32-3.71c.6.04,1.21.06,1.82.08v3.74h3.03v-3.73c.61-.01,1.22-.03,1.82-.06l.32,3.71,3.02-.26-.32-3.7c.61-.07,1.21-.14,1.81-.23l.65,3.67,2.98-.53-.64-3.65c.6-.12,1.19-.26,1.78-.4l.96,3.6,2.92-.78-.96-3.59c.58-.17,1.16-.35,1.74-.54l1.27,3.5,2.84-1.04-1.27-3.49c.57-.22,1.13-.44,1.69-.68l1.57,3.37,2.74-1.28-1.57-3.36c.54-.27,1.09-.54,1.62-.83l1.86,3.22,2.62-1.51-1.85-3.21c.52-.32,1.03-.65,1.53-.98l2.14,3.06,2.48-1.74-2.13-3.04c.49-.36.97-.73,1.44-1.11l2.4,2.86,2.32-1.95-2.39-2.85c.46-.4.91-.81,1.35-1.23l2.64,2.64,2.14-2.14-2.64-2.64c.42-.44.84-.88,1.24-1.33l2.86,2.4,1.95-2.32-2.85-2.39c.38-.47.76-.95,1.13-1.43l3.05,2.13,1.74-2.48-3.04-2.13c.34-.51.66-1.02.98-1.53l3.23,1.86,1.51-2.62-3.21-1.85c.29-.53.57-1.08.84-1.62l3.38,1.58,1.28-2.74-3.36-1.57c.24-.56.48-1.12.7-1.68l3.5,1.27,1.04-2.84-3.49-1.27c.19-.57.39-1.15.56-1.73l3.59.96.78-2.92-3.59-.96c.14-.59.29-1.18.41-1.78l3.66.65.53-2.98-3.65-.64c.09-.6.16-1.2.23-1.81l3.72.33.26-3.02-3.71-.32c.04-.6.06-1.21.08-1.82h3.74ZM366.13,356.34c-16.71,0-30.25-13.54-30.25-30.25s13.54-30.25,30.25-30.25,30.25,13.54,30.25,30.25-13.54,30.25-30.25,30.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M366.13,273.18c-29.22,0-52.91,23.69-52.91,52.91s23.69,52.91,52.91,52.91,52.91-23.69,52.91-52.91-23.69-52.91-52.91-52.91ZM366.13,356.34c-16.71,0-30.25-13.54-30.25-30.25s13.54-30.25,30.25-30.25,30.25,13.54,30.25,30.25-13.54,30.25-30.25,30.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M398.17,331.38c-.7,1.24-1.62,2.01-2.65,2.01-2.15,0-3.89-3.31-3.89-7.4s1.74-7.4,3.89-7.4c1.01,0,1.92.75,2.61,1.95-.85-4.94-2.8-9.48-5.61-13.39.39,1.37.28,2.58-.45,3.31-1.52,1.52-5.09.41-7.98-2.48-2.89-2.89-4-6.46-2.48-7.98.72-.72,1.9-.83,3.25-.46-3.93-2.78-8.49-4.69-13.44-5.5,1.24.69,2.01,1.62,2.01,2.65,0,2.15-3.31,3.89-7.4,3.89s-7.4-1.74-7.4-3.89c0-1.01.75-1.92,1.95-2.61-4.93.85-9.48,2.8-13.39,5.61,1.37-.39,2.58-.28,3.31.45,1.52,1.52.41,5.09-2.48,7.98-2.89,2.89-6.46,4-7.98,2.48-.72-.72-.83-1.9-.46-3.25-2.78,3.93-4.69,8.49-5.5,13.44.7-1.24,1.62-2.01,2.65-2.01,2.15,0,3.89,3.31,3.89,7.4s-1.74,7.4-3.89,7.4c-1.01,0-1.92-.75-2.61-1.96.85,4.94,2.8,9.48,5.61,13.39-.39-1.37-.28-2.58.45-3.31,1.52-1.52,5.09-.41,7.98,2.48,2.89,2.89,4,6.46,2.48,7.98-.72.72-1.9.83-3.25.46,3.93,2.78,8.49,4.69,13.44,5.5-1.24-.69-2.01-1.62-2.01-2.65,0-2.15,3.31-3.89,7.4-3.89s7.4,1.74,7.4,3.89c0,1.01-.75,1.92-1.95,2.62,4.94-.85,9.48-2.8,13.39-5.61-1.37.39-2.58.28-3.31-.45-1.52-1.52-.41-5.09,2.48-7.98,2.89-2.89,6.46-4,7.98-2.48.72.72.83,1.9.46,3.25,2.78-3.93,4.69-8.49,5.5-13.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-107",
    cx: 366.13,
    cy: 326.09,
    r: 19.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M366.13,293.55c-17.97,0-32.54,14.57-32.54,32.54s14.57,32.54,32.54,32.54,32.54-14.57,32.54-32.54-14.57-32.54-32.54-32.54ZM366.13,356.67c-16.89,0-30.58-13.69-30.58-30.58s13.69-30.58,30.58-30.58,30.58,13.69,30.58,30.58-13.69,30.58-30.58,30.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M366.13,289.17c-20.39,0-36.92,16.53-36.92,36.93s16.53,36.93,36.92,36.93,36.92-16.53,36.92-36.93-16.53-36.93-36.92-36.93ZM366.13,358.13c-17.7,0-32.04-14.35-32.04-32.04s14.35-32.04,32.04-32.04,32.04,14.35,32.04,32.04-14.34,32.04-32.04,32.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M398.17,331.38c-.7,1.24-1.62,2.01-2.65,2.01-2.15,0-3.89-3.31-3.89-7.4s1.74-7.4,3.89-7.4c1.01,0,1.92.75,2.61,1.95-.85-4.94-2.8-9.48-5.61-13.39.39,1.37.28,2.58-.45,3.31-1.52,1.52-5.09.41-7.98-2.48-2.89-2.89-4-6.46-2.48-7.98.72-.72,1.9-.83,3.25-.46-3.93-2.78-8.49-4.69-13.44-5.5,1.24.69,2.01,1.62,2.01,2.65,0,2.15-3.31,3.89-7.4,3.89s-7.4-1.74-7.4-3.89c0-1.01.75-1.92,1.95-2.61-4.93.85-9.48,2.8-13.39,5.61,1.37-.39,2.58-.28,3.31.45,1.52,1.52.41,5.09-2.48,7.98-2.89,2.89-6.46,4-7.98,2.48-.72-.72-.83-1.9-.46-3.25-2.78,3.93-4.69,8.49-5.5,13.44.7-1.24,1.62-2.01,2.65-2.01,2.15,0,3.89,3.31,3.89,7.4s-1.74,7.4-3.89,7.4c-1.01,0-1.92-.75-2.61-1.96.85,4.94,2.8,9.48,5.61,13.39-.39-1.37-.28-2.58.45-3.31,1.52-1.52,5.09-.41,7.98,2.48,2.89,2.89,4,6.46,2.48,7.98-.72.72-1.9.83-3.25.46,3.93,2.78,8.49,4.69,13.44,5.5-1.24-.69-2.01-1.62-2.01-2.65,0-2.15,3.31-3.89,7.4-3.89s7.4,1.74,7.4,3.89c0,1.01-.75,1.92-1.95,2.62,4.94-.85,9.48-2.8,13.39-5.61-1.37.39-2.58.28-3.31-.45-1.52-1.52-.41-5.09,2.48-7.98,2.89-2.89,6.46-4,7.98-2.48.72.72.83,1.9.46,3.25,2.78-3.93,4.69-8.49,5.5-13.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M366.13,292.63c-18.48,0-33.46,14.98-33.46,33.46s14.98,33.46,33.46,33.46,33.46-14.98,33.46-33.46-14.98-33.46-33.46-33.46ZM366.13,357.54c-17.37,0-31.44-14.08-31.44-31.45s14.08-31.45,31.44-31.45,31.44,14.08,31.44,31.45-14.08,31.45-31.44,31.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-106",
    cx: 366.13,
    cy: 326.09,
    r: 12.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "367.72 339.66 365.04 339.66 363.7 341.98 365.04 344.3 367.72 344.3 369.06 341.98 367.72 339.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M367.7,341.98c0,.73-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31.59-1.31,1.31-1.31,1.31.59,1.31,1.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "376.85 334.56 374.95 336.46 375.65 339.05 378.24 339.74 380.13 337.84 379.44 335.26 376.85 334.56"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-91",
    cx: 377.54,
    cy: 337.15,
    r: 1.31
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "379.7 324.5 379.7 327.18 382.02 328.52 384.34 327.18 384.34 324.5 382.02 323.16 379.7 324.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M382.02,324.53c.73,0,1.31.59,1.31,1.31s-.59,1.31-1.31,1.31-1.31-.59-1.31-1.31.59-1.31,1.31-1.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "374.6 315.38 376.5 317.27 379.08 316.58 379.78 313.99 377.88 312.09 375.29 312.79 374.6 315.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M376.26,313.75c.51-.51,1.35-.51,1.86,0,.51.51.51,1.35,0,1.86-.51.51-1.35.51-1.86,0-.51-.51-.51-1.35,0-1.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "364.54 312.53 367.22 312.53 368.56 310.21 367.22 307.88 364.54 307.88 363.2 310.21 364.54 312.53"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-91",
    cx: 365.88,
    cy: 310.21,
    r: 1.31
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "355.42 317.62 357.31 315.73 356.62 313.14 354.03 312.45 352.13 314.34 352.83 316.93 355.42 317.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M353.79,315.96c-.51-.51-.51-1.35,0-1.86.51-.51,1.35-.51,1.86,0,.51.51.51,1.35,0,1.86-.51.51-1.35.51-1.86,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "352.57 327.68 352.57 325 350.24 323.66 347.92 325 347.92 327.68 350.24 329.02 352.57 327.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M350.24,327.66c-.73,0-1.31-.59-1.31-1.31s.59-1.31,1.31-1.31,1.31.59,1.31,1.31-.59,1.31-1.31,1.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "357.66 336.81 355.77 334.91 353.18 335.61 352.49 338.2 354.38 340.09 356.97 339.4 357.66 336.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M356,338.43c-.51.51-1.35.51-1.86,0-.51-.51-.51-1.35,0-1.86.51-.51,1.35-.51,1.86,0,.51.51.51,1.35,0,1.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-112",
    cx: 366.13,
    cy: 326.09,
    r: 8.54,
    transform: "translate(-13.23 15.49) rotate(-2.38)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-96",
    cx: 1116.69,
    cy: 326.09,
    r: 25.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1116.53,267.7c-32.25,0-58.39,26.14-58.39,58.39s26.14,58.39,58.39,58.39,58.39-26.14,58.39-58.39-26.14-58.39-58.39-58.39ZM1116.53,356.34c-16.71,0-30.25-13.54-30.25-30.25s13.54-30.25,30.25-30.25,30.25,13.54,30.25,30.25-13.54,30.25-30.25,30.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1175.82,327.83v-3.03h-3.73c-.01-.61-.03-1.22-.06-1.82l3.71-.32-.26-3.02-3.7.32c-.07-.61-.14-1.21-.23-1.81l3.67-.65-.53-2.98-3.65.64c-.12-.6-.26-1.19-.4-1.78l3.6-.96-.78-2.92-3.59.96c-.17-.58-.35-1.16-.54-1.74l3.5-1.27-1.04-2.84-3.49,1.27c-.22-.57-.44-1.13-.68-1.69l3.37-1.57-1.28-2.74-3.36,1.57c-.27-.55-.54-1.09-.83-1.62l3.22-1.86-1.51-2.62-3.21,1.85c-.32-.52-.65-1.03-.98-1.53l3.06-2.14-1.74-2.48-3.04,2.13c-.36-.49-.73-.97-1.11-1.44l2.86-2.4-1.95-2.32-2.85,2.39c-.4-.46-.81-.9-1.23-1.35l2.64-2.64-2.14-2.14-2.64,2.64c-.44-.42-.88-.84-1.33-1.24l2.4-2.86-2.32-1.95-2.39,2.85c-.47-.38-.95-.76-1.43-1.13l2.13-3.05-2.48-1.74-2.13,3.04c-.5-.34-1.02-.66-1.53-.98l1.86-3.23-2.62-1.51-1.85,3.21c-.53-.29-1.08-.57-1.62-.84l1.58-3.38-2.74-1.28-1.57,3.36c-.56-.24-1.12-.48-1.68-.7l1.27-3.5-2.84-1.04-1.27,3.49c-.58-.19-1.15-.39-1.73-.56l.96-3.59-2.92-.78-.96,3.59c-.59-.14-1.18-.29-1.78-.41l.65-3.66-2.98-.53-.64,3.65c-.6-.09-1.2-.16-1.81-.23l.33-3.72-3.02-.26-.32,3.71c-.6-.04-1.21-.06-1.82-.08v-3.74h-3.03v3.73c-.61.01-1.22.03-1.82.06l-.33-3.71-3.02.26.32,3.7c-.61.07-1.21.14-1.81.23l-.65-3.67-2.98.53.64,3.65c-.6.12-1.19.26-1.78.4l-.96-3.6-2.92.78.96,3.59c-.58.17-1.17.35-1.74.54l-1.27-3.5-2.84,1.04,1.27,3.49c-.57.22-1.13.44-1.69.68l-1.57-3.37-2.74,1.28,1.57,3.36c-.55.27-1.09.54-1.62.83l-1.86-3.22-2.62,1.51,1.85,3.21c-.52.32-1.03.65-1.53.98l-2.14-3.06-2.48,1.74,2.13,3.04c-.49.36-.97.73-1.44,1.11l-2.4-2.86-2.32,1.95,2.39,2.85c-.46.4-.91.81-1.35,1.23l-2.64-2.64-2.14,2.14,2.64,2.64c-.42.44-.84.88-1.24,1.33l-2.86-2.4-1.95,2.32,2.85,2.39c-.38.47-.76.95-1.13,1.43l-3.05-2.13-1.74,2.48,3.04,2.13c-.34.5-.66,1.02-.98,1.53l-3.23-1.86-1.51,2.62,3.21,1.85c-.29.53-.57,1.08-.84,1.62l-3.38-1.58-1.28,2.74,3.36,1.57c-.24.56-.48,1.12-.7,1.68l-3.5-1.27-1.04,2.85,3.49,1.27c-.19.58-.39,1.15-.56,1.73l-3.59-.96-.78,2.92,3.59.96c-.14.59-.29,1.18-.41,1.78l-3.66-.65-.53,2.98,3.65.64c-.09.6-.16,1.2-.23,1.81l-3.72-.33-.26,3.02,3.71.32c-.04.6-.06,1.21-.08,1.82h-3.74v3.03h3.73c.01.61.03,1.22.06,1.82l-3.71.32.26,3.02,3.7-.32c.07.61.14,1.21.23,1.81l-3.67.65.53,2.98,3.65-.64c.12.6.26,1.19.4,1.78l-3.6.96.78,2.92,3.59-.96c.17.58.35,1.17.54,1.74l-3.5,1.27,1.04,2.85,3.49-1.27c.22.57.44,1.13.68,1.69l-3.37,1.57,1.28,2.74,3.36-1.57c.27.55.54,1.09.83,1.62l-3.22,1.86,1.51,2.62,3.21-1.85c.32.52.65,1.03.98,1.53l-3.06,2.14,1.74,2.48,3.04-2.13c.36.49.73.97,1.11,1.44l-2.86,2.4,1.95,2.32,2.85-2.39c.4.46.81.91,1.23,1.35l-2.64,2.64,2.14,2.14,2.64-2.64c.44.42.88.84,1.33,1.24l-2.4,2.86,2.32,1.95,2.39-2.85c.47.38.95.76,1.43,1.13l-2.13,3.05,2.48,1.74,2.13-3.04c.51.34,1.02.66,1.53.98l-1.86,3.23,2.62,1.51,1.85-3.21c.53.29,1.08.57,1.62.84l-1.58,3.38,2.74,1.28,1.57-3.36c.56.24,1.12.48,1.68.7l-1.27,3.5,2.85,1.04,1.27-3.49c.58.19,1.15.39,1.73.56l-.96,3.59,2.92.78.96-3.59c.59.14,1.18.29,1.78.41l-.65,3.66,2.98.53.64-3.65c.6.09,1.2.16,1.81.23l-.33,3.72,3.02.26.32-3.71c.6.04,1.21.06,1.82.08v3.74h3.03v-3.73c.61-.01,1.22-.03,1.82-.06l.32,3.71,3.02-.26-.32-3.7c.61-.07,1.21-.14,1.81-.23l.65,3.67,2.98-.53-.64-3.65c.6-.12,1.19-.26,1.78-.4l.96,3.6,2.92-.78-.96-3.59c.58-.17,1.17-.35,1.74-.54l1.27,3.5,2.84-1.04-1.27-3.49c.57-.22,1.13-.44,1.69-.68l1.57,3.37,2.74-1.28-1.57-3.36c.54-.27,1.09-.54,1.62-.83l1.86,3.22,2.62-1.51-1.85-3.21c.52-.32,1.03-.65,1.53-.98l2.14,3.06,2.48-1.74-2.13-3.04c.49-.36.97-.73,1.44-1.11l2.4,2.86,2.32-1.95-2.39-2.85c.46-.4.91-.81,1.35-1.23l2.64,2.64,2.14-2.14-2.64-2.64c.42-.44.84-.88,1.24-1.33l2.86,2.4,1.95-2.32-2.85-2.39c.38-.47.76-.95,1.13-1.43l3.05,2.13,1.74-2.48-3.04-2.13c.34-.51.66-1.02.98-1.53l3.23,1.86,1.51-2.62-3.21-1.85c.29-.53.57-1.08.84-1.62l3.38,1.58,1.28-2.74-3.36-1.57c.24-.56.48-1.12.7-1.68l3.5,1.27,1.04-2.84-3.49-1.27c.19-.57.39-1.15.56-1.73l3.59.96.78-2.92-3.59-.96c.14-.59.29-1.18.41-1.78l3.66.65.53-2.98-3.65-.64c.09-.6.16-1.2.23-1.81l3.72.33.26-3.02-3.71-.32c.04-.6.06-1.21.08-1.82h3.74ZM1116.53,356.34c-16.71,0-30.25-13.54-30.25-30.25s13.54-30.25,30.25-30.25,30.25,13.54,30.25,30.25-13.54,30.25-30.25,30.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1116.53,273.18c-29.22,0-52.91,23.69-52.91,52.91s23.69,52.91,52.91,52.91,52.91-23.69,52.91-52.91-23.69-52.91-52.91-52.91ZM1116.53,356.34c-16.71,0-30.25-13.54-30.25-30.25s13.54-30.25,30.25-30.25,30.25,13.54,30.25,30.25-13.54,30.25-30.25,30.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M1116.53,289.17c-20.39,0-36.92,16.53-36.92,36.93s16.53,36.93,36.92,36.93,36.92-16.53,36.92-36.93-16.53-36.93-36.92-36.93ZM1116.53,358.13c-17.7,0-32.04-14.35-32.04-32.04s14.34-32.04,32.04-32.04,32.04,14.35,32.04,32.04-14.34,32.04-32.04,32.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1116.53,292.63c-18.48,0-33.46,14.98-33.46,33.46s14.98,33.46,33.46,33.46,33.46-14.98,33.46-33.46-14.98-33.46-33.46-33.46ZM1116.53,356.99c-17.06,0-30.9-13.83-30.9-30.9s13.83-30.9,30.9-30.9,30.9,13.83,30.9,30.9-13.83,30.9-30.9,30.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1116.51,293.66c-17.92,0-32.45,14.53-32.45,32.45s14.53,32.45,32.45,32.45,32.45-14.53,32.45-32.45-14.53-32.45-32.45-32.45ZM1095.46,305.18c2.58-2.58,5.77-3.57,7.12-2.21,1.35,1.35.36,4.54-2.21,7.12-2.58,2.58-5.76,3.57-7.12,2.21-1.35-1.35-.36-4.54,2.21-7.12ZM1090.3,332.8c-1.92,0-3.47-2.95-3.47-6.6s1.55-6.6,3.47-6.6,3.47,2.95,3.47,6.6-1.55,6.6-3.47,6.6ZM1102.7,349.38c-1.36,1.35-4.54.36-7.12-2.21-2.58-2.58-3.57-5.77-2.21-7.12,1.35-1.35,4.54-.36,7.12,2.21,2.58,2.58,3.57,5.77,2.21,7.12ZM1116.43,296.43c3.65,0,6.6,1.55,6.6,3.47s-2.95,3.47-6.6,3.47-6.6-1.55-6.6-3.47,2.96-3.47,6.6-3.47ZM1116.6,355.8c-3.64,0-6.6-1.55-6.6-3.47s2.96-3.47,6.6-3.47,6.6,1.55,6.6,3.47-2.95,3.47-6.6,3.47ZM1130.32,302.85c1.35-1.35,4.54-.36,7.12,2.21,2.58,2.58,3.57,5.77,2.21,7.12-1.36,1.35-4.54.36-7.12-2.21-2.58-2.58-3.57-5.76-2.21-7.12ZM1137.56,347.04c-2.58,2.58-5.76,3.57-7.12,2.21-1.35-1.35-.36-4.54,2.21-7.12,2.58-2.58,5.77-3.57,7.12-2.21,1.35,1.35.36,4.54-2.21,7.12ZM1142.73,332.63c-1.92,0-3.47-2.95-3.47-6.6s1.55-6.6,3.47-6.6,3.47,2.95,3.47,6.6-1.55,6.6-3.47,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1148.65,321.87c-2.08-15.91-15.66-28.21-32.14-28.21s-30.06,12.3-32.14,28.21c.66,2.2,1.53,4.31,2.63,6.28-.1-.62-.17-1.27-.17-1.96,0-3.65,1.55-6.6,3.47-6.6s3.47,2.95,3.47,6.6-1.55,6.6-3.47,6.6c-.05,0-.09-.02-.14-.03,6.12,7.53,15.64,12.39,26.35,12.39s20.39-4.95,26.51-12.59c-.1.02-.19.06-.29.06-1.92,0-3.47-2.95-3.47-6.6s1.55-6.6,3.47-6.6,3.47,2.95,3.47,6.6c0,.78-.08,1.51-.21,2.21,1.12-2,2.01-4.14,2.67-6.36ZM1100.37,310.09c-2.58,2.58-5.76,3.57-7.12,2.21-1.35-1.35-.36-4.54,2.21-7.12,2.58-2.58,5.76-3.57,7.12-2.21,1.35,1.35.36,4.54-2.21,7.12ZM1116.43,303.37c-3.64,0-6.6-1.55-6.6-3.47s2.96-3.47,6.6-3.47,6.6,1.55,6.6,3.47-2.95,3.47-6.6,3.47ZM1139.66,312.18c-1.36,1.35-4.54.36-7.12-2.21-2.58-2.58-3.57-5.76-2.21-7.12,1.35-1.35,4.54-.36,7.12,2.21,2.58,2.58,3.57,5.77,2.21,7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M1093.92,312.72c-.25-.1-.48-.23-.67-.42-1.35-1.35-.36-4.54,2.21-7.12,2.58-2.58,5.76-3.57,7.12-2.21,1.1,1.1.64,3.4-.94,5.6,4.6-1.86,9.62-2.89,14.89-2.89s10.21,1.02,14.79,2.85c-1.62-2.23-2.11-4.57-1-5.68,1.35-1.35,4.54-.36,7.12,2.21,2.58,2.58,3.57,5.77,2.21,7.12-.19.19-.42.32-.68.42,3.72,2.54,6.99,5.7,9.65,9.32,0-.02.01-.04.02-.05-2.08-15.91-15.66-28.21-32.14-28.21s-30.06,12.3-32.14,28.21c0,.03.02.06.03.09,2.63-3.58,5.85-6.71,9.52-9.24ZM1116.43,296.43c3.65,0,6.6,1.55,6.6,3.47s-2.95,3.47-6.6,3.47-6.6-1.55-6.6-3.47,2.96-3.47,6.6-3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1116.51,293.66c-17.92,0-32.45,14.53-32.45,32.45s14.53,32.45,32.45,32.45,32.45-14.53,32.45-32.45-14.53-32.45-32.45-32.45ZM1095.46,305.18c2.58-2.58,5.77-3.57,7.12-2.21,1.35,1.35.36,4.54-2.21,7.12-2.58,2.58-5.76,3.57-7.12,2.21-1.35-1.35-.36-4.54,2.21-7.12ZM1090.3,332.8c-1.92,0-3.47-2.95-3.47-6.6s1.55-6.6,3.47-6.6,3.47,2.95,3.47,6.6-1.55,6.6-3.47,6.6ZM1102.7,349.38c-1.36,1.35-4.54.36-7.12-2.21-2.58-2.58-3.57-5.77-2.21-7.12,1.35-1.35,4.54-.36,7.12,2.21,2.58,2.58,3.57,5.77,2.21,7.12ZM1116.43,296.43c3.65,0,6.6,1.55,6.6,3.47s-2.95,3.47-6.6,3.47-6.6-1.55-6.6-3.47,2.96-3.47,6.6-3.47ZM1116.6,355.8c-3.64,0-6.6-1.55-6.6-3.47s2.96-3.47,6.6-3.47,6.6,1.55,6.6,3.47-2.95,3.47-6.6,3.47ZM1130.32,302.85c1.35-1.35,4.54-.36,7.12,2.21,2.58,2.58,3.57,5.77,2.21,7.12-1.36,1.35-4.54.36-7.12-2.21-2.58-2.58-3.57-5.76-2.21-7.12ZM1137.56,347.04c-2.58,2.58-5.76,3.57-7.12,2.21-1.35-1.35-.36-4.54,2.21-7.12,2.58-2.58,5.77-3.57,7.12-2.21,1.35,1.35.36,4.54-2.21,7.12ZM1142.73,332.63c-1.92,0-3.47-2.95-3.47-6.6s1.55-6.6,3.47-6.6,3.47,2.95,3.47,6.6-1.55,6.6-3.47,6.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "1118.12 339.66 1115.44 339.66 1114.1 341.98 1115.44 344.3 1118.12 344.3 1119.46 341.98 1118.12 339.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1118.1,341.98c0,.73-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31.59-1.31,1.31-1.31,1.31.59,1.31,1.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "1127.25 334.56 1125.35 336.46 1126.05 339.05 1128.64 339.74 1130.53 337.84 1129.84 335.26 1127.25 334.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1128.87,336.22c.51.51.51,1.35,0,1.86-.51.51-1.35.51-1.86,0-.51-.51-.51-1.35,0-1.86.51-.51,1.35-.51,1.86,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "1130.1 324.5 1130.1 327.18 1132.42 328.52 1134.74 327.18 1134.74 324.5 1132.42 323.16 1130.1 324.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1132.42,324.53c.73,0,1.31.59,1.31,1.31s-.59,1.31-1.31,1.31-1.31-.59-1.31-1.31.59-1.31,1.31-1.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "1125 315.38 1126.9 317.27 1129.49 316.58 1130.18 313.99 1128.28 312.09 1125.7 312.79 1125 315.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1126.66,313.75c.51-.51,1.35-.51,1.86,0,.51.51.51,1.35,0,1.86-.51.51-1.35.51-1.86,0-.51-.51-.51-1.35,0-1.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "1114.94 312.53 1117.62 312.53 1118.96 310.21 1117.62 307.88 1114.94 307.88 1113.6 310.21 1114.94 312.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1114.97,310.21c0-.73.59-1.31,1.31-1.31s1.31.59,1.31,1.31-.59,1.31-1.31,1.31-1.31-.59-1.31-1.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "1105.82 317.62 1107.71 315.73 1107.02 313.14 1104.43 312.45 1102.53 314.34 1103.23 316.93 1105.82 317.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1104.19,315.96c-.51-.51-.51-1.35,0-1.86.51-.51,1.35-.51,1.86,0,.51.51.51,1.35,0,1.86s-1.35.51-1.86,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "1102.97 327.68 1102.97 325 1100.65 323.66 1098.33 325 1098.33 327.68 1100.65 329.02 1102.97 327.68"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-91",
    cx: 1100.65,
    cy: 326.34,
    r: 1.31
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "1108.06 336.81 1106.17 334.91 1103.58 335.61 1102.89 338.2 1104.78 340.09 1107.37 339.4 1108.06 336.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1106.4,338.43c-.51.51-1.35.51-1.86,0-.51-.51-.51-1.35,0-1.86.51-.51,1.35-.51,1.86,0,.51.51.51,1.35,0,1.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-109",
    cx: 1116.53,
    cy: 326.09,
    r: 12.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-110",
    cx: 1116.53,
    cy: 326.09,
    r: 8.47,
    transform: "translate(-11.69 43.09) rotate(-2.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M1484.54,75.85c0-13.03-11.35-23.59-25.36-23.59H106.91c-9.43,0-17.41,11.4-23.95,31.5,5.55,2.42,9.4,7.65,9.4,13.73v114.08c0,7.64-3.42,14.52-8.9,19.43h10.75c3.81,34.79,12.17,103.47,12.17,103.47l3.42,2.68h168.99l16.33-76.52h135.88l30.17,76.52h398.81l126.21-76.52h498.37v-29.62h0V75.85ZM120.46,222.54v-73.74h43.24v73.74h-43.24ZM165.66,222.54v-73.74h40.05v73.74h-40.05ZM232.28,223.31v-81.73h54.74v53.03c0,15.85-13.81,28.7-30.85,28.7h-23.89ZM1265.79,77.62h162.5c9.4,0,17.02,7.09,17.02,15.83v75.96c0,8.74-7.62,15.83-17.02,15.83h-162.5v-107.62ZM1073.54,77.62h179.52v107.62h-84.47c-30.25,0-60.33,4.13-89.29,12.24l-5.76,1.62v-121.48ZM882.07,77.62h178.74v124.87c-25.31,6.23-51.39,9.39-77.6,9.39h-101.14V77.62ZM688.94,77.62h180.4v134.26h-180.4V77.62ZM496.79,77.62h179.42v134.26h-159.6c-6.62,0-13.23-.21-19.83-.62V77.62ZM304.54,93.45c0-8.74,7.62-15.83,17.02-15.83h162.5v132.63c-18.61-1.87-37.02-5.33-54.99-10.37l-8.54-2.4c-28.96-8.12-59.04-12.24-89.29-12.24h-9.68c-9.4,0-17.02-7.09-17.02-15.83v-75.96ZM113.49,102.57c0-13.78,12.01-24.95,26.82-24.95h146.71v51.1H113.49v-26.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M217.35,279.11c-.45,0-.81-.36-.81-.81,0-7.92-.95-12.31-1.79-16.18-.67-3.11-1.31-6.06-1.31-10.24,0-7.38,3.69-11.25,7.33-11.25h3.75c.45,0,.81.36.81.81s-.36.81-.81.81h-3.75c-2.84,0-5.72,3.31-5.72,9.63,0,4.01.59,6.74,1.27,9.9.85,3.95,1.82,8.43,1.82,16.52,0,.45-.36.81-.81.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M217.35,278.64c-.19,0-.34-.15-.34-.34,0-7.97-.95-12.38-1.8-16.28-.67-3.09-1.3-6.01-1.3-10.14,0-7.08,3.45-10.78,6.86-10.78h3.75c.19,0,.34.15.34.34s-.15.34-.34.34h-3.75c-3.08,0-6.19,3.47-6.19,10.1,0,4.06.59,6.81,1.28,10,.85,3.93,1.81,8.39,1.81,16.42,0,.19-.15.34-.34.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M217.35,278.37s-.07-.03-.07-.07c0-7.99-.96-12.43-1.8-16.34-.69-3.21-1.29-5.98-1.29-10.08,0-6.9,3.32-10.51,6.59-10.51h3.75s.07.03.07.07-.03.07-.07.07h-3.75c-3.21,0-6.46,3.56-6.46,10.37,0,4.09.6,6.85,1.29,10.06.85,3.92,1.81,8.36,1.81,16.37,0,.04-.03.07-.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M216.16,273.44h2.12v2.04c0,.28-.23.51-.51.51h-1.09c-.28,0-.51-.23-.51-.51v-2.04h0Z",
    transform: "translate(434.44 549.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "215.88 275.47 216.46 275.47 217.99 275.47 218.57 275.47 219.51 288.26 217.99 288.26 216.46 288.26 214.93 288.26 215.88 275.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "218.76 287.64 217.72 287.64 217.72 275.86 218.22 275.86 218.76 287.64"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 221.91,
    y: 240.12,
    width: 4.4,
    height: 2.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 221.91,
    y: 241.96,
    width: 4.4,
    height: 0.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 221.91,
    y: 241.86,
    width: 4.4,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 221.91,
    y: 240.34,
    width: 4.4,
    height: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M223.24,240.93c0,.68.27,1.3.7,1.76h1.81v-2.57h-2.37c-.08.25-.13.52-.13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M233.66,238.18l-4.88-.27c-.17,0-.32-.12-.38-.28l-.09-.25c-.17-.45-.6-.75-1.08-.75h-1.72c-.39,0-.71.32-.71.71v1.71h9.02c.21,0,.43.03.63.09l2.2.65h0c0-.22-.12-.42-.32-.51l-1.81-.89c-.27-.13-.55-.21-.85-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228.28,237.85l.09-.31-.06-.16c-.17-.45-.6-.75-1.08-.75h-1.72c-.39,0-.71.32-.71.71v1.28h2.41c.49,0,.92-.32,1.07-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M231.73,234.23l-6.41,1.8c-.31.09-.52.37-.52.69v1.62h2.41c.49,0,.92-.32,1.07-.79l.16-.5c.05-.15.15-.27.28-.34l2.98-1.59c.18-.09.37-.15.57-.17l3.11-.25h0c0-.18-.14-.34-.33-.35l-2.83-.18c-.16-.01-.33,0-.49.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M227.78,237.14c0,.2-.16.36-.36.36s-.36-.16-.36-.36.16-.36.36-.36.36.16.36.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M227.48,237.29h0c-.13.06-.29,0-.35-.12l-1.74-3.6c-.06-.13,0-.29.12-.35h0c.13-.06.29,0,.35.12l1.74,3.6c.06.13,0,.29-.12.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 224.5,
    y: 243.5,
    width: 3.76,
    height: 4.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 224.5,
    y: 243.5,
    width: 1.34,
    height: 4.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M225.99,242.17h.78c.94,0,1.7.76,1.7,1.7v.83h-4.17v-.83c0-.94.76-1.7,1.7-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M232.87,289.84h-12.99v-39.77c0-3.15,2.55-3.97,5.7-3.97h1.59c3.15,0,5.7.82,5.7,3.97v39.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M232.87,289.84h-11.39v-39.77c0-3.15,2.55-3.97,5.7-3.97h0c3.15,0,5.7.82,5.7,3.97v39.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M222.15,248.97h.01v34.99h-1.26v-33.75c0-.69.56-1.25,1.25-1.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.58,248.97h1.59c.56,0,1.01.45,1.01,1.01v33.98h-2.91v-34.68c0-.17.14-.31.31-.31Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 219.89,
    y: 250.81,
    width: 12.99,
    height: 1.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M232.97,251.26h-13.14c-.25,0-.45-.2-.45-.45h0c0-.25.2-.45.45-.45h13.14c.25,0,.45.2.45.45h0c0,.25-.2.45-.45.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M219.88,288.27h13.04c.28,0,.5.23.5.5v1.07h-14.04v-1.07c0-.28.23-.5.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M228.95,240.93c0,1.42-1.15,2.57-2.57,2.57s-2.57-1.15-2.57-2.57,1.15-2.57,2.57-2.57,2.57,1.15,2.57,2.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 226.38,
    cy: 240.93,
    r: 2.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M227.02,241.15c0,.44-.36.81-.81.81s-.81-.36-.81-.81.36-.81.81-.81.81.36.81.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M226.38,240.93l.89-1.81c-.27-.13-.57-.21-.89-.21s-.62.08-.89.21l.89,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M226.38,239.05l-.23,1.37c.07.1.15.16.23.16s.16-.06.23-.16l-.23-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M226.38,238.9c-1.03,0-1.88.77-2,1.77.21-.75.89-1.31,1.71-1.31.98,0,1.78.8,1.78,1.78s-.78,1.76-1.75,1.78c.09.01.18.02.27.02,1.12,0,2.02-.9,2.02-2.02s-.9-2.02-2.02-2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M227.18,240.93c0,.44-.36.81-.81.81s-.81-.36-.81-.81.36-.81.81-.81.81.36.81.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M225.16,239.15l1.85,3.8c-.22.07-.45.12-.69.12,0,0-.02,0-.03,0l-1.67-3.42c.15-.19.33-.36.53-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M224.52,239.8l1.58,3.25c-.12-.01-.24-.04-.36-.07l-1.39-2.85c.05-.11.1-.22.17-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M224.31,240.26l1.31,2.68c-.15-.05-.29-.12-.43-.21l-.98-2.01c.02-.16.05-.31.1-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M226.38,238.7c-1.23,0-2.22,1-2.22,2.22s1,2.22,2.22,2.22,2.22-1,2.22-2.22-1-2.22-2.22-2.22ZM226.38,242.95c-1.12,0-2.02-.9-2.02-2.02s.9-2.02,2.02-2.02,2.02.9,2.02,2.02-.9,2.02-2.02,2.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 219.89,
    y: 272.48,
    width: 12.99,
    height: 1.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 215.88,
    y: 271.26,
    width: 17.54,
    height: 1.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M207.91,204.36c1.12-1.37,1.71-3.18,1.48-5.06l-1.58-12.69c-.46-3.67-3.83-6.29-7.5-5.84l-.22.03c-3.67.46-6.29,3.83-5.84,7.5l1.58,12.69c.24,1.9,1.27,3.52,2.71,4.57-2.69,1.69-4.65,4.5-5.14,7.87l-5.45,37.61c-.35,2.38.1,4.7,1.13,6.7h-5.32l-37.47-5.96c-4.91-.78-9.51,2.56-10.29,7.47-.78,4.91,2.56,9.52,7.47,10.3l1.59.25c.98,2.7,3.2,4.77,5.99,5.56-3.98,3.07-6.56,7.88-6.56,13.3v1.19h62.76v-1.19c0-6.4-3.58-11.96-8.84-14.79,2.15-1.64,3.56-4.21,3.56-7.12,0-1.11-.23-2.15-.59-3.13,4.46-.96,8.09-4.59,8.78-9.35l5.45-37.61c.79-5.49-2.58-10.65-7.7-12.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M146.87,219.59l-38.83-10.57c-1.46-.4-2.96.59-3.13,2.16-.13,1.23.76,2.35,1.95,2.67l15.13,4.12-1.77,6.52c-.24.89-1.16,1.42-2.06,1.18-.61-.17-1.24.19-1.4.8l-7.17,24.64-5.48-25.59h-18.42c-22.15,0-40.11,15.41-40.11,34.43v50.66h76.77l-6.46-30.13,14.63-50.27c.17-.61-.19-1.24-.8-1.4-.89-.24-1.42-1.16-1.18-2.06l1.77-6.52,15.13,4.12c1.19.33,2.52-.19,3.04-1.32.65-1.44-.15-3.05-1.6-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M761.79,193.91c.06-1.33.1-2.67.1-4v-14.71c0-2.25-2.18-4-4.54-3.25-.98.31-1.67,1.1-2.03,2.04-1.43.23-2.63.71-2.63,1.27v13.82c-.02,10.78-3.38,21.34-9.74,30.58l-17.48,25.39c-.25.77,2.33,1.55,5.45,2.22l-.67,1.11h-37.6c-3.39,0-6.13,2.75-6.13,6.13h0c0,3.16,2.4,5.8,5.54,6.1l20.21,1.95,5.23,40.79h24.88l-10.38-38.88,9.3.9c3.6.35,6.72-2.48,6.72-6.1v-4.75c0-.91-.21-1.77-.57-2.55.29-.36.54-.75.68-1.23l10.34-36.45c1.55-5.47,2.56-11.08,3.05-16.73h4.59v-3.64h-4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M861.44,193.91c.06-1.33.1-2.67.1-4v-14.71c0-2.25-2.18-4-4.54-3.25-.98.31-1.67,1.1-2.03,2.04-1.43.23-2.63.71-2.63,1.27v13.82c-.02,10.78-3.38,21.34-9.74,30.58l-17.48,25.39c-.25.77,2.33,1.55,5.45,2.22l-.67,1.11h-37.6c-3.39,0-6.13,2.75-6.13,6.13h0c0,3.16,2.4,5.8,5.54,6.1l20.21,1.95,5.23,40.79h24.88l-10.38-38.88,9.3.9c3.6.35,6.72-2.48,6.72-6.1v-4.75c0-.91-.21-1.77-.57-2.55.29-.36.55-.75.68-1.23l10.34-36.45c1.55-5.47,2.56-11.08,3.05-16.73h4.59v-3.64h-4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M542.33,249.18c-.34,0-.68-.04-1.02-.13-1.97-.49-15.71-2.29-15.15-4.01l17.48-25.39c6.35-9.23,9.72-19.8,9.74-30.58h0v-13.82c0-1.42,7.43-2.28,7.43-.14v13.96c0,7.82-1.24,15.61-3.68,23.13l-11.23,34.6c-.46,1.43-1.95,2.36-3.57,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M566.83,193.91h-4.35c.06-1.33.1-2.67.1-4v-14.71c0-2.25-2.18-4-4.54-3.25-1.43.45-2.31,1.9-2.31,3.39v14.56c-.02,11.35-3.12,22.49-8.97,32.21l-16.1,26.75c-.52,1.82,12.14,3.71,13.95,4.23.31.09.63.13.94.13,1.49,0,2.86-.98,3.29-2.49l10.34-36.45c1.55-5.47,2.56-11.08,3.05-16.73h4.59v-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M442.68,226.97c-.34,0-.68-.04-1.02-.13-1.97-.49-15.71-2.29-15.15-4.01l17.48-25.39c6.35-9.23,9.72-19.8,9.74-30.58h0v-13.82c0-1.42,7.43-2.27,7.43-.14v13.96c0,7.82-1.24,15.61-3.68,23.13l-11.23,34.6c-.46,1.43-1.95,2.36-3.57,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M467.17,171.69h-4.35c.06-1.33.1-2.67.1-4v-14.71c0-2.25-2.18-4-4.54-3.25-1.43.45-2.31,1.9-2.31,3.39v14.56c-.02,11.35-3.12,22.49-8.97,32.21l-16.1,26.75c-.52,1.82,12.14,3.71,13.95,4.23.31.09.63.13.94.13,1.49,0,2.86-.98,3.29-2.49l10.34-36.45c1.55-5.47,2.56-11.08,3.05-16.73h4.59v-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M343.02,226.97c-.34,0-.68-.04-1.02-.13-1.97-.49-15.71-2.29-15.15-4.01l17.48-25.39c6.35-9.23,9.72-19.8,9.74-30.58h0v-13.82c0-1.42,7.43-2.27,7.43-.14v13.96c0,7.82-1.24,15.61-3.68,23.13l-11.23,34.6c-.46,1.43-1.95,2.36-3.57,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M367.51,171.69h-4.35c.06-1.33.1-2.67.1-4v-14.71c0-2.25-2.18-4-4.54-3.25-1.43.45-2.31,1.9-2.31,3.39v14.56c-.02,11.35-3.12,22.49-8.97,32.21l-16.1,26.75c-.52,1.82,12.14,3.71,13.95,4.23.31.09.63.13.94.13,1.49,0,2.86-.98,3.29-2.49l10.34-36.45c1.55-5.47,2.56-11.08,3.05-16.73h4.59v-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M641.99,249.18c-.34,0-.68-.04-1.02-.13-1.97-.49-15.71-2.29-15.15-4.01l17.48-25.39c6.35-9.23,9.72-19.8,9.74-30.58h0v-13.82c0-1.42,7.43-2.28,7.43-.14v13.96c0,7.82-1.24,15.61-3.68,23.13l-11.23,34.6c-.46,1.43-1.95,2.36-3.57,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M666.48,193.91h-4.35c.06-1.33.1-2.67.1-4v-14.71c0-2.25-2.18-4-4.54-3.25-1.43.45-2.31,1.9-2.31,3.39v14.56c-.02,11.35-3.12,22.49-8.97,32.21l-16.1,26.75c-.52,1.82,12.14,3.71,13.95,4.23.31.09.63.13.94.13,1.49,0,2.86-.98,3.29-2.49l10.34-36.45c1.55-5.47,2.56-11.08,3.05-16.73h4.59v-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M940.95,249.18c-.34,0-.68-.04-1.02-.13-1.97-.49-15.71-2.29-15.15-4.01l17.48-25.39c6.35-9.23,9.72-19.8,9.74-30.58h0v-13.82c0-1.42,7.43-2.28,7.43-.14v13.96c0,7.82-1.24,15.61-3.68,23.13l-11.23,34.6c-.46,1.43-1.95,2.36-3.57,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M965.45,193.91h-4.35c.06-1.33.1-2.67.1-4v-14.71c0-2.25-2.18-4-4.54-3.25-1.43.45-2.31,1.9-2.31,3.39v14.56c-.02,11.35-3.12,22.49-8.97,32.21l-16.1,26.75c-.52,1.82,12.14,3.71,13.95,4.23.31.09.63.13.94.13,1.49,0,2.86-.98,3.29-2.49l10.34-36.45c1.55-5.47,2.56-11.08,3.05-16.73h4.59v-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1040.61,249.18c-.34,0-.68-.04-1.02-.13-1.97-.49-15.71-2.29-15.15-4.01l17.48-25.39c6.35-9.23,9.72-19.8,9.74-30.58h0v-13.82c0-1.42,7.43-2.28,7.43-.14v13.96c0,7.82-1.24,15.61-3.68,23.13l-11.23,34.6c-.46,1.43-1.95,2.36-3.57,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1065.1,193.91h-4.35c.06-1.33.1-2.67.1-4v-14.71c0-2.25-2.18-4-4.54-3.25-1.43.45-2.31,1.9-2.31,3.39v14.56c-.02,11.35-3.12,22.49-8.97,32.21l-16.1,26.75c-.52,1.82,12.14,3.71,13.95,4.23.31.09.63.13.94.13,1.49,0,2.86-.98,3.29-2.49l10.34-36.45c1.55-5.47,2.56-11.08,3.05-16.73h4.59v-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1140.26,226.97c-.34,0-.68-.04-1.02-.13-1.97-.49-15.71-2.29-15.15-4.01l17.48-25.39c6.35-9.23,9.72-19.8,9.74-30.58h0v-13.82c0-1.42,7.43-2.27,7.43-.14v13.96c0,7.82-1.24,15.61-3.68,23.13l-11.23,34.6c-.46,1.43-1.95,2.36-3.57,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1164.76,171.69h-4.35c.06-1.33.1-2.67.1-4v-14.71c0-2.25-2.18-4-4.54-3.25-1.43.45-2.31,1.9-2.31,3.39v14.56c-.02,11.35-3.12,22.49-8.97,32.21l-16.1,26.75c-.52,1.82,12.14,3.71,13.95,4.23.31.09.63.13.94.13,1.49,0,2.86-.98,3.29-2.49l10.34-36.45c1.55-5.47,2.56-11.08,3.05-16.73h4.59v-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1439.23,226.97c-.34,0-.68-.04-1.02-.13-1.97-.49-15.71-2.29-15.15-4.01l17.48-25.39c6.35-9.23,9.72-19.8,9.74-30.58h0v-13.82c0-1.42,7.43-2.27,7.43-.14v13.96c0,7.82-1.24,15.61-3.68,23.13l-11.23,34.6c-.46,1.43-1.95,2.36-3.57,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1463.72,171.69h-4.35c.06-1.33.1-2.67.1-4v-14.71c0-2.25-2.18-4-4.54-3.25-1.43.45-2.31,1.9-2.31,3.39v14.56c-.02,11.35-3.12,22.49-8.97,32.21l-16.1,26.75c-.52,1.82,12.14,3.71,13.95,4.23.31.09.63.13.94.13,1.49,0,2.86-.98,3.29-2.49l10.34-36.45c1.55-5.47,2.56-11.08,3.05-16.73h4.59v-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1239.92,226.97c-.34,0-.68-.04-1.02-.13-1.97-.49-15.71-2.29-15.15-4.01l17.48-25.39c6.35-9.23,9.72-19.8,9.74-30.58h0v-13.82c0-1.42,7.43-2.27,7.43-.14v13.96c0,7.82-1.24,15.61-3.68,23.13l-11.23,34.6c-.46,1.43-1.95,2.36-3.57,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1264.41,171.69h-4.35c.06-1.33.1-2.67.1-4v-14.71c0-2.25-2.18-4-4.54-3.25-1.43.45-2.31,1.9-2.31,3.39v14.56c-.02,11.35-3.12,22.49-8.97,32.21l-16.1,26.75c-.52,1.82,12.14,3.71,13.95,4.23.31.09.63.13.94.13,1.49,0,2.86-.98,3.29-2.49l10.34-36.45c1.55-5.47,2.56-11.08,3.05-16.73h4.59v-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1339.57,226.97c-.34,0-.68-.04-1.02-.13-1.97-.49-15.71-2.29-15.15-4.01l17.48-25.39c6.35-9.23,9.72-19.8,9.74-30.58h0v-13.82c0-1.42,7.43-2.27,7.43-.14v13.96c0,7.82-1.24,15.61-3.68,23.13l-11.23,34.6c-.46,1.43-1.95,2.36-3.57,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1364.07,171.69h-4.35c.06-1.33.1-2.67.1-4v-14.71c0-2.25-2.18-4-4.54-3.25-1.43.45-2.31,1.9-2.31,3.39v14.56c-.02,11.35-3.12,22.49-8.97,32.21l-16.1,26.75c-.52,1.82,12.14,3.71,13.95,4.23.31.09.63.13.94.13,1.49,0,2.86-.98,3.29-2.49l10.34-36.45c1.55-5.47,2.56-11.08,3.05-16.73h4.59v-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1347.4,85.57H282.63c-6.85,0-12.42-5.57-12.42-12.42v-29.59c0-6.85,5.57-12.42,12.42-12.42h1064.77c6.85,0,12.42,5.57,12.42,12.42v29.59c0,6.85-5.57,12.42-12.42,12.42ZM282.63,34.57c-4.96,0-8.99,4.04-8.99,8.99v29.59c0,4.96,4.04,8.99,8.99,8.99h1064.77c4.96,0,8.99-4.04,8.99-8.99v-29.59c0-4.96-4.04-8.99-8.99-8.99H282.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M356.32,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM356.32,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 354.72,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M402.19,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM402.19,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 400.59,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M448.06,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM448.06,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 446.46,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M493.93,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM493.93,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 492.33,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M539.8,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM539.8,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 538.2,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M585.67,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM585.67,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 584.06,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M631.54,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM631.54,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 629.93,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M677.41,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM677.41,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 675.8,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M723.28,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM723.28,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 721.67,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M769.15,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM769.15,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 767.54,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M815.02,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM815.02,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 813.41,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M860.88,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM860.88,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 859.28,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M906.75,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM906.75,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 905.15,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M952.62,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM952.62,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 951.02,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M998.49,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM998.49,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 996.89,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1044.36,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM1044.36,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1042.76,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1090.23,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM1090.23,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1088.63,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1136.1,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM1136.1,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1134.49,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1181.97,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM1181.97,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1180.36,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1227.84,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM1227.84,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1226.23,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1273.71,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM1273.71,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1272.1,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1319.58,101.65c-3.3,0-5.99-2.69-5.99-5.99s2.69-5.99,5.99-5.99,5.99,2.69,5.99,5.99-2.69,5.99-5.99,5.99ZM1319.58,91.38c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1317.97,
    y: 78.99,
    width: 3.21,
    height: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M679.17,295.84c-.95,0-1.71-.84-1.71-1.87V66.09c0-1.04.77-1.87,1.71-1.87s1.71.84,1.71,1.87v227.88c0,1.04-.77,1.87-1.71,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M924.78,295.84c-.95,0-1.71-.84-1.71-1.87V66.09c0-1.04.77-1.87,1.71-1.87s1.71.84,1.71,1.87v227.88c0,1.04-.77,1.87-1.71,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M714.4,295.84c-.95,0-1.71-.84-1.71-1.87V66.09c0-1.04.77-1.87,1.71-1.87s1.71.84,1.71,1.87v227.88c0,1.04-.77,1.87-1.71,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M309.46,295.84c-.95,0-1.71-.84-1.71-1.87V66.09c0-1.04.77-1.87,1.71-1.87s1.71.84,1.71,1.87v227.88c0,1.04-.77,1.87-1.71,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M215.73,295.84c-.95,0-1.71-.84-1.71-1.87V66.09c0-1.04.77-1.87,1.71-1.87s1.71.84,1.71,1.87v227.88c0,1.04-.77,1.87-1.71,1.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 682.88,
    y: 289.94,
    width: 191.61,
    height: 38.32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "682.88 289.94 688.36 295.42 688.36 289.94 682.88 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "682.88 295.42 688.36 300.89 688.36 295.42 682.88 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "682.88 300.89 688.36 306.37 688.36 300.89 682.88 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "682.88 306.37 688.36 311.84 688.36 306.37 682.88 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "682.88 311.84 688.36 317.32 688.36 311.84 682.88 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "682.88 317.32 688.36 322.79 688.36 317.32 682.88 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "682.88 322.79 688.36 328.27 688.36 322.79 682.88 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "688.36 289.94 693.83 295.42 693.83 289.94 688.36 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "688.36 295.42 693.83 300.89 693.83 295.42 688.36 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "688.36 300.89 693.83 306.37 693.83 300.89 688.36 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "688.36 306.37 693.83 311.84 693.83 306.37 688.36 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "688.36 311.84 693.83 317.32 693.83 311.84 688.36 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "688.36 317.32 693.83 322.79 693.83 317.32 688.36 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "688.36 322.79 693.83 328.27 693.83 322.79 688.36 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.83 289.94 699.31 295.42 699.31 289.94 693.83 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.83 295.42 699.31 300.89 699.31 295.42 693.83 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.83 300.89 699.31 306.37 699.31 300.89 693.83 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.83 306.37 699.31 311.84 699.31 306.37 693.83 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.83 311.84 699.31 317.32 699.31 311.84 693.83 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.83 317.32 699.31 322.79 699.31 317.32 693.83 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.83 322.79 699.31 328.27 699.31 322.79 693.83 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.31 289.94 704.78 295.42 704.78 289.94 699.31 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.31 295.42 704.78 300.89 704.78 295.42 699.31 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.31 300.89 704.78 306.37 704.78 300.89 699.31 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.31 306.37 704.78 311.84 704.78 306.37 699.31 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.31 311.84 704.78 317.32 704.78 311.84 699.31 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.31 317.32 704.78 322.79 704.78 317.32 699.31 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.31 322.79 704.78 328.27 704.78 322.79 699.31 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.78 289.94 710.26 295.42 710.26 289.94 704.78 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.78 295.42 710.26 300.89 710.26 295.42 704.78 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.78 300.89 710.26 306.37 710.26 300.89 704.78 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.78 306.37 710.26 311.84 710.26 306.37 704.78 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.78 311.84 710.26 317.32 710.26 311.84 704.78 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.78 317.32 710.26 322.79 710.26 317.32 704.78 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.78 322.79 710.26 328.27 710.26 322.79 704.78 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.26 289.94 715.73 295.42 715.73 289.94 710.26 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.26 295.42 715.73 300.89 715.73 295.42 710.26 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.26 300.89 715.73 306.37 715.73 300.89 710.26 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.26 306.37 715.73 311.84 715.73 306.37 710.26 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.26 311.84 715.73 317.32 715.73 311.84 710.26 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.26 317.32 715.73 322.79 715.73 317.32 710.26 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.26 322.79 715.73 328.27 715.73 322.79 710.26 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.73 289.94 721.2 295.42 721.2 289.94 715.73 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.73 295.42 721.2 300.89 721.2 295.42 715.73 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.73 300.89 721.2 306.37 721.2 300.89 715.73 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.73 306.37 721.2 311.84 721.2 306.37 715.73 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.73 311.84 721.2 317.32 721.2 311.84 715.73 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.73 317.32 721.2 322.79 721.2 317.32 715.73 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.73 322.79 721.2 328.27 721.2 322.79 715.73 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.2 289.94 726.68 295.42 726.68 289.94 721.2 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.2 295.42 726.68 300.89 726.68 295.42 721.2 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.2 300.89 726.68 306.37 726.68 300.89 721.2 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.2 306.37 726.68 311.84 726.68 306.37 721.2 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.2 311.84 726.68 317.32 726.68 311.84 721.2 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.2 317.32 726.68 322.79 726.68 317.32 721.2 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.2 322.79 726.68 328.27 726.68 322.79 721.2 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.68 289.94 732.15 295.42 732.15 289.94 726.68 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.68 295.42 732.15 300.89 732.15 295.42 726.68 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.68 300.89 732.15 306.37 732.15 300.89 726.68 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.68 306.37 732.15 311.84 732.15 306.37 726.68 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.68 311.84 732.15 317.32 732.15 311.84 726.68 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.68 317.32 732.15 322.79 732.15 317.32 726.68 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.68 322.79 732.15 328.27 732.15 322.79 726.68 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.15 289.94 737.63 295.42 737.63 289.94 732.15 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.15 295.42 737.63 300.89 737.63 295.42 732.15 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.15 300.89 737.63 306.37 737.63 300.89 732.15 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.15 306.37 737.63 311.84 737.63 306.37 732.15 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.15 311.84 737.63 317.32 737.63 311.84 732.15 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.15 317.32 737.63 322.79 737.63 317.32 732.15 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.15 322.79 737.63 328.27 737.63 322.79 732.15 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.63 289.94 743.1 295.42 743.1 289.94 737.63 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.63 295.42 743.1 300.89 743.1 295.42 737.63 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.63 300.89 743.1 306.37 743.1 300.89 737.63 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.63 306.37 743.1 311.84 743.1 306.37 737.63 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.63 311.84 743.1 317.32 743.1 311.84 737.63 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.63 317.32 743.1 322.79 743.1 317.32 737.63 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.63 322.79 743.1 328.27 743.1 322.79 737.63 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.1 289.94 748.58 295.42 748.58 289.94 743.1 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.1 295.42 748.58 300.89 748.58 295.42 743.1 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.1 300.89 748.58 306.37 748.58 300.89 743.1 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.1 306.37 748.58 311.84 748.58 306.37 743.1 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.1 311.84 748.58 317.32 748.58 311.84 743.1 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.1 317.32 748.58 322.79 748.58 317.32 743.1 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.1 322.79 748.58 328.27 748.58 322.79 743.1 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.58 289.94 754.05 295.42 754.05 289.94 748.58 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.58 295.42 754.05 300.89 754.05 295.42 748.58 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.58 300.89 754.05 306.37 754.05 300.89 748.58 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.58 306.37 754.05 311.84 754.05 306.37 748.58 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.58 311.84 754.05 317.32 754.05 311.84 748.58 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.58 317.32 754.05 322.79 754.05 317.32 748.58 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.58 322.79 754.05 328.27 754.05 322.79 748.58 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.05 289.94 759.53 295.42 759.53 289.94 754.05 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.05 295.42 759.53 300.89 759.53 295.42 754.05 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.05 300.89 759.53 306.37 759.53 300.89 754.05 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.05 306.37 759.53 311.84 759.53 306.37 754.05 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.05 311.84 759.53 317.32 759.53 311.84 754.05 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.05 317.32 759.53 322.79 759.53 317.32 754.05 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.05 322.79 759.53 328.27 759.53 322.79 754.05 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.53 289.94 765 295.42 765 289.94 759.53 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.53 295.42 765 300.89 765 295.42 759.53 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.53 300.89 765 306.37 765 300.89 759.53 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.53 306.37 765 311.84 765 306.37 759.53 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.53 311.84 765 317.32 765 311.84 759.53 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.53 317.32 765 322.79 765 317.32 759.53 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.53 322.79 765 328.27 765 322.79 759.53 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765 289.94 770.48 295.42 770.48 289.94 765 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765 295.42 770.48 300.89 770.48 295.42 765 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765 300.89 770.48 306.37 770.48 300.89 765 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765 306.37 770.48 311.84 770.48 306.37 765 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765 311.84 770.48 317.32 770.48 311.84 765 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765 317.32 770.48 322.79 770.48 317.32 765 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765 322.79 770.48 328.27 770.48 322.79 765 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.48 289.94 775.95 295.42 775.95 289.94 770.48 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.48 295.42 775.95 300.89 775.95 295.42 770.48 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.48 300.89 775.95 306.37 775.95 300.89 770.48 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.48 306.37 775.95 311.84 775.95 306.37 770.48 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.48 311.84 775.95 317.32 775.95 311.84 770.48 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.48 317.32 775.95 322.79 775.95 317.32 770.48 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.48 322.79 775.95 328.27 775.95 322.79 770.48 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 289.94 781.42 295.42 781.42 289.94 775.95 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 295.42 781.42 300.89 781.42 295.42 775.95 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 300.89 781.42 306.37 781.42 300.89 775.95 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 306.37 781.42 311.84 781.42 306.37 775.95 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 311.84 781.42 317.32 781.42 311.84 775.95 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 317.32 781.42 322.79 781.42 317.32 775.95 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 322.79 781.42 328.27 781.42 322.79 775.95 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 289.94 786.9 295.42 786.9 289.94 781.42 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 295.42 786.9 300.89 786.9 295.42 781.42 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 300.89 786.9 306.37 786.9 300.89 781.42 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 306.37 786.9 311.84 786.9 306.37 781.42 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 311.84 786.9 317.32 786.9 311.84 781.42 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 317.32 786.9 322.79 786.9 317.32 781.42 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 322.79 786.9 328.27 786.9 322.79 781.42 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.9 289.94 792.37 295.42 792.37 289.94 786.9 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.9 295.42 792.37 300.89 792.37 295.42 786.9 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.9 300.89 792.37 306.37 792.37 300.89 786.9 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.9 306.37 792.37 311.84 792.37 306.37 786.9 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.9 311.84 792.37 317.32 792.37 311.84 786.9 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.9 317.32 792.37 322.79 792.37 317.32 786.9 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.9 322.79 792.37 328.27 792.37 322.79 786.9 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.37 289.94 797.85 295.42 797.85 289.94 792.37 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.37 295.42 797.85 300.89 797.85 295.42 792.37 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.37 300.89 797.85 306.37 797.85 300.89 792.37 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.37 306.37 797.85 311.84 797.85 306.37 792.37 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.37 311.84 797.85 317.32 797.85 311.84 792.37 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.37 317.32 797.85 322.79 797.85 317.32 792.37 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.37 322.79 797.85 328.27 797.85 322.79 792.37 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.85 289.94 803.32 295.42 803.32 289.94 797.85 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.85 295.42 803.32 300.89 803.32 295.42 797.85 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.85 300.89 803.32 306.37 803.32 300.89 797.85 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.85 306.37 803.32 311.84 803.32 306.37 797.85 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.85 311.84 803.32 317.32 803.32 311.84 797.85 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.85 317.32 803.32 322.79 803.32 317.32 797.85 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.85 322.79 803.32 328.27 803.32 322.79 797.85 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.32 289.94 808.8 295.42 808.8 289.94 803.32 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.32 295.42 808.8 300.89 808.8 295.42 803.32 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.32 300.89 808.8 306.37 808.8 300.89 803.32 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.32 306.37 808.8 311.84 808.8 306.37 803.32 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.32 311.84 808.8 317.32 808.8 311.84 803.32 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.32 317.32 808.8 322.79 808.8 317.32 803.32 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.32 322.79 808.8 328.27 808.8 322.79 803.32 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.8 289.94 814.27 295.42 814.27 289.94 808.8 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.8 295.42 814.27 300.89 814.27 295.42 808.8 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.8 300.89 814.27 306.37 814.27 300.89 808.8 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.8 306.37 814.27 311.84 814.27 306.37 808.8 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.8 311.84 814.27 317.32 814.27 311.84 808.8 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.8 317.32 814.27 322.79 814.27 317.32 808.8 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.8 322.79 814.27 328.27 814.27 322.79 808.8 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.27 289.94 819.75 295.42 819.75 289.94 814.27 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.27 295.42 819.75 300.89 819.75 295.42 814.27 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.27 300.89 819.75 306.37 819.75 300.89 814.27 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.27 306.37 819.75 311.84 819.75 306.37 814.27 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.27 311.84 819.75 317.32 819.75 311.84 814.27 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.27 317.32 819.75 322.79 819.75 317.32 814.27 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.27 322.79 819.75 328.27 819.75 322.79 814.27 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.75 289.94 825.22 295.42 825.22 289.94 819.75 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.75 295.42 825.22 300.89 825.22 295.42 819.75 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.75 300.89 825.22 306.37 825.22 300.89 819.75 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.75 306.37 825.22 311.84 825.22 306.37 819.75 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.75 311.84 825.22 317.32 825.22 311.84 819.75 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.75 317.32 825.22 322.79 825.22 317.32 819.75 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.75 322.79 825.22 328.27 825.22 322.79 819.75 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.22 289.94 830.69 295.42 830.69 289.94 825.22 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.22 295.42 830.69 300.89 830.69 295.42 825.22 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.22 300.89 830.69 306.37 830.69 300.89 825.22 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.22 306.37 830.69 311.84 830.69 306.37 825.22 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.22 311.84 830.69 317.32 830.69 311.84 825.22 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.22 317.32 830.69 322.79 830.69 317.32 825.22 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.22 322.79 830.69 328.27 830.69 322.79 825.22 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.69 289.94 836.17 295.42 836.17 289.94 830.69 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.69 295.42 836.17 300.89 836.17 295.42 830.69 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.69 300.89 836.17 306.37 836.17 300.89 830.69 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.69 306.37 836.17 311.84 836.17 306.37 830.69 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.69 311.84 836.17 317.32 836.17 311.84 830.69 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.69 317.32 836.17 322.79 836.17 317.32 830.69 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.69 322.79 836.17 328.27 836.17 322.79 830.69 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.17 289.94 841.64 295.42 841.64 289.94 836.17 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.17 295.42 841.64 300.89 841.64 295.42 836.17 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.17 300.89 841.64 306.37 841.64 300.89 836.17 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.17 306.37 841.64 311.84 841.64 306.37 836.17 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.17 311.84 841.64 317.32 841.64 311.84 836.17 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.17 317.32 841.64 322.79 841.64 317.32 836.17 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.17 322.79 841.64 328.27 841.64 322.79 836.17 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.64 289.94 847.12 295.42 847.12 289.94 841.64 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.64 295.42 847.12 300.89 847.12 295.42 841.64 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.64 300.89 847.12 306.37 847.12 300.89 841.64 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.64 306.37 847.12 311.84 847.12 306.37 841.64 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.64 311.84 847.12 317.32 847.12 311.84 841.64 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.64 317.32 847.12 322.79 847.12 317.32 841.64 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.64 322.79 847.12 328.27 847.12 322.79 841.64 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847.12 289.94 852.59 295.42 852.59 289.94 847.12 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847.12 295.42 852.59 300.89 852.59 295.42 847.12 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847.12 300.89 852.59 306.37 852.59 300.89 847.12 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847.12 306.37 852.59 311.84 852.59 306.37 847.12 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847.12 311.84 852.59 317.32 852.59 311.84 847.12 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847.12 317.32 852.59 322.79 852.59 317.32 847.12 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847.12 322.79 852.59 328.27 852.59 322.79 847.12 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.59 289.94 858.07 295.42 858.07 289.94 852.59 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.59 295.42 858.07 300.89 858.07 295.42 852.59 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.59 300.89 858.07 306.37 858.07 300.89 852.59 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.59 306.37 858.07 311.84 858.07 306.37 852.59 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.59 311.84 858.07 317.32 858.07 311.84 852.59 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.59 317.32 858.07 322.79 858.07 317.32 852.59 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.59 322.79 858.07 328.27 858.07 322.79 852.59 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "858.07 289.94 863.54 295.42 863.54 289.94 858.07 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "858.07 295.42 863.54 300.89 863.54 295.42 858.07 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "858.07 300.89 863.54 306.37 863.54 300.89 858.07 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "858.07 306.37 863.54 311.84 863.54 306.37 858.07 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "858.07 311.84 863.54 317.32 863.54 311.84 858.07 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "858.07 317.32 863.54 322.79 863.54 317.32 858.07 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "858.07 322.79 863.54 328.27 863.54 322.79 858.07 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "863.54 289.94 869.02 295.42 869.02 289.94 863.54 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "863.54 295.42 869.02 300.89 869.02 295.42 863.54 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "863.54 300.89 869.02 306.37 869.02 300.89 863.54 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "863.54 306.37 869.02 311.84 869.02 306.37 863.54 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "863.54 311.84 869.02 317.32 869.02 311.84 863.54 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "863.54 317.32 869.02 322.79 869.02 317.32 863.54 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "863.54 322.79 869.02 328.27 869.02 322.79 863.54 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "869.02 289.94 874.49 295.42 874.49 289.94 869.02 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "869.02 295.42 874.49 300.89 874.49 295.42 869.02 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "869.02 300.89 874.49 306.37 874.49 300.89 869.02 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "869.02 306.37 874.49 311.84 874.49 306.37 869.02 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "869.02 311.84 874.49 317.32 874.49 311.84 869.02 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "869.02 317.32 874.49 322.79 874.49 317.32 869.02 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "869.02 322.79 874.49 328.27 874.49 322.79 869.02 322.79"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 682.88,
    y: 289.94,
    width: 191.61,
    height: 21.9,
    transform: "translate(1557.37 601.79) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 84.33,
    y: 289.94,
    width: 191.61,
    height: 38.32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "84.33 289.94 89.8 295.42 89.8 289.94 84.33 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "84.33 295.42 89.8 300.89 89.8 295.42 84.33 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "84.33 300.89 89.8 306.37 89.8 300.89 84.33 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "84.33 306.37 89.8 311.84 89.8 306.37 84.33 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "84.33 311.84 89.8 317.32 89.8 311.84 84.33 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "84.33 317.32 89.8 322.79 89.8 317.32 84.33 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "84.33 322.79 89.8 328.27 89.8 322.79 84.33 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "89.8 289.94 95.28 295.42 95.28 289.94 89.8 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "89.8 295.42 95.28 300.89 95.28 295.42 89.8 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "89.8 300.89 95.28 306.37 95.28 300.89 89.8 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "89.8 306.37 95.28 311.84 95.28 306.37 89.8 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "89.8 311.84 95.28 317.32 95.28 311.84 89.8 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "89.8 317.32 95.28 322.79 95.28 317.32 89.8 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "89.8 322.79 95.28 328.27 95.28 322.79 89.8 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.28 289.94 100.75 295.42 100.75 289.94 95.28 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.28 295.42 100.75 300.89 100.75 295.42 95.28 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.28 300.89 100.75 306.37 100.75 300.89 95.28 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.28 306.37 100.75 311.84 100.75 306.37 95.28 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.28 311.84 100.75 317.32 100.75 311.84 95.28 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.28 317.32 100.75 322.79 100.75 317.32 95.28 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.28 322.79 100.75 328.27 100.75 322.79 95.28 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.75 289.94 106.22 295.42 106.22 289.94 100.75 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.75 295.42 106.22 300.89 106.22 295.42 100.75 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.75 300.89 106.22 306.37 106.22 300.89 100.75 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.75 306.37 106.22 311.84 106.22 306.37 100.75 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.75 311.84 106.22 317.32 106.22 311.84 100.75 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.75 317.32 106.22 322.79 106.22 317.32 100.75 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.75 322.79 106.22 328.27 106.22 322.79 100.75 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.22 289.94 111.7 295.42 111.7 289.94 106.22 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.22 295.42 111.7 300.89 111.7 295.42 106.22 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.22 300.89 111.7 306.37 111.7 300.89 106.22 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.22 306.37 111.7 311.84 111.7 306.37 106.22 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.22 311.84 111.7 317.32 111.7 311.84 106.22 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.22 317.32 111.7 322.79 111.7 317.32 106.22 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.22 322.79 111.7 328.27 111.7 322.79 106.22 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.7 289.94 117.17 295.42 117.17 289.94 111.7 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.7 295.42 117.17 300.89 117.17 295.42 111.7 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.7 300.89 117.17 306.37 117.17 300.89 111.7 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.7 306.37 117.17 311.84 117.17 306.37 111.7 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.7 311.84 117.17 317.32 117.17 311.84 111.7 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.7 317.32 117.17 322.79 117.17 317.32 111.7 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.7 322.79 117.17 328.27 117.17 322.79 111.7 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.17 289.94 122.65 295.42 122.65 289.94 117.17 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.17 295.42 122.65 300.89 122.65 295.42 117.17 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.17 300.89 122.65 306.37 122.65 300.89 117.17 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.17 306.37 122.65 311.84 122.65 306.37 117.17 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.17 311.84 122.65 317.32 122.65 311.84 117.17 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.17 317.32 122.65 322.79 122.65 317.32 117.17 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.17 322.79 122.65 328.27 122.65 322.79 117.17 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.65 289.94 128.12 295.42 128.12 289.94 122.65 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.65 295.42 128.12 300.89 128.12 295.42 122.65 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.65 300.89 128.12 306.37 128.12 300.89 122.65 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.65 306.37 128.12 311.84 128.12 306.37 122.65 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.65 311.84 128.12 317.32 128.12 311.84 122.65 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.65 317.32 128.12 322.79 128.12 317.32 122.65 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.65 322.79 128.12 328.27 128.12 322.79 122.65 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.12 289.94 133.6 295.42 133.6 289.94 128.12 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.12 295.42 133.6 300.89 133.6 295.42 128.12 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.12 300.89 133.6 306.37 133.6 300.89 128.12 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.12 306.37 133.6 311.84 133.6 306.37 128.12 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.12 311.84 133.6 317.32 133.6 311.84 128.12 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.12 317.32 133.6 322.79 133.6 317.32 128.12 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.12 322.79 133.6 328.27 133.6 322.79 128.12 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.6 289.94 139.07 295.42 139.07 289.94 133.6 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.6 295.42 139.07 300.89 139.07 295.42 133.6 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.6 300.89 139.07 306.37 139.07 300.89 133.6 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.6 306.37 139.07 311.84 139.07 306.37 133.6 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.6 311.84 139.07 317.32 139.07 311.84 133.6 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.6 317.32 139.07 322.79 139.07 317.32 133.6 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.6 322.79 139.07 328.27 139.07 322.79 133.6 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.07 289.94 144.55 295.42 144.55 289.94 139.07 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.07 295.42 144.55 300.89 144.55 295.42 139.07 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.07 300.89 144.55 306.37 144.55 300.89 139.07 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.07 306.37 144.55 311.84 144.55 306.37 139.07 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.07 311.84 144.55 317.32 144.55 311.84 139.07 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.07 317.32 144.55 322.79 144.55 317.32 139.07 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.07 322.79 144.55 328.27 144.55 322.79 139.07 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.55 289.94 150.02 295.42 150.02 289.94 144.55 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.55 295.42 150.02 300.89 150.02 295.42 144.55 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.55 300.89 150.02 306.37 150.02 300.89 144.55 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.55 306.37 150.02 311.84 150.02 306.37 144.55 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.55 311.84 150.02 317.32 150.02 311.84 144.55 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.55 317.32 150.02 322.79 150.02 317.32 144.55 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.55 322.79 150.02 328.27 150.02 322.79 144.55 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.02 289.94 155.5 295.42 155.5 289.94 150.02 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.02 295.42 155.5 300.89 155.5 295.42 150.02 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.02 300.89 155.5 306.37 155.5 300.89 150.02 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.02 306.37 155.5 311.84 155.5 306.37 150.02 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.02 311.84 155.5 317.32 155.5 311.84 150.02 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.02 317.32 155.5 322.79 155.5 317.32 150.02 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.02 322.79 155.5 328.27 155.5 322.79 150.02 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.5 289.94 160.97 295.42 160.97 289.94 155.5 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.5 295.42 160.97 300.89 160.97 295.42 155.5 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.5 300.89 160.97 306.37 160.97 300.89 155.5 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.5 306.37 160.97 311.84 160.97 306.37 155.5 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.5 311.84 160.97 317.32 160.97 311.84 155.5 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.5 317.32 160.97 322.79 160.97 317.32 155.5 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.5 322.79 160.97 328.27 160.97 322.79 155.5 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "160.97 289.94 166.44 295.42 166.44 289.94 160.97 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "160.97 295.42 166.44 300.89 166.44 295.42 160.97 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "160.97 300.89 166.44 306.37 166.44 300.89 160.97 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "160.97 306.37 166.44 311.84 166.44 306.37 160.97 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "160.97 311.84 166.44 317.32 166.44 311.84 160.97 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "160.97 317.32 166.44 322.79 166.44 317.32 160.97 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "160.97 322.79 166.44 328.27 166.44 322.79 160.97 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.44 289.94 171.92 295.42 171.92 289.94 166.44 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.44 295.42 171.92 300.89 171.92 295.42 166.44 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.44 300.89 171.92 306.37 171.92 300.89 166.44 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.44 306.37 171.92 311.84 171.92 306.37 166.44 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.44 311.84 171.92 317.32 171.92 311.84 166.44 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.44 317.32 171.92 322.79 171.92 317.32 166.44 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.44 322.79 171.92 328.27 171.92 322.79 166.44 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.92 289.94 177.39 295.42 177.39 289.94 171.92 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.92 295.42 177.39 300.89 177.39 295.42 171.92 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.92 300.89 177.39 306.37 177.39 300.89 171.92 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.92 306.37 177.39 311.84 177.39 306.37 171.92 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.92 311.84 177.39 317.32 177.39 311.84 171.92 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.92 317.32 177.39 322.79 177.39 317.32 171.92 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.92 322.79 177.39 328.27 177.39 322.79 171.92 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.39 289.94 182.87 295.42 182.87 289.94 177.39 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.39 295.42 182.87 300.89 182.87 295.42 177.39 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.39 300.89 182.87 306.37 182.87 300.89 177.39 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.39 306.37 182.87 311.84 182.87 306.37 177.39 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.39 311.84 182.87 317.32 182.87 311.84 177.39 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.39 317.32 182.87 322.79 182.87 317.32 177.39 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.39 322.79 182.87 328.27 182.87 322.79 177.39 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.87 289.94 188.34 295.42 188.34 289.94 182.87 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.87 295.42 188.34 300.89 188.34 295.42 182.87 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.87 300.89 188.34 306.37 188.34 300.89 182.87 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.87 306.37 188.34 311.84 188.34 306.37 182.87 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.87 311.84 188.34 317.32 188.34 311.84 182.87 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.87 317.32 188.34 322.79 188.34 317.32 182.87 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.87 322.79 188.34 328.27 188.34 322.79 182.87 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.34 289.94 193.82 295.42 193.82 289.94 188.34 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.34 295.42 193.82 300.89 193.82 295.42 188.34 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.34 300.89 193.82 306.37 193.82 300.89 188.34 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.34 306.37 193.82 311.84 193.82 306.37 188.34 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.34 311.84 193.82 317.32 193.82 311.84 188.34 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.34 317.32 193.82 322.79 193.82 317.32 188.34 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.34 322.79 193.82 328.27 193.82 322.79 188.34 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.82 289.94 199.29 295.42 199.29 289.94 193.82 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.82 295.42 199.29 300.89 199.29 295.42 193.82 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.82 300.89 199.29 306.37 199.29 300.89 193.82 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.82 306.37 199.29 311.84 199.29 306.37 193.82 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.82 311.84 199.29 317.32 199.29 311.84 193.82 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.82 317.32 199.29 322.79 199.29 317.32 193.82 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.82 322.79 199.29 328.27 199.29 322.79 193.82 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.29 289.94 204.77 295.42 204.77 289.94 199.29 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.29 295.42 204.77 300.89 204.77 295.42 199.29 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.29 300.89 204.77 306.37 204.77 300.89 199.29 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.29 306.37 204.77 311.84 204.77 306.37 199.29 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.29 311.84 204.77 317.32 204.77 311.84 199.29 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.29 317.32 204.77 322.79 204.77 317.32 199.29 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.29 322.79 204.77 328.27 204.77 322.79 199.29 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.77 289.94 210.24 295.42 210.24 289.94 204.77 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.77 295.42 210.24 300.89 210.24 295.42 204.77 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.77 300.89 210.24 306.37 210.24 300.89 204.77 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.77 306.37 210.24 311.84 210.24 306.37 204.77 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.77 311.84 210.24 317.32 210.24 311.84 204.77 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.77 317.32 210.24 322.79 210.24 317.32 204.77 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.77 322.79 210.24 328.27 210.24 322.79 204.77 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.24 289.94 215.71 295.42 215.71 289.94 210.24 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.24 295.42 215.71 300.89 215.71 295.42 210.24 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.24 300.89 215.71 306.37 215.71 300.89 210.24 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.24 306.37 215.71 311.84 215.71 306.37 210.24 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.24 311.84 215.71 317.32 215.71 311.84 210.24 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.24 317.32 215.71 322.79 215.71 317.32 210.24 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.24 322.79 215.71 328.27 215.71 322.79 210.24 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.71 289.94 221.19 295.42 221.19 289.94 215.71 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.71 295.42 221.19 300.89 221.19 295.42 215.71 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.71 300.89 221.19 306.37 221.19 300.89 215.71 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.71 306.37 221.19 311.84 221.19 306.37 215.71 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.71 311.84 221.19 317.32 221.19 311.84 215.71 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.71 317.32 221.19 322.79 221.19 317.32 215.71 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.71 322.79 221.19 328.27 221.19 322.79 215.71 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.19 289.94 226.66 295.42 226.66 289.94 221.19 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.19 295.42 226.66 300.89 226.66 295.42 221.19 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.19 300.89 226.66 306.37 226.66 300.89 221.19 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.19 306.37 226.66 311.84 226.66 306.37 221.19 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.19 311.84 226.66 317.32 226.66 311.84 221.19 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.19 317.32 226.66 322.79 226.66 317.32 221.19 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.19 322.79 226.66 328.27 226.66 322.79 221.19 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.66 289.94 232.14 295.42 232.14 289.94 226.66 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.66 295.42 232.14 300.89 232.14 295.42 226.66 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.66 300.89 232.14 306.37 232.14 300.89 226.66 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.66 306.37 232.14 311.84 232.14 306.37 226.66 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.66 311.84 232.14 317.32 232.14 311.84 226.66 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.66 317.32 232.14 322.79 232.14 317.32 226.66 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.66 322.79 232.14 328.27 232.14 322.79 226.66 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.14 289.94 237.61 295.42 237.61 289.94 232.14 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.14 295.42 237.61 300.89 237.61 295.42 232.14 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.14 300.89 237.61 306.37 237.61 300.89 232.14 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.14 306.37 237.61 311.84 237.61 306.37 232.14 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.14 311.84 237.61 317.32 237.61 311.84 232.14 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.14 317.32 237.61 322.79 237.61 317.32 232.14 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.14 322.79 237.61 328.27 237.61 322.79 232.14 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.61 289.94 243.09 295.42 243.09 289.94 237.61 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.61 295.42 243.09 300.89 243.09 295.42 237.61 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.61 300.89 243.09 306.37 243.09 300.89 237.61 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.61 306.37 243.09 311.84 243.09 306.37 237.61 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.61 311.84 243.09 317.32 243.09 311.84 237.61 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.61 317.32 243.09 322.79 243.09 317.32 237.61 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.61 322.79 243.09 328.27 243.09 322.79 237.61 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "243.09 289.94 248.56 295.42 248.56 289.94 243.09 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "243.09 295.42 248.56 300.89 248.56 295.42 243.09 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "243.09 300.89 248.56 306.37 248.56 300.89 243.09 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "243.09 306.37 248.56 311.84 248.56 306.37 243.09 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "243.09 311.84 248.56 317.32 248.56 311.84 243.09 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "243.09 317.32 248.56 322.79 248.56 317.32 243.09 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "243.09 322.79 248.56 328.27 248.56 322.79 243.09 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.56 289.94 254.04 295.42 254.04 289.94 248.56 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.56 295.42 254.04 300.89 254.04 295.42 248.56 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.56 300.89 254.04 306.37 254.04 300.89 248.56 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.56 306.37 254.04 311.84 254.04 306.37 248.56 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.56 311.84 254.04 317.32 254.04 311.84 248.56 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.56 317.32 254.04 322.79 254.04 317.32 248.56 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.56 322.79 254.04 328.27 254.04 322.79 248.56 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "254.04 289.94 259.51 295.42 259.51 289.94 254.04 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "254.04 295.42 259.51 300.89 259.51 295.42 254.04 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "254.04 300.89 259.51 306.37 259.51 300.89 254.04 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "254.04 306.37 259.51 311.84 259.51 306.37 254.04 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "254.04 311.84 259.51 317.32 259.51 311.84 254.04 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "254.04 317.32 259.51 322.79 259.51 317.32 254.04 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "254.04 322.79 259.51 328.27 259.51 322.79 254.04 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.51 289.94 264.98 295.42 264.98 289.94 259.51 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.51 295.42 264.98 300.89 264.98 295.42 259.51 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.51 300.89 264.98 306.37 264.98 300.89 259.51 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.51 306.37 264.98 311.84 264.98 306.37 259.51 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.51 311.84 264.98 317.32 264.98 311.84 259.51 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.51 317.32 264.98 322.79 264.98 317.32 259.51 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.51 322.79 264.98 328.27 264.98 322.79 259.51 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "264.98 289.94 270.46 295.42 270.46 289.94 264.98 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "264.98 295.42 270.46 300.89 270.46 295.42 264.98 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "264.98 300.89 270.46 306.37 270.46 300.89 264.98 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "264.98 306.37 270.46 311.84 270.46 306.37 264.98 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "264.98 311.84 270.46 317.32 270.46 311.84 264.98 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "264.98 317.32 270.46 322.79 270.46 317.32 264.98 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "264.98 322.79 270.46 328.27 270.46 322.79 264.98 322.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "270.46 289.94 275.93 295.42 275.93 289.94 270.46 289.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "270.46 295.42 275.93 300.89 275.93 295.42 270.46 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "270.46 300.89 275.93 306.37 275.93 300.89 270.46 300.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "270.46 306.37 275.93 311.84 275.93 306.37 270.46 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "270.46 311.84 275.93 317.32 275.93 311.84 270.46 311.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "270.46 317.32 275.93 322.79 275.93 317.32 270.46 317.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "270.46 322.79 275.93 328.27 275.93 322.79 270.46 322.79"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 84.33,
    y: 289.94,
    width: 191.61,
    height: 21.9,
    transform: "translate(360.26 601.79) rotate(180)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "82.23 52.26 82.23 220.83 101.05 220.83 101.05 344.34 259.21 344.34 259.21 220.83 699.54 220.83 699.54 344.34 857.7 344.34 857.7 220.83 1480.85 220.83 1480.85 52.26 82.23 52.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M565.94,0h-174.49c-7.16,0-14.04,2.82-19.14,7.85l-25.05,24.68h262.88l-25.05-24.68C579.98,2.82,573.1,0,565.94,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M557.43,2.35h-157.47c-6.47,0-12.67,2.61-17.28,7.28l-22.61,22.89h237.24l-22.61-22.89c-4.61-4.66-10.81-7.28-17.28-7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1170.26,0h-174.5c-7.16,0-14.04,2.82-19.14,7.85l-25.05,24.68h262.88l-25.05-24.68C1184.3,2.82,1177.42,0,1170.26,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M1161.75,2.35h-157.47c-6.47,0-12.67,2.61-17.28,7.28l-22.61,22.89h237.24l-22.61-22.89c-4.61-4.66-10.81-7.28-17.28-7.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 41.23,
    y: 27.6,
    width: 54.19,
    height: 45.43
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.23,
    y: 29.03,
    width: 54.19,
    height: 11.54
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1498.45,21.4H96.92c-19.34,0-34.85,19.39-46.52,52.21h9.72c9.22,0,16.69,7.47,16.69,16.69v125.41c0,16.4-13.3,29.7-29.7,29.7h-22.41c-.63,16.36-.95,33.21-.95,50.44v29.78c0,13.46,15.97,24.36,65.61,24.36h208.84c.02-1.5.08-3.01.22-4.53l2.97-32.04c2.74-29.5,27.9-52.09,58.04-52.09h12.91c30.13,0,55.3,22.59,58.04,52.09l2.97,32.04c.14,1.52.2,3.03.22,4.53h615.53c.02-1.5.08-3.01.22-4.53l2.97-32.04c2.74-29.5,27.9-52.09,58.04-52.09h12.91c30.13,0,55.3,22.59,58.04,52.09l2.97,32.04c.14,1.52.2,3.03.22,4.53h188.15c7.52,0,15.04-.54,22.48-1.62l131.1-19c6.75-.98,11.76-6.77,11.76-13.59v-104.95c0-184.01-21.54-189.43-39.51-189.43ZM1478.28,218.26h-623.15v123.51h-153.02v-123.51h-445.47v123.51H103.62v-123.51h-18.83V54.83h1393.49v163.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M444.77,312.61c-3.35-35.39-34.13-62.48-71-62.48h-15.79c-36.86,0-67.65,27.09-71,62.48l-3.54,37.37,18.03,2.05,2.21-30.08c2.64-33.41,26.9-58.98,55.96-58.98h12.44c29.06,0,53.32,25.57,55.96,58.98l2.21,30.08,18.03-2.05-3.54-37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M1195.17,312.61c-3.35-35.39-34.13-62.48-71-62.48h-15.79c-36.86,0-67.65,27.09-71,62.48l-3.54,37.37,18.03,2.05,2.21-30.08c2.64-33.41,26.9-58.98,55.96-58.98h12.44c29.06,0,53.32,25.57,55.96,58.98l2.21,30.08,18.03-2.05-3.54-37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1498.45,21.4h-295.29l-13.75-13.55c-5.1-5.03-11.98-7.85-19.14-7.85h-174.49c-7.16,0-14.04,2.82-19.14,7.85l-13.75,13.55h-364.02l-13.75-13.55c-5.1-5.03-11.98-7.85-19.14-7.85h-174.49c-7.16,0-14.04,2.82-19.14,7.85l-13.75,13.55H96.92c-19.34,0-34.85,19.39-46.52,52.21h9.72c9.22,0,16.69,7.47,16.69,16.69v125.41c0,16.4-13.3,29.7-29.7,29.7h-22.41c-.63,16.36-.95,33.21-.95,50.44v29.78c0,13.46,15.98,24.36,65.61,24.36h194.1l18.03,2.05,2.21-30.08c2.64-33.41,26.9-58.98,55.96-58.98h12.44c29.06,0,53.32,25.57,55.96,58.98l2.21,30.08,18.03-2.05h585.55l18.03,2.05,2.21-30.08c2.64-33.41,26.9-58.98,55.96-58.98h12.44c29.06,0,53.32,25.57,55.96,58.98l2.21,30.08,18.03-2.05h173.9c7.52,0,15.04-.54,22.48-1.62l131.1-19c6.75-.98,11.76-6.77,11.76-13.59v-104.95c0-184.01-21.54-189.43-39.51-189.43ZM1478.28,218.26h-623.15v123.51h-153.02v-123.51h-445.47v123.51H103.62v-123.51h-18.83V54.83h1393.49v163.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 466.5,
    y: 231.01,
    width: 0.86,
    height: 118.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 1014.81,
    y: 231.01,
    width: 0.86,
    height: 118.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 1216.9,
    y: 231.01,
    width: 0.86,
    height: 118.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 1358.39,
    y: 231.01,
    width: 0.86,
    height: 118.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M1474.37,40.35H91.69c-7.73,0-14.75,7.94-20.87,23.62-1.31,3.35-2.57,7.07-3.8,11.11h.45c6.88-22.6,15.06-34.3,24.22-34.3h1382.68c14.18,0,25.72,11.54,25.72,25.72v266.64l.43-.06V66.5c0-14.42-11.73-26.14-26.15-26.14ZM69.99,282.22h-24.7c.3-12.6.69-24.87,1.19-36.74h-.43c-.5,11.87-.89,24.14-1.19,36.74h-21.06v.86h46.19c14.73,0,26.72,11.99,26.72,26.72v40.19h.86v-40.19c0-15.2-12.37-27.57-27.57-27.57Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 477.32,
    y: 40.57,
    width: 13.02,
    height: 180.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1067.04,
    y: 40.57,
    width: 13.02,
    height: 180.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1263.61,
    y: 40.57,
    width: 13.02,
    height: 180.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1474.37,40.57H91.69c-9.64,0-17.8,12.53-24.49,34.63,5.67,2.67,9.61,8.41,9.61,15.1v125.41c0,8.39-3.5,15.96-9.1,21.36h31.14V89.97h162.57v147.1h10.53c11.55,0,22.99-2.21,33.67-6.6,13.07-5.38,31.77-8.71,52.38-8.71h15.79c20.61,0,39.31,3.34,52.38,8.71,10.68,4.39,22.12,6.6,33.67,6.6h237.58V89.97h162.57v147.1h162.37c11.55,0,22.99-2.21,33.67-6.6,13.07-5.38,31.77-8.71,52.38-8.71h15.79c20.61,0,39.31,3.34,52.38,8.71,10.68,4.39,22.12,6.6,33.67,6.6h290.08V66.5c0-14.32-11.61-25.93-25.93-25.93ZM673.89,216.04h-163.28c-30.33,0-60.49-4.45-89.52-13.2l-8.74-2.63c-29.61-8.93-60.37-13.46-91.29-13.46h-9.89c-9.61,0-17.4-7.79-17.4-17.4v-83.5c0-9.61,7.79-17.4,17.4-17.4h362.73v147.6ZM1460.19,169.35c0,9.61-7.79,17.4-17.4,17.4h-265.54c-30.93,0-61.68,4.54-91.29,13.46l-8.74,2.63c-29.03,8.75-59.2,13.2-89.52,13.2h-104.21V68.44h559.3c9.61,0,17.4,7.79,17.4,17.4v83.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1490.96,33.81H104.98c-5.28,0-9.56-4.28-9.56-9.56h1405.09c0,5.28-4.28,9.56-9.56,9.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1492.88,64.58H77.66l2.67-7.85c1.73-5.09,6.51-8.52,11.89-8.52h1384.3c9.04,0,16.37,7.33,16.37,16.37h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1437.01,327.95h-14.58c-2.9,0-5.26-2.35-5.26-5.26h0c0-2.9,2.35-5.26,5.26-5.26h14.58c2.9,0,5.26,2.35,5.26,5.26h0c0,2.9-2.35,5.26-5.26,5.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1420.19,
    y: 320.4,
    width: 18.1,
    height: 4.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1420.76,324.99h-4.9c-1.27,0-2.29-1.03-2.29-2.29h0c0-1.27,1.03-2.29,2.29-2.29h4.9v4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1437.71,320.4h4.9c1.27,0,2.29,1.03,2.29,2.29h0c0,1.27-1.03,2.29-2.29,2.29h-4.9v-4.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1421.1,
    y: 321.04,
    width: 16.28,
    height: 3.3,
    rx: 0.71,
    ry: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M37.94,324.31h-14.19v-24.59h5.51c4.53,0,8.43,3.2,9.32,7.64l2.6,13.01c.41,2.04-1.15,3.94-3.23,3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M35.97,323.12h-12.23v-21.74h4.75c3.9,0,7.26,2.83,8.03,6.76l2.24,11.51c.35,1.8-.99,3.48-2.78,3.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 24.36,
    y: 316.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(49.72 638.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 24.61,
    y: 316.27,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(49.88 636.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 25.69,
    y: 316.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(52.38 638.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 25.93,
    y: 316.27,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(52.53 636.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 27.02,
    y: 316.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(55.03 638.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 27.26,
    y: 316.27,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(55.19 636.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 28.35,
    y: 316.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(57.69 638.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 28.59,
    y: 316.27,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(57.84 636.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 29.67,
    y: 316.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(60.34 638.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 29.92,
    y: 316.27,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(60.5 636.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 31.28,
    y: 316.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(63.55 638.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 31.52,
    y: 316.27,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(63.71 636.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 32.61,
    y: 316.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(66.21 638.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 32.85,
    y: 316.27,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(66.36 636.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 33.93,
    y: 316.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(68.86 638.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 34.18,
    y: 316.27,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(69.02 636.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 35.26,
    y: 316.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(71.52 638.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 35.51,
    y: 316.27,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(71.68 636.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 36.59,
    y: 316.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(74.18 638.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 36.83,
    y: 316.27,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(74.33 636.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 30.06,
    y: 309.15,
    width: 0.98,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(61.11 624.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M30.54,309.34h.17c.13,0,.24.11.24.24v3.86c0,.13-.11.24-.24.24h-.17c-.13,0-.24-.11-.24-.24v-3.86c0-.13.11-.24.24-.24Z",
    transform: "translate(61.26 623.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 31.37,
    y: 309.15,
    width: 0.98,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(63.73 624.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 31.61,
    y: 309.34,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(63.88 623.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 32.68,
    y: 309.15,
    width: 0.98,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(66.35 624.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 32.92,
    y: 309.34,
    width: 0.65,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(66.5 623.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 33.99,
    y: 309.15,
    width: 0.98,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(68.97 624.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 34.24,
    y: 309.34,
    width: 0.65,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(69.13 623.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 35.3,
    y: 309.15,
    width: 0.98,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(71.59 624.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 35.55,
    y: 309.34,
    width: 0.65,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(71.75 623.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 24.36,
    y: 302.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(49.72 610.68) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 24.61,
    y: 302.28,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(49.88 608.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 25.69,
    y: 302.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(52.38 610.68) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 25.93,
    y: 302.28,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(52.53 608.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 27.02,
    y: 302.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(55.03 610.68) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 27.26,
    y: 302.28,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(55.19 608.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 28.35,
    y: 302.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(57.69 610.68) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 28.59,
    y: 302.28,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(57.84 608.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 29.67,
    y: 302.08,
    width: 1,
    height: 6.51,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(60.34 610.68) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 29.92,
    y: 302.28,
    width: 0.66,
    height: 4.34,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(60.5 608.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M31.48,305.04h.16c.11,0,.2.09.2.2v3.15c0,.11-.09.2-.2.2h-.16c-.11,0-.2-.09-.2-.2v-3.15c0-.11.09-.2.2-.2Z",
    transform: "translate(63.12 613.64) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 31.42,
    y: 305.15,
    width: 0.37,
    height: 2.37,
    rx: 0.13,
    ry: 0.13,
    transform: "translate(63.21 612.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M32.23,305.04h.16c.11,0,.2.09.2.2v3.15c0,.11-.09.2-.2.2h-.16c-.11,0-.2-.09-.2-.2v-3.15c0-.11.09-.2.2-.2Z",
    transform: "translate(64.62 613.64) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 32.17,
    y: 305.15,
    width: 0.37,
    height: 2.37,
    rx: 0.13,
    ry: 0.13,
    transform: "translate(64.71 612.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 32.78,
    y: 305.04,
    width: 0.56,
    height: 3.55,
    rx: 0.2,
    ry: 0.2,
    transform: "translate(66.12 613.64) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 32.92,
    y: 305.15,
    width: 0.37,
    height: 2.37,
    rx: 0.13,
    ry: 0.13,
    transform: "translate(66.21 612.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M33.73,305.04h.16c.11,0,.2.09.2.2v3.15c0,.11-.09.2-.2.2h-.16c-.11,0-.2-.09-.2-.2v-3.15c0-.11.09-.2.2-.2Z",
    transform: "translate(67.62 613.64) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 33.67,
    y: 305.15,
    width: 0.37,
    height: 2.37,
    rx: 0.13,
    ry: 0.13,
    transform: "translate(67.71 612.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M34.48,305.04h.16c.11,0,.2.09.2.2v3.15c0,.11-.09.2-.2.2h-.16c-.11,0-.2-.09-.2-.2v-3.15c0-.11.09-.2.2-.2Z",
    transform: "translate(69.12 613.64) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 34.42,
    y: 305.15,
    width: 0.38,
    height: 2.37,
    rx: 0.13,
    ry: 0.13,
    transform: "translate(69.21 612.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 24.4,
    y: 309.11,
    width: 0.82,
    height: 6.55,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(49.63 624.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.61,
    y: 309.3,
    width: 0.55,
    height: 4.37,
    rx: 0.21,
    ry: 0.21,
    transform: "translate(49.76 622.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 25.5,
    y: 309.11,
    width: 0.82,
    height: 6.55,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(51.83 624.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.71,
    y: 309.3,
    width: 0.55,
    height: 4.37,
    rx: 0.21,
    ry: 0.21,
    transform: "translate(51.96 622.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 26.61,
    y: 309.11,
    width: 0.82,
    height: 6.55,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(54.03 624.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.02,309.3h.13c.12,0,.21.09.21.21v3.95c0,.12-.09.21-.21.21h-.13c-.12,0-.21-.09-.21-.21v-3.95c0-.12.09-.21.21-.21Z",
    transform: "translate(54.16 622.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 27.71,
    y: 309.11,
    width: 0.82,
    height: 6.55,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(56.23 624.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.12,309.3h.13c.12,0,.21.09.21.21v3.95c0,.12-.09.21-.21.21h-.13c-.12,0-.21-.09-.21-.21v-3.95c0-.12.09-.21.21-.21Z",
    transform: "translate(56.36 622.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 28.81,
    y: 309.11,
    width: 0.82,
    height: 6.55,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(58.43 624.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.22,309.3h.13c.12,0,.21.09.21.21v3.95c0,.12-.09.21-.21.21h-.13c-.12,0-.21-.09-.21-.21v-3.95c0-.12.09-.21.21-.21Z",
    transform: "translate(58.56 622.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,306.75h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,302.47h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,298.19h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,293.92h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,289.64h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,285.36h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,281.09h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,276.81h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,272.53h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,268.26h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,263.98h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,259.71h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,255.43h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1488.6,251.15h0c0,.56-.46,1.02-1.02,1.02h-116.7c-.56,0-1.02-.46-1.02-1.02h0c0-.56.46-1.02,1.02-1.02h116.7c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 267.5,
    y: 299.72,
    width: 13.3,
    height: 8.27,
    rx: 1.05,
    ry: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 268.22,
    y: 300.32,
    width: 11.85,
    height: 7.07,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 278.22,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 278.35,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 276.31,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 276.44,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 274.41,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 274.53,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 272.5,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 272.62,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 270.59,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 270.71,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 268.68,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 268.8,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 450.6,
    y: 299.72,
    width: 13.3,
    height: 8.27,
    rx: 1.05,
    ry: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 451.33,
    y: 300.32,
    width: 11.85,
    height: 7.07,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 461.33,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 461.45,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 459.42,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 459.55,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 457.51,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 457.64,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 455.61,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 455.73,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 453.7,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 453.82,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 451.79,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 451.91,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1017.78,
    y: 299.72,
    width: 13.3,
    height: 8.27,
    rx: 1.05,
    ry: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1018.51,
    y: 300.32,
    width: 11.85,
    height: 7.07,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1028.51,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1028.63,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1026.6,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1026.72,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1024.69,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1024.81,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1022.78,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1022.9,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1020.87,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1020.99,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1018.96,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1019.09,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1200.54,
    y: 299.72,
    width: 13.3,
    height: 8.27,
    rx: 1.05,
    ry: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 1201.27,
    y: 300.32,
    width: 11.85,
    height: 7.07,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1211.27,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1211.39,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1209.36,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1209.48,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1207.45,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1207.57,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1205.54,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1205.67,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1203.63,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1203.76,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1201.73,
    y: 301,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1201.85,
    y: 301.11,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 450.6,
    y: 40.57,
    width: 13.3,
    height: 8.27,
    rx: 1.05,
    ry: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 451.33,
    y: 41.17,
    width: 11.85,
    height: 7.07,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 461.33,
    y: 41.84,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 461.45,
    y: 41.96,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 459.42,
    y: 41.84,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 459.55,
    y: 41.96,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 457.51,
    y: 41.84,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 457.64,
    y: 41.96,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 455.61,
    y: 41.84,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 455.73,
    y: 41.96,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 453.7,
    y: 41.84,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 453.82,
    y: 41.96,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 451.79,
    y: 41.84,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 451.91,
    y: 41.96,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1200.54,
    y: 40.57,
    width: 13.3,
    height: 8.27,
    rx: 1.05,
    ry: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 1201.27,
    y: 41.17,
    width: 11.85,
    height: 7.07,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1211.27,
    y: 41.84,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1211.39,
    y: 41.96,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1209.36,
    y: 41.84,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1209.48,
    y: 41.96,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1207.45,
    y: 41.84,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1207.57,
    y: 41.96,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1205.54,
    y: 41.84,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1205.67,
    y: 41.96,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1203.63,
    y: 41.84,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1203.76,
    y: 41.96,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1201.73,
    y: 41.84,
    width: 1.39,
    height: 5.72,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1201.85,
    y: 41.96,
    width: 0.93,
    height: 1.63,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1532.55,250.13h5.4v53.64h-5.4c-2.76,0-5.01-2.24-5.01-5.01v-43.62c0-2.76,2.24-5.01,5.01-5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1534.09,252.16h3.87v49.6h-3.87c-2.76,0-5.01-2.24-5.01-5.01v-39.58c0-2.76,2.24-5.01,5.01-5.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1529.08,
    y: 268.68,
    width: 8.88,
    height: 16.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1533.37,285.92h.11c2.47,0,4.48,2.01,4.48,4.48v6.09c0,2.47-2.01,4.48-4.48,4.48h-.11c-1.13,0-2.05-.92-2.05-2.05v-10.94c0-1.13.92-2.05,2.05-2.05Z",
    transform: "translate(3069.28 586.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1536.38,
    y: 287.05,
    width: 0.99,
    height: 12.8,
    rx: 0.41,
    ry: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 1536.47,
    y: 287.3,
    width: 0.66,
    height: 3.64,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1535.02,
    y: 287.05,
    width: 0.99,
    height: 12.8,
    rx: 0.41,
    ry: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 1535.11,
    y: 287.3,
    width: 0.66,
    height: 3.64,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1533.66,
    y: 287.05,
    width: 0.99,
    height: 12.8,
    rx: 0.41,
    ry: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1534.03,287.3h.11c.15,0,.28.12.28.28v3.08c0,.15-.12.28-.28.28h-.11c-.15,0-.28-.12-.28-.28v-3.08c0-.15.12-.28.28-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1533.37,252.94h.11c2.47,0,4.48,2.01,4.48,4.48v6.09c0,2.47-2.01,4.48-4.48,4.48h-.11c-1.13,0-2.05-.92-2.05-2.05v-10.94c0-1.13.92-2.05,2.05-2.05Z",
    transform: "translate(3069.28 520.93) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1536.38,
    y: 254.06,
    width: 0.99,
    height: 12.8,
    rx: 0.41,
    ry: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1536.75,254.32h.11c.15,0,.28.12.28.28v3.08c0,.15-.12.28-.28.28h-.11c-.15,0-.28-.12-.28-.28v-3.08c0-.15.12-.28.28-.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1535.02,
    y: 254.06,
    width: 0.99,
    height: 12.8,
    rx: 0.41,
    ry: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1535.39,254.32h.11c.15,0,.28.12.28.28v3.08c0,.15-.12.28-.28.28h-.11c-.15,0-.28-.12-.28-.28v-3.08c0-.15.12-.28.28-.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1533.66,
    y: 254.06,
    width: 0.99,
    height: 12.8,
    rx: 0.41,
    ry: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1534.03,254.32h.11c.15,0,.28.12.28.28v3.08c0,.15-.12.28-.28.28h-.11c-.15,0-.28-.12-.28-.28v-3.08c0-.15.12-.28.28-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1533.01,269.43h.79c2.29,0,4.15,1.86,4.15,4.15v6.76c0,2.29-1.86,4.15-4.15,4.15h-.79c-1.05,0-1.9-.85-1.9-1.9v-11.25c0-1.05.85-1.9,1.9-1.9Z",
    transform: "translate(3069.07 553.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1536.33,
    y: 270.55,
    width: 1.02,
    height: 12.81,
    rx: 0.42,
    ry: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1536.43,
    y: 270.8,
    width: 0.68,
    height: 3.64,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1534.93,
    y: 270.55,
    width: 1.02,
    height: 12.81,
    rx: 0.42,
    ry: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1535.02,
    y: 270.8,
    width: 0.68,
    height: 3.64,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1533.52,
    y: 270.55,
    width: 1.02,
    height: 12.81,
    rx: 0.42,
    ry: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1533.61,
    y: 270.8,
    width: 0.68,
    height: 3.64,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M444.77,312.61c-3.35-35.39-34.13-62.48-71-62.48h-15.79c-36.86,0-67.65,27.09-71,62.48l-3.54,37.37,18.03,2.05,2.21-30.08c2.64-33.41,26.9-58.98,55.96-58.98h12.44c29.06,0,53.32,25.57,55.96,58.98l2.21,30.08,18.03-2.05-3.54-37.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M1195.17,312.61c-3.35-35.39-34.13-62.48-71-62.48h-15.79c-36.86,0-67.65,27.09-71,62.48l-3.54,37.37,18.03,2.05,2.21-30.08c2.64-33.41,26.9-58.98,55.96-58.98h12.44c29.06,0,53.32,25.57,55.96,58.98l2.21,30.08,18.03-2.05-3.54-37.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M24.7,245.41h22.41c16.4,0,29.7-13.3,29.7-29.7v-125.41c0-9.22-7.47-16.69-16.69-16.69h-9.72c-14.41,40.51-22.98,101.5-25.7,171.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 95.42,
    y: 311.66,
    width: 169.42,
    height: 38.32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.42 311.66 100.89 317.13 100.89 311.66 95.42 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.42 317.13 100.89 322.61 100.89 317.13 95.42 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.42 322.61 100.89 328.08 100.89 322.61 95.42 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.42 328.08 100.89 333.56 100.89 328.08 95.42 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.42 333.56 100.89 339.03 100.89 333.56 95.42 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.42 339.03 100.89 344.51 100.89 339.03 95.42 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "95.42 344.51 100.89 349.98 100.89 344.51 95.42 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.89 311.66 106.35 317.13 106.35 311.66 100.89 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.89 317.13 106.35 322.61 106.35 317.13 100.89 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.89 322.61 106.35 328.08 106.35 322.61 100.89 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.89 328.08 106.35 333.56 106.35 328.08 100.89 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.89 333.56 106.35 339.03 106.35 333.56 100.89 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.89 339.03 106.35 344.51 106.35 339.03 100.89 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "100.89 344.51 106.35 349.98 106.35 344.51 100.89 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.35 311.66 111.82 317.13 111.82 311.66 106.35 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.35 317.13 111.82 322.61 111.82 317.13 106.35 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.35 322.61 111.82 328.08 111.82 322.61 106.35 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.35 328.08 111.82 333.56 111.82 328.08 106.35 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.35 333.56 111.82 339.03 111.82 333.56 106.35 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.35 339.03 111.82 344.51 111.82 339.03 106.35 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "106.35 344.51 111.82 349.98 111.82 344.51 106.35 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.82 311.66 117.28 317.13 117.28 311.66 111.82 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.82 317.13 117.28 322.61 117.28 317.13 111.82 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.82 322.61 117.28 328.08 117.28 322.61 111.82 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.82 328.08 117.28 333.56 117.28 328.08 111.82 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.82 333.56 117.28 339.03 117.28 333.56 111.82 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.82 339.03 117.28 344.51 117.28 339.03 111.82 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "111.82 344.51 117.28 349.98 117.28 344.51 111.82 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.28 311.66 122.75 317.13 122.75 311.66 117.28 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.28 317.13 122.75 322.61 122.75 317.13 117.28 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.28 322.61 122.75 328.08 122.75 322.61 117.28 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.28 328.08 122.75 333.56 122.75 328.08 117.28 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.28 333.56 122.75 339.03 122.75 333.56 117.28 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.28 339.03 122.75 344.51 122.75 339.03 117.28 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "117.28 344.51 122.75 349.98 122.75 344.51 117.28 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.75 311.66 128.21 317.13 128.21 311.66 122.75 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.75 317.13 128.21 322.61 128.21 317.13 122.75 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.75 322.61 128.21 328.08 128.21 322.61 122.75 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.75 328.08 128.21 333.56 128.21 328.08 122.75 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.75 333.56 128.21 339.03 128.21 333.56 122.75 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.75 339.03 128.21 344.51 128.21 339.03 122.75 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "122.75 344.51 128.21 349.98 128.21 344.51 122.75 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.21 311.66 133.68 317.13 133.68 311.66 128.21 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.21 317.13 133.68 322.61 133.68 317.13 128.21 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.21 322.61 133.68 328.08 133.68 322.61 128.21 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.21 328.08 133.68 333.56 133.68 328.08 128.21 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.21 333.56 133.68 339.03 133.68 333.56 128.21 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.21 339.03 133.68 344.51 133.68 339.03 128.21 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "128.21 344.51 133.68 349.98 133.68 344.51 128.21 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.68 311.66 139.14 317.13 139.14 311.66 133.68 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.68 317.13 139.14 322.61 139.14 317.13 133.68 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.68 322.61 139.14 328.08 139.14 322.61 133.68 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.68 328.08 139.14 333.56 139.14 328.08 133.68 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.68 333.56 139.14 339.03 139.14 333.56 133.68 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.68 339.03 139.14 344.51 139.14 339.03 133.68 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "133.68 344.51 139.14 349.98 139.14 344.51 133.68 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.14 311.66 144.61 317.13 144.61 311.66 139.14 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.14 317.13 144.61 322.61 144.61 317.13 139.14 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.14 322.61 144.61 328.08 144.61 322.61 139.14 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.14 328.08 144.61 333.56 144.61 328.08 139.14 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.14 333.56 144.61 339.03 144.61 333.56 139.14 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.14 339.03 144.61 344.51 144.61 339.03 139.14 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "139.14 344.51 144.61 349.98 144.61 344.51 139.14 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.61 311.66 150.07 317.13 150.07 311.66 144.61 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.61 317.13 150.07 322.61 150.07 317.13 144.61 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.61 322.61 150.07 328.08 150.07 322.61 144.61 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.61 328.08 150.07 333.56 150.07 328.08 144.61 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.61 333.56 150.07 339.03 150.07 333.56 144.61 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.61 339.03 150.07 344.51 150.07 339.03 144.61 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "144.61 344.51 150.07 349.98 150.07 344.51 144.61 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.07 311.66 155.54 317.13 155.54 311.66 150.07 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.07 317.13 155.54 322.61 155.54 317.13 150.07 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.07 322.61 155.54 328.08 155.54 322.61 150.07 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.07 328.08 155.54 333.56 155.54 328.08 150.07 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.07 333.56 155.54 339.03 155.54 333.56 150.07 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.07 339.03 155.54 344.51 155.54 339.03 150.07 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "150.07 344.51 155.54 349.98 155.54 344.51 150.07 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.54 311.66 161 317.13 161 311.66 155.54 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.54 317.13 161 322.61 161 317.13 155.54 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.54 322.61 161 328.08 161 322.61 155.54 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.54 328.08 161 333.56 161 328.08 155.54 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.54 333.56 161 339.03 161 333.56 155.54 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.54 339.03 161 344.51 161 339.03 155.54 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "155.54 344.51 161 349.98 161 344.51 155.54 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "161 311.66 166.47 317.13 166.47 311.66 161 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "161 317.13 166.47 322.61 166.47 317.13 161 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "161 322.61 166.47 328.08 166.47 322.61 161 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "161 328.08 166.47 333.56 166.47 328.08 161 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "161 333.56 166.47 339.03 166.47 333.56 161 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "161 339.03 166.47 344.51 166.47 339.03 161 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "161 344.51 166.47 349.98 166.47 344.51 161 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.47 311.66 171.93 317.13 171.93 311.66 166.47 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.47 317.13 171.93 322.61 171.93 317.13 166.47 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.47 322.61 171.93 328.08 171.93 322.61 166.47 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.47 328.08 171.93 333.56 171.93 328.08 166.47 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.47 333.56 171.93 339.03 171.93 333.56 166.47 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.47 339.03 171.93 344.51 171.93 339.03 166.47 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "166.47 344.51 171.93 349.98 171.93 344.51 166.47 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.93 311.66 177.4 317.13 177.4 311.66 171.93 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.93 317.13 177.4 322.61 177.4 317.13 171.93 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.93 322.61 177.4 328.08 177.4 322.61 171.93 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.93 328.08 177.4 333.56 177.4 328.08 171.93 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.93 333.56 177.4 339.03 177.4 333.56 171.93 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.93 339.03 177.4 344.51 177.4 339.03 171.93 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "171.93 344.51 177.4 349.98 177.4 344.51 171.93 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.4 311.66 182.86 317.13 182.86 311.66 177.4 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.4 317.13 182.86 322.61 182.86 317.13 177.4 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.4 322.61 182.86 328.08 182.86 322.61 177.4 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.4 328.08 182.86 333.56 182.86 328.08 177.4 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.4 333.56 182.86 339.03 182.86 333.56 177.4 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.4 339.03 182.86 344.51 182.86 339.03 177.4 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "177.4 344.51 182.86 349.98 182.86 344.51 177.4 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.86 311.66 188.33 317.13 188.33 311.66 182.86 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.86 317.13 188.33 322.61 188.33 317.13 182.86 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.86 322.61 188.33 328.08 188.33 322.61 182.86 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.86 328.08 188.33 333.56 188.33 328.08 182.86 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.86 333.56 188.33 339.03 188.33 333.56 182.86 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.86 339.03 188.33 344.51 188.33 339.03 182.86 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.86 344.51 188.33 349.98 188.33 344.51 182.86 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.33 311.66 193.79 317.13 193.79 311.66 188.33 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.33 317.13 193.79 322.61 193.79 317.13 188.33 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.33 322.61 193.79 328.08 193.79 322.61 188.33 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.33 328.08 193.79 333.56 193.79 328.08 188.33 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.33 333.56 193.79 339.03 193.79 333.56 188.33 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.33 339.03 193.79 344.51 193.79 339.03 188.33 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "188.33 344.51 193.79 349.98 193.79 344.51 188.33 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.79 311.66 199.26 317.13 199.26 311.66 193.79 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.79 317.13 199.26 322.61 199.26 317.13 193.79 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.79 322.61 199.26 328.08 199.26 322.61 193.79 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.79 328.08 199.26 333.56 199.26 328.08 193.79 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.79 333.56 199.26 339.03 199.26 333.56 193.79 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.79 339.03 199.26 344.51 199.26 339.03 193.79 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "193.79 344.51 199.26 349.98 199.26 344.51 193.79 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.26 311.66 204.72 317.13 204.72 311.66 199.26 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.26 317.13 204.72 322.61 204.72 317.13 199.26 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.26 322.61 204.72 328.08 204.72 322.61 199.26 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.26 328.08 204.72 333.56 204.72 328.08 199.26 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.26 333.56 204.72 339.03 204.72 333.56 199.26 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.26 339.03 204.72 344.51 204.72 339.03 199.26 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.26 344.51 204.72 349.98 204.72 344.51 199.26 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.72 311.66 210.19 317.13 210.19 311.66 204.72 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.72 317.13 210.19 322.61 210.19 317.13 204.72 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.72 322.61 210.19 328.08 210.19 322.61 204.72 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.72 328.08 210.19 333.56 210.19 328.08 204.72 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.72 333.56 210.19 339.03 210.19 333.56 204.72 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.72 339.03 210.19 344.51 210.19 339.03 204.72 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "204.72 344.51 210.19 349.98 210.19 344.51 204.72 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.19 311.66 215.65 317.13 215.65 311.66 210.19 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.19 317.13 215.65 322.61 215.65 317.13 210.19 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.19 322.61 215.65 328.08 215.65 322.61 210.19 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.19 328.08 215.65 333.56 215.65 328.08 210.19 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.19 333.56 215.65 339.03 215.65 333.56 210.19 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.19 339.03 215.65 344.51 215.65 339.03 210.19 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "210.19 344.51 215.65 349.98 215.65 344.51 210.19 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.65 311.66 221.12 317.13 221.12 311.66 215.65 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.65 317.13 221.12 322.61 221.12 317.13 215.65 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.65 322.61 221.12 328.08 221.12 322.61 215.65 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.65 328.08 221.12 333.56 221.12 328.08 215.65 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.65 333.56 221.12 339.03 221.12 333.56 215.65 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.65 339.03 221.12 344.51 221.12 339.03 215.65 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "215.65 344.51 221.12 349.98 221.12 344.51 215.65 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.12 311.66 226.58 317.13 226.58 311.66 221.12 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.12 317.13 226.58 322.61 226.58 317.13 221.12 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.12 322.61 226.58 328.08 226.58 322.61 221.12 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.12 328.08 226.58 333.56 226.58 328.08 221.12 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.12 333.56 226.58 339.03 226.58 333.56 221.12 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.12 339.03 226.58 344.51 226.58 339.03 221.12 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "221.12 344.51 226.58 349.98 226.58 344.51 221.12 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.58 311.66 232.05 317.13 232.05 311.66 226.58 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.58 317.13 232.05 322.61 232.05 317.13 226.58 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.58 322.61 232.05 328.08 232.05 322.61 226.58 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.58 328.08 232.05 333.56 232.05 328.08 226.58 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.58 333.56 232.05 339.03 232.05 333.56 226.58 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.58 339.03 232.05 344.51 232.05 339.03 226.58 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.58 344.51 232.05 349.98 232.05 344.51 226.58 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.05 311.66 237.51 317.13 237.51 311.66 232.05 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.05 317.13 237.51 322.61 237.51 317.13 232.05 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.05 322.61 237.51 328.08 237.51 322.61 232.05 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.05 328.08 237.51 333.56 237.51 328.08 232.05 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.05 333.56 237.51 339.03 237.51 333.56 232.05 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.05 339.03 237.51 344.51 237.51 339.03 232.05 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "232.05 344.51 237.51 349.98 237.51 344.51 232.05 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.51 311.66 242.98 317.13 242.98 311.66 237.51 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.51 317.13 242.98 322.61 242.98 317.13 237.51 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.51 322.61 242.98 328.08 242.98 322.61 237.51 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.51 328.08 242.98 333.56 242.98 328.08 237.51 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.51 333.56 242.98 339.03 242.98 333.56 237.51 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.51 339.03 242.98 344.51 242.98 339.03 237.51 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "237.51 344.51 242.98 349.98 242.98 344.51 237.51 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "242.98 311.66 248.44 317.13 248.44 311.66 242.98 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "242.98 317.13 248.44 322.61 248.44 317.13 242.98 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "242.98 322.61 248.44 328.08 248.44 322.61 242.98 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "242.98 328.08 248.44 333.56 248.44 328.08 242.98 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "242.98 333.56 248.44 339.03 248.44 333.56 242.98 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "242.98 339.03 248.44 344.51 248.44 339.03 242.98 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "242.98 344.51 248.44 349.98 248.44 344.51 242.98 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.44 311.66 253.91 317.13 253.91 311.66 248.44 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.44 317.13 253.91 322.61 253.91 317.13 248.44 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.44 322.61 253.91 328.08 253.91 322.61 248.44 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.44 328.08 253.91 333.56 253.91 328.08 248.44 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.44 333.56 253.91 339.03 253.91 333.56 248.44 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.44 339.03 253.91 344.51 253.91 339.03 248.44 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "248.44 344.51 253.91 349.98 253.91 344.51 248.44 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "253.91 311.66 259.37 317.13 259.37 311.66 253.91 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "253.91 317.13 259.37 322.61 259.37 317.13 253.91 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "253.91 322.61 259.37 328.08 259.37 322.61 253.91 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "253.91 328.08 259.37 333.56 259.37 328.08 253.91 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "253.91 333.56 259.37 339.03 259.37 333.56 253.91 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "253.91 339.03 259.37 344.51 259.37 339.03 253.91 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "253.91 344.51 259.37 349.98 259.37 344.51 253.91 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.37 311.66 264.84 317.13 264.84 311.66 259.37 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.37 317.13 264.84 322.61 264.84 317.13 259.37 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.37 322.61 264.84 328.08 264.84 322.61 259.37 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.37 328.08 264.84 333.56 264.84 328.08 259.37 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.37 333.56 264.84 339.03 264.84 333.56 259.37 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.37 339.03 264.84 344.51 264.84 339.03 259.37 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "259.37 344.51 264.84 349.98 264.84 344.51 259.37 344.51"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 95.42,
    y: 311.66,
    width: 169.42,
    height: 32.49,
    transform: "translate(360.26 655.81) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M175.82,313.66c-1.18,0-2.14-.96-2.14-2.14,0-38.77-31.54-70.31-70.31-70.31-1.18,0-2.14-.96-2.14-2.14s.96-2.14,2.14-2.14c41.13,0,74.58,33.46,74.58,74.59,0,1.18-.96,2.14-2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M173.89,315.59c-1.18,0-2.14-.96-2.14-2.14,0-38.77-31.54-70.31-70.31-70.31-1.18,0-2.14-.96-2.14-2.14s.96-2.14,2.14-2.14c41.13,0,74.58,33.46,74.58,74.58,0,1.18-.96,2.14-2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M184.44,313.66c1.18,0,2.14-.96,2.14-2.14,0-38.77,31.54-70.31,70.3-70.31,1.18,0,2.14-.96,2.14-2.14s-.96-2.14-2.14-2.14c-41.13,0-74.58,33.46-74.58,74.59,0,1.18.96,2.14,2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M186.37,315.59c1.18,0,2.14-.96,2.14-2.14,0-38.77,31.54-70.31,70.3-70.31,1.18,0,2.14-.96,2.14-2.14s-.96-2.14-2.14-2.14c-41.13,0-74.58,33.46-74.58,74.58,0,1.18.96,2.14,2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 97.13,
    y: 86.54,
    width: 165.99,
    height: 257.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M97.13,86.54v257.6h165.99V86.54H97.13ZM163.01,338.64h-48.76c-4.61,0-8.35-3.74-8.35-8.35V115.11c0-5.65,4.58-10.23,10.23-10.23h45c5.65,0,10.23,4.58,10.23,10.23v215.18c0,4.61-3.74,8.35-8.35,8.35ZM246.01,338.64h-48.76c-4.61,0-8.35-3.74-8.35-8.35V115.11c0-5.65,4.58-10.23,10.23-10.23h45c5.65,0,10.23,4.58,10.23,10.23v215.18c0,4.61-3.74,8.35-8.35,8.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "264.84 86.54 95.42 86.54 95.42 349.98 98.84 349.98 98.84 89.97 178.42 89.97 178.42 344.15 181.84 344.15 181.84 89.97 261.42 89.97 261.42 349.98 264.84 349.98 264.84 86.54"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M131.99,170.34l-9.16,3.64c-5.57,2.21-11.61-1.89-11.61-7.88v-45.25c0-4.68,3.8-8.48,8.48-8.48h37.38c4.68,0,8.48,3.8,8.48,8.48h0c0,21.81-13.3,41.42-33.57,49.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M216.4,170.34l-9.16,3.64c-5.57,2.21-11.61-1.89-11.61-7.88v-45.25c0-4.68,3.8-8.48,8.48-8.48h37.39c4.68,0,8.48,3.8,8.48,8.48h0c0,21.81-13.3,41.42-33.57,49.48Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 95.42,
    y: 48.21,
    width: 169.42,
    height: 35.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M117.77,75.32s-.07.07-.1.11c-.03-.04-.06-.07-.1-.11-.53-.53-1.49-.54-2.02,0-.03.03-.05.05-.08.08-.02-.03-.05-.06-.08-.08-.53-.53-1.5-.52-2.01,0-.04.04-.08.08-.11.13-.03-.04-.07-.09-.11-.13-.53-.53-1.49-.53-2.01,0-.04.04-.08.08-.11.13-.03-.04-.07-.08-.11-.12-.53-.53-1.49-.53-2.01,0-.07.07-.14.15-.19.24-.05-.09-.12-.16-.19-.24-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.02.06-.05.08-.08.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.06-.06-.12-.11-.19-.16.07-.05.13-.1.19-.16.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.26.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.02.06-.05.08-.08.27-.27.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.08-.08-.13-.11.04-.03.08-.07.12-.11.27-.26.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.08-.07-.12-.11.04-.03.08-.07.13-.11.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.53-.53-1.49-.53-2.01,0-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.08.08.12.11-.04.03-.08.07-.12.11-.27.27-.41.61-.41,1.01s.14.75.4,1.01c.04.04.08.08.13.11-.04.03-.08.07-.12.11-.27.26-.41.61-.41,1.01s.14.74.41,1.01c.03.03.05.05.08.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.75.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.26-.41.61-.41,1.01s.14.75.4,1c.05.05.09.09.14.13-.05.04-.1.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.4,1.01c.06.06.12.11.19.16-.07.05-.13.1-.18.15-.27.26-.41.61-.41,1.01s.14.75.4,1c.03.03.06.06.09.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.26-.41.61-.41,1.01s.14.75.4,1c.53.53,1.49.53,2.01,0,.07-.07.14-.15.19-.24.05.08.12.16.19.24.53.53,1.49.53,2.01,0,.04-.04.08-.08.11-.13.04.04.07.08.11.12.53.53,1.48.53,2.02,0,.04-.04.08-.08.11-.12.03.04.07.08.11.12.53.53,1.49.54,2.02,0,.03-.03.05-.05.08-.08.02.03.05.06.08.08.53.53,1.5.52,2.01,0,.04-.04.07-.07.1-.11.03.04.06.08.1.11.27.27.61.41,1.01.41s.75-.14,1.01-.4c.27-.26.41-.61.41-1.01s-.14-.75-.4-1.01c-.53-.53-1.48-.54-2.02,0ZM141.37,66.27c0-.39-.14-.74-.4-1.01-.03-.03-.06-.06-.09-.09.24-.26.36-.59.36-.96,0-.39-.14-.74-.41-1.01-.07-.07-.14-.13-.22-.18.19-.24.29-.54.29-.87,0-.39-.14-.74-.41-1.01-.19-.19-.42-.32-.68-.37.12-.21.19-.46.19-.72,0-.39-.14-.74-.41-1.01-.27-.26-.61-.4-1.01-.4.04-.13.06-.27.06-.42,0-.39-.14-.74-.41-1.01-.3-.3-.73-.44-1.15-.4v-.04c0-.39-.14-.74-.41-1.01-.49-.49-1.36-.53-1.9-.1-.05-.29-.18-.55-.38-.75-.51-.52-1.44-.54-1.98-.04-.06-.1-.13-.19-.22-.28-.53-.53-1.48-.53-2.02,0-.11.11-.2.23-.26.37-.01-.02-.03-.04-.05-.05-.53-.53-1.48-.53-2.02,0-.21.21-.34.46-.39.75-.53-.42-1.39-.39-1.9.11-.26.27-.4.61-.4,1.01v.04c-.42-.04-.85.1-1.15.4-.27.27-.41.61-.41,1.01,0,.15.02.29.06.42-.39,0-.74.14-1.01.41-.26.27-.4.61-.4,1.01,0,.27.06.51.19.72-.26.06-.49.18-.69.37-.26.27-.4.61-.4,1.01,0,.32.1.62.28.86-.08.05-.16.12-.23.19-.27.27-.41.61-.41,1.01s.13.72.38.98c-.02.02-.05.04-.07.06-.27.27-.41.61-.41,1.01s.14.75.4,1c.02.02.05.05.07.07-.22.26-.34.58-.34.94,0,.39.14.74.41,1.01.04.04.09.08.14.12-.15.23-.23.5-.23.79,0,.39.14.74.41,1.01.19.19.42.31.68.37-.12.21-.19.46-.19.72,0,.39.14.74.41,1.01.27.27.61.41,1.01.41-.04.13-.06.27-.06.42,0,.4.14.75.4,1,.3.3.74.44,1.16.4v.04c0,.39.14.74.41,1.01.5.49,1.36.53,1.9.1.05.29.18.55.39.75.53.53,1.48.53,2.01,0,.02-.02.03-.04.05-.05.06.13.15.26.26.37.27.27.61.41,1.01.41s.74-.14,1.01-.41c.08-.08.16-.18.22-.28.54.5,1.47.48,1.97-.04.21-.21.34-.46.39-.76.53.42,1.4.39,1.9-.11.27-.27.41-.61.41-1.01v-.04c.44.04.86-.1,1.15-.4.27-.26.41-.61.41-1.01,0-.15-.02-.29-.06-.42.39,0,.74-.14,1.01-.41.26-.27.4-.61.4-1.01,0-.26-.06-.51-.19-.72.26-.06.5-.18.69-.37.27-.27.41-.61.41-1.01,0-.29-.08-.55-.22-.78.05-.04.11-.08.15-.13.27-.27.41-.61.41-1.01,0-.36-.12-.68-.34-.94.02-.02.05-.04.07-.07.26-.26.4-.61.4-1.01ZM138.89,67.21s-.05.04-.07.07c-.27.27-.41.61-.41,1.01,0,.29.08.56.22.78-.06.04-.11.09-.16.14-.26.27-.4.61-.4,1.01,0,.26.06.51.19.72-.26.06-.49.18-.69.37-.26.27-.4.61-.4,1.01,0,.15.02.29.06.42-.4,0-.75.14-1.01.4-.27.26-.41.61-.41,1.01v.04c-.43-.04-.86.1-1.15.4-.21.21-.34.46-.39.75-.53-.43-1.4-.39-1.9.11-.08.08-.16.18-.22.28-.53-.49-1.45-.48-1.98.04-.02.02-.03.03-.05.05-.07-.13-.15-.26-.26-.37-.27-.27-.61-.41-1.01-.41-.34,0-.64.1-.89.3-.05-.29-.18-.55-.38-.75-.3-.3-.73-.44-1.16-.4v-.04c0-.39-.14-.74-.41-1.01-.27-.27-.61-.41-1.01-.41.04-.13.06-.27.06-.42,0-.39-.14-.74-.41-1.01-.19-.19-.42-.31-.68-.37.12-.21.19-.46.19-.72,0-.39-.14-.74-.41-1.01-.04-.04-.09-.08-.14-.12.15-.23.23-.5.23-.79,0-.39-.14-.74-.41-1.01-.02-.02-.04-.04-.07-.06.22-.25.34-.58.34-.94,0-.38-.13-.72-.38-.98.02-.02.05-.04.07-.07.26-.27.4-.61.4-1.01,0-.32-.09-.62-.28-.86.08-.05.16-.12.23-.19.27-.27.41-.61.41-1.01,0-.27-.06-.51-.19-.72.26-.06.49-.18.68-.37.27-.26.41-.61.41-1.01,0-.15-.02-.29-.06-.42.39,0,.74-.14,1.01-.41.26-.27.4-.61.4-1.01v-.04c.42.03.86-.1,1.15-.4.21-.21.34-.46.39-.75.54.43,1.4.39,1.9-.1.11-.11.2-.23.26-.37.02.02.03.04.05.05.52.52,1.43.53,1.97.03.06.1.13.2.22.28.49.49,1.36.53,1.9.1.05.29.18.55.39.75.3.3.72.43,1.15.4v.04c0,.39.14.74.4,1.01.26.27.61.41,1.01.41-.04.13-.06.27-.06.42,0,.39.14.74.41,1.01.19.19.42.32.68.37-.12.21-.19.46-.19.72,0,.39.14.74.41,1.01.07.07.14.13.22.18-.19.24-.29.54-.29.87,0,.39.14.74.41,1.01.03.03.06.06.09.09-.24.26-.37.59-.37.96s.12.69.34.94ZM160.79,69.72c-.27.27-.41.61-.41,1.01,0,.33.1.63.3.88-.22.06-.42.18-.59.35-.27.27-.41.61-.41,1.01,0,.08,0,.17.02.24-.33.03-.63.17-.85.4-.27.27-.41.61-.41,1.01,0,.02,0,.03,0,.05-.5-.18-1.13-.07-1.52.32-.26.26-.4.61-.4.99-.06-.11-.14-.21-.23-.3-.53-.53-1.47-.53-2.02,0-.09.09-.17.2-.23.31-.06-.11-.14-.22-.24-.32-.53-.53-1.48-.53-2.01,0-.07-.21-.18-.4-.34-.56-.4-.41-1.07-.51-1.58-.29,0-.38-.15-.71-.41-.97-.27-.27-.6-.44-1.06-.4.04-.14.06-.29.06-.44,0-.4-.14-.75-.4-1.01-.22-.22-.5-.36-.81-.4.11-.21.17-.44.17-.7,0-.39-.14-.74-.4-1.01-.14-.14-.31-.25-.49-.32.23-.26.36-.59.36-.96,0-.39-.14-.74-.41-1.01-.1-.1-.21-.18-.34-.25.11-.06.2-.13.29-.22.27-.27.41-.61.41-1.01s-.14-.74-.4-1.01c-.02-.02-.05-.05-.07-.07.09-.06.18-.12.25-.2.27-.27.41-.61.41-1.01,0-.34-.1-.64-.3-.89.16-.07.31-.17.43-.29.27-.26.41-.61.41-1.01,0-.23-.05-.45-.14-.65.28-.05.53-.18.73-.38.26-.26.4-.61.4-1.01,0-.14-.02-.27-.05-.4.41.03.83-.11,1.12-.4.25-.25.39-.58.4-.95.49.15,1.08.03,1.45-.34.18-.18.31-.41.37-.66.53.42,1.4.38,1.89-.11.11-.11.19-.22.25-.35.06.1.13.2.22.29.53.53,1.48.53,2.01,0,.02-.02.04-.05.07-.07.07.16.17.31.29.43.4.4,1.06.51,1.57.3.03.33.17.62.4.86.29.29.7.43,1.11.4.03.34.16.65.4.89.53.53,1.49.52,2.01,0,.27-.27.41-.61.41-1.01s-.14-.75-.4-1.01c-.29-.29-.7-.43-1.12-.41-.03-.34-.16-.65-.4-.89-.4-.4-1.06-.51-1.57-.3-.03-.33-.17-.63-.4-.85-.53-.53-1.49-.53-2.01,0-.02.02-.05.05-.07.07-.07-.16-.17-.31-.29-.43-.53-.53-1.48-.53-2.02,0-.1.1-.19.22-.25.35-.06-.1-.13-.19-.22-.28-.53-.54-1.49-.53-2.01,0-.19.18-.31.41-.37.66-.53-.42-1.4-.39-1.89.11-.25.25-.39.58-.4.95-.49-.15-1.08-.03-1.45.34-.27.27-.41.61-.41,1.01,0,.14.02.27.05.4-.41-.04-.82.11-1.11.4-.27.27-.41.61-.41,1.01,0,.23.05.45.14.65-.28.05-.53.18-.73.38-.27.27-.41.61-.41,1.01,0,.34.11.65.3.89-.16.07-.31.17-.44.3-.26.27-.4.61-.4,1.01s.14.74.41,1.01l.07.06c-.09.06-.17.12-.25.2-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.1.1.21.18.34.25-.11.06-.21.14-.3.23-.26.27-.4.61-.4,1.01s.14.74.41,1.01c.14.14.31.25.5.32-.23.26-.36.59-.36.96,0,.39.14.74.41,1.01.22.22.5.35.81.39-.11.21-.17.44-.17.7,0,.4.14.75.4,1,.28.28.65.44,1.06.41-.04.14-.06.29-.06.44,0,.39.14.74.4,1.01.4.41,1.07.51,1.59.3,0,.38.15.71.41.98.53.53,1.47.53,2.01,0,.07.21.18.4.34.56.53.53,1.48.54,2.02,0,.09-.09.17-.2.23-.31.06.11.14.22.23.32.27.27.61.41,1.01.41s.74-.14,1.01-.41c.26-.26.4-.61.41-1,.06.11.13.2.22.3.53.53,1.48.53,2.02,0,.27-.27.41-.61.41-1.01,0-.02,0-.04,0-.05.51.18,1.13.07,1.52-.32.27-.27.41-.61.41-1.01,0-.08,0-.17-.02-.24.33-.03.63-.17.86-.4.27-.27.41-.61.41-1.01,0-.33-.1-.64-.29-.88.22-.06.42-.18.59-.35.27-.27.41-.61.41-1.01s-.14-.75-.41-1.01c-.53-.53-1.48-.53-2.02,0ZM182.46,75.36c-.07-.03-.14-.06-.21-.08.03-.05.06-.1.08-.15.16-.35.17-.72.03-1.08-.18-.5-.53-.72-.79-.82-.06-.02-.11-.04-.17-.05.01-.03.03-.06.04-.09.14-.33.15-.71.02-1.08,0,0,0-.01,0-.02-.15-.38-.42-.65-.79-.8-.03-.01-.06-.02-.09-.03.01-.02.02-.04.03-.07.19-.36.19-.77.02-1.15-.14-.33-.39-.59-.73-.75-.07-.03-.13-.06-.2-.08.03-.05.06-.1.08-.15.16-.35.17-.72.03-1.08-.19-.5-.53-.72-.79-.82-.03,0-.05-.02-.08-.03.02-.04.04-.09.06-.14.13-.33.13-.69,0-1.05-.14-.37-.41-.65-.77-.8-.05-.02-.1-.04-.14-.05.02-.04.05-.09.07-.13.15-.34.18-.7.06-1.05,0-.02-.02-.05-.03-.07-.16-.34-.41-.6-.75-.75-.04-.02-.08-.04-.13-.05.02-.03.03-.07.05-.11.14-.34.15-.72,0-1.08,0,0,0,0,0,0-.14-.37-.41-.64-.76-.79-.06-.02-.12-.04-.18-.06.03-.05.06-.09.08-.15.18-.37.18-.77,0-1.14-.14-.33-.38-.58-.7-.73-.04-.02-.09-.04-.14-.06.02-.05.04-.09.06-.13.12-.33.12-.69,0-1.03-.12-.38-.39-.67-.77-.82-.19-.08-.37-.1-.54-.11.02-.05.05-.1.07-.15.13-.38.13-.75-.02-1.09-.15-.34-.42-.6-.81-.75-.38-.14-.77-.13-1.11.04-.32.15-.56.4-.7.71,0,.02-.01.03-.02.05-.13.38-.13.75.02,1.08.02.05.05.11.08.15-.05.01-.1.03-.15.05-.38.15-.64.44-.77.82-.13.34-.13.7,0,1.03.02.04.04.08.06.13-.05.02-.09.04-.13.06-.32.15-.56.41-.71.73-.17.36-.17.77,0,1.14.03.05.05.1.08.15-.06.02-.12.04-.18.06-.35.15-.62.42-.76.79,0,0,0,0,0,0-.14.36-.14.73,0,1.08.01.03.03.07.05.1-.04.01-.09.03-.13.05-.33.15-.58.41-.74.75-.01.02-.02.05-.03.07-.12.35-.09.71.06,1.05.02.05.04.09.07.13-.05.01-.1.03-.15.05-.36.15-.62.43-.77.8-.14.35-.14.72,0,1.05.02.05.04.1.06.14-.03,0-.05.02-.08.03-.37.14-.64.43-.79.82-.14.35-.13.72.03,1.08.02.05.05.1.08.15-.07.02-.14.04-.21.08-.34.16-.59.41-.73.75-.17.38-.16.79.02,1.15.01.02.02.04.04.07-.03,0-.07.02-.1.03-.37.14-.64.41-.78.79,0,0,0,.01,0,.02-.13.37-.13.75.02,1.08.01.03.03.06.04.09-.06.01-.12.03-.18.05-.26.1-.6.32-.78.82-.14.35-.13.73.03,1.08.02.05.05.1.08.15-.07.02-.14.04-.2.08-.33.15-.59.41-.73.75-.17.39-.17.79.02,1.15.16.31.41.54.75.7.18.07.37.1.55.1.17,0,.34-.03.51-.09.39-.14.67-.44.78-.8.14-.35.14-.72.01-1.06-.02-.06-.06-.13-.09-.2.07-.02.13-.05.2-.08.31-.15.56-.39.74-.75.15-.35.14-.73-.02-1.1-.01-.03-.03-.06-.04-.09.09-.02.17-.05.25-.09.32-.15.56-.4.72-.76.14-.38.13-.76-.02-1.09-.02-.04-.04-.08-.06-.11.03,0,.05-.02.08-.03.28-.1.5-.28.64-.5.05.08.1.15.17.22.25.27.57.44,1.05.46.37-.03.7-.17.96-.42.07-.07.14-.14.19-.23.06.08.13.16.21.23.26.23.59.36,1.03.39.37-.02.7-.16.95-.4.06-.05.11-.12.17-.19.05.06.1.13.16.19.29.3.67.44,1.11.4.34-.05.63-.18.88-.38.1-.08.18-.18.25-.28.06.09.13.18.21.26.27.25.61.39.94.39h0c.4.03.78-.12,1.06-.43.08-.09.15-.19.21-.29.15.27.39.47.69.58.02,0,.05.02.07.02-.02.04-.04.07-.06.11-.15.34-.15.71,0,1.14.14.31.39.56.7.71.08.04.17.07.26.09-.02.03-.03.06-.05.1-.16.36-.16.74,0,1.14.16.32.41.56.71.71.07.03.13.06.2.08-.04.07-.07.14-.1.2-.13.34-.12.7,0,1.01.12.4.41.7.8.85.34.12.7.11,1.09-.03.3-.14.55-.37.71-.68.19-.36.19-.76.02-1.15-.14-.34-.4-.59-.73-.74ZM176.83,69.13h0c-.36.03-.68.17-.94.43-.08.08-.15.17-.21.27-.06-.1-.12-.19-.2-.27-.25-.27-.58-.41-.95-.41-.03,0-.05,0-.08,0-.38,0-.71.14-.98.39-.07.07-.13.14-.18.21-.06-.08-.12-.16-.19-.23-.26-.24-.59-.37-.97-.38-.4-.02-.77.12-1.05.41-.06.06-.11.13-.16.2-.04-.06-.09-.13-.15-.18-.25-.27-.58-.42-.94-.45-.03,0-.07,0-.1,0-.11,0-.22.03-.32.06.05-.08.11-.16.15-.26.15-.35.14-.73-.02-1.1-.01-.03-.03-.06-.05-.09.04-.01.08-.03.12-.04.34-.15.6-.42.74-.79.14-.36.14-.73,0-1.08-.02-.05-.05-.11-.08-.16.06-.02.12-.04.18-.07.33-.15.59-.41.77-.83.12-.34.1-.71-.06-1.05l-.04-.08s.09-.04.14-.06c.32-.15.57-.41.72-.77.14-.36.13-.73-.01-1.08-.03-.06-.06-.12-.09-.18.05-.01.11-.03.16-.05.26-.1.61-.32.78-.8.15-.35.15-.72,0-1.07-.01-.04-.03-.07-.05-.1.04-.02.09-.03.13-.05.18-.08.33-.19.47-.34.13.14.29.25.47.34.04.02.09.04.13.05-.02.03-.03.07-.05.1-.15.35-.15.73-.01,1.05.18.51.53.73.79.83.05.02.1.03.15.05-.03.06-.07.12-.1.18-.15.34-.15.71,0,1.1.14.34.39.6.71.75.05.02.09.04.14.06-.01.03-.03.05-.04.08-.16.34-.18.7-.03,1.12.16.35.42.61.74.75.06.03.12.05.18.07-.03.05-.05.1-.08.15-.15.35-.15.72,0,1.08.14.37.39.65.74.8.04.01.08.03.12.04-.02.03-.03.06-.05.1-.16.36-.16.74,0,1.14.04.07.08.14.12.21-.15-.04-.31-.06-.48-.05ZM178.08,69.79s-.02-.03-.03-.05c.01,0,.03.01.05.01,0,.01-.01.02-.02.03ZM195.49,55.14s-.08.08-.11.13c-.03-.04-.07-.08-.11-.12-.53-.53-1.49-.53-2.02,0-.04.04-.08.08-.11.13-.03-.04-.07-.08-.11-.12-.53-.53-1.48-.54-2.02,0-.04.04-.08.09-.12.14-.04-.05-.08-.1-.12-.14-.53-.53-1.49-.53-2.02,0-.1.1-.18.2-.24.32-.05-.08-.11-.16-.19-.23-.53-.53-1.48-.53-2.02,0-.04.04-.08.08-.11.13-.03-.04-.07-.08-.11-.13-.53-.53-1.5-.53-2.02,0-.04.04-.08.08-.11.13-.03-.04-.07-.08-.11-.12-.53-.53-1.48-.53-2.02,0-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.53.53,1.49.53,2.01,0,.04-.04.08-.08.11-.13.03.04.07.08.11.12.53.53,1.48.54,2.02,0,.04-.04.08-.08.11-.12.03.04.07.08.11.13.53.53,1.48.53,2.02,0,.1-.1.17-.2.24-.32.05.08.12.16.19.23.04.04.08.08.12.11-.04.03-.08.07-.12.11-.27.27-.41.61-.41,1.01s.14.75.4,1.01c.04.04.08.08.13.11-.04.03-.08.07-.12.11-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.03.03.05.05.08.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.75.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.4,1c.05.05.09.09.14.13-.05.04-.1.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.4,1.01c.06.06.12.11.19.16-.07.05-.13.1-.18.15-.27.27-.41.61-.41,1.01s.14.74.4,1c.03.03.06.06.09.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.4,1c.26.27.61.41,1.01.41s.74-.14,1.01-.41c.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.13.26-.27.4-.61.4-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.13.26-.27.4-.61.4-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.03.06-.05.08-.08.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.06-.06-.12-.11-.19-.16.07-.05.13-.1.19-.16.26-.27.4-.61.4-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.03.06-.05.09-.08.26-.27.4-.61.4-1.01s-.14-.74-.41-1.01c-.04-.04-.08-.08-.13-.11.04-.03.08-.07.13-.11.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.08-.07-.12-.11.04-.04.09-.07.13-.11.04-.04.08-.09.12-.14.04.05.08.1.12.14.53.53,1.49.52,2.01,0,.04-.04.08-.08.11-.13.03.04.07.08.11.13.53.53,1.49.53,2.01,0,.04-.04.08-.08.11-.13.03.04.07.09.11.13.53.53,1.48.53,2.01,0,.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.53-.53-1.48-.53-2.02,0ZM205.44,56.86c.06.11.14.21.23.3.53.53,1.48.53,2.01,0,.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.53-.53-1.48-.53-2.02,0-.09.09-.16.19-.22.29-.06-.11-.14-.2-.23-.29-.53-.53-1.48-.53-2.02,0-.1.1-.18.21-.24.33-.06-.12-.15-.23-.25-.34-.53-.53-1.48-.53-2.02,0-.26.27-.4.61-.4,1.01s.14.74.41,1.01c.53.53,1.48.53,2.01,0,.1-.1.18-.21.25-.34.06.12.15.24.25.34.04.04.08.07.12.11-.04.04-.09.07-.13.11-.26.27-.4.61-.4,1.01s.14.74.4,1.01c.04.04.08.08.13.11-.04.03-.08.07-.13.11-.26.26-.4.61-.4,1.01s.14.74.41,1.01c.03.03.05.05.08.07-.03.03-.06.05-.09.08-.26.27-.4.61-.4,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.1.08-.14.12-.26.26-.4.61-.4,1.01s.14.74.4,1.01c.04.04.09.09.14.12-.05.04-.1.08-.14.12-.26.27-.4.61-.4,1.01s.14.74.4,1.01c.06.06.12.11.19.16-.07.05-.13.1-.19.16-.26.26-.4.61-.4,1.01s.14.74.4,1.01c.03.03.06.05.08.08-.03.02-.06.05-.09.08-.26.27-.4.61-.4,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.1.08-.14.13-.26.27-.4.61-.4,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.1.08-.14.12-.1.1-.18.21-.24.32-.07-.13-.15-.24-.26-.35-.53-.53-1.47-.53-2.02,0-.26.27-.4.61-.4,1.01s.14.74.41,1.01c.53.53,1.48.53,2.01,0,.1-.1.18-.21.24-.32.06.13.15.24.25.35.27.27.61.41,1.01.41s.74-.14,1.01-.4c.09-.09.17-.2.23-.31.06.1.13.2.22.29.53.53,1.48.53,2.01,0,.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.53-.53-1.48-.53-2.01,0-.09.09-.17.19-.23.3-.06-.1-.13-.2-.22-.28-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.02.06-.05.08-.08.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.06-.06-.12-.11-.19-.16.07-.05.13-.1.19-.16.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.26.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.02.06-.05.08-.08.27-.27.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.08-.08-.13-.11.04-.03.08-.07.12-.11.27-.26.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.08-.07-.12-.11.04-.03.08-.07.13-.11.09-.09.16-.19.23-.29ZM231.25,66.27c0-.39-.14-.74-.4-1.01-.03-.03-.06-.06-.09-.09.24-.26.36-.59.36-.96,0-.39-.14-.74-.41-1.01-.07-.07-.14-.13-.22-.18.19-.24.29-.54.29-.87,0-.39-.14-.74-.41-1.01-.19-.19-.42-.32-.68-.37.12-.21.19-.46.19-.72,0-.39-.14-.74-.41-1.01-.27-.27-.61-.41-1.01-.41.04-.13.06-.27.06-.42,0-.39-.14-.74-.41-1.01-.3-.3-.72-.44-1.15-.4v-.04c0-.39-.14-.74-.41-1.01-.49-.49-1.36-.53-1.9-.1-.05-.29-.18-.55-.38-.75-.52-.52-1.45-.53-1.98-.04-.06-.1-.13-.19-.22-.28-.53-.53-1.48-.53-2.02,0-.11.11-.2.23-.26.37-.01-.02-.03-.04-.05-.05-.53-.53-1.48-.53-2.02,0-.21.21-.34.46-.39.75-.53-.43-1.41-.39-1.9.11-.27.27-.41.61-.41,1.01v.04c-.42-.04-.85.1-1.16.4-.26.27-.4.61-.4,1.01,0,.15.02.29.06.42h0c-.39,0-.74.14-1.01.41-.26.27-.4.61-.4,1.01,0,.27.06.51.19.72-.26.06-.49.18-.68.37-.27.27-.41.61-.41,1.01,0,.33.1.62.28.86-.08.05-.16.12-.23.19-.27.27-.41.61-.41,1.01s.13.72.38.98c-.02.02-.05.04-.07.06-.27.27-.41.61-.41,1.01s.14.75.4,1c.02.02.05.05.07.07-.22.26-.34.58-.34.94,0,.39.14.74.4,1.01.04.04.09.08.14.12-.15.23-.23.5-.23.79,0,.39.14.74.41,1.01.19.19.42.32.68.37-.12.21-.19.46-.19.72,0,.39.14.74.41,1.01.27.27.61.41,1.01.41h0c-.04.13-.06.27-.06.42,0,.39.14.74.4,1,.3.3.74.44,1.16.4v.04c0,.39.14.74.41,1.01.49.49,1.36.53,1.9.11.05.29.18.55.39.75.53.53,1.48.53,2.01,0,.02-.02.04-.04.05-.05.06.13.15.26.26.37.27.27.61.41,1.01.41s.74-.14,1.01-.41c.08-.08.16-.18.22-.28.53.5,1.47.48,1.97-.04.21-.21.34-.46.39-.76.54.42,1.4.39,1.9-.11.27-.27.41-.61.41-1.01v-.04c.44.04.86-.1,1.15-.4.27-.26.41-.61.41-1.01,0-.15-.02-.29-.06-.42.4,0,.75-.14,1.01-.41.27-.27.41-.61.41-1.01,0-.27-.06-.51-.19-.72.26-.06.49-.18.68-.37.27-.27.41-.61.41-1.01,0-.29-.08-.55-.22-.78.05-.04.11-.08.15-.13.27-.27.41-.61.41-1.01,0-.36-.12-.68-.34-.94.02-.02.05-.04.07-.07.26-.26.4-.61.4-1.01ZM228.77,67.21s-.05.04-.07.07c-.27.27-.41.61-.41,1.01,0,.29.08.56.22.78-.05.04-.1.08-.15.13-.27.27-.41.61-.41,1.01,0,.27.06.51.19.72-.26.06-.49.18-.69.37-.26.27-.4.61-.4,1.01,0,.15.02.29.06.42-.39,0-.74.14-1.01.4-.27.26-.41.61-.41,1.01v.04c-.43-.04-.86.1-1.15.4-.21.21-.34.46-.39.75-.53-.43-1.41-.39-1.89.1-.09.08-.16.18-.22.28-.53-.49-1.45-.48-1.98.04-.02.02-.03.03-.05.05-.07-.13-.15-.26-.26-.37-.27-.27-.61-.41-1.01-.41-.34,0-.64.1-.89.3-.05-.29-.18-.55-.38-.75-.3-.3-.72-.44-1.16-.4v-.04c0-.39-.14-.74-.41-1.01-.27-.27-.61-.41-1.01-.41.04-.13.06-.27.06-.42,0-.39-.14-.74-.41-1.01-.19-.19-.42-.31-.68-.37.12-.21.19-.46.19-.72,0-.39-.14-.74-.41-1.01-.04-.04-.09-.08-.14-.12.15-.23.23-.5.23-.79,0-.39-.14-.74-.41-1.01-.02-.02-.04-.04-.07-.06.22-.25.34-.58.34-.94,0-.38-.13-.72-.38-.98.02-.02.05-.04.07-.07.26-.27.4-.61.4-1.01,0-.32-.09-.62-.28-.86.08-.05.16-.12.23-.19.27-.27.41-.61.41-1.01,0-.27-.06-.51-.19-.72.26-.06.49-.18.68-.37.27-.26.41-.61.41-1.01,0-.15-.02-.29-.06-.42.39,0,.74-.14,1.01-.41.26-.27.4-.61.4-1.01v-.04c.42.03.86-.1,1.15-.4.21-.21.34-.46.39-.75.54.43,1.4.39,1.9-.1.11-.11.2-.23.26-.37.02.02.03.04.05.05.52.52,1.43.53,1.97.03.06.1.13.2.22.28.49.49,1.36.53,1.9.11.05.29.18.55.39.75.3.3.72.43,1.15.4v.04c0,.39.14.74.41,1.01.27.27.61.41,1.01.41-.04.13-.06.27-.06.42,0,.39.14.74.41,1.01.19.19.42.32.69.37-.12.21-.19.46-.19.72,0,.39.14.74.4,1.01.07.07.14.13.22.18-.19.24-.29.54-.29.87,0,.39.14.74.41,1.01.03.03.06.06.09.09-.24.26-.36.59-.36.96s.12.68.34.94ZM252.12,58.38c0-.39-.14-.74-.41-1.01-.04-.04-.08-.08-.12-.11.04-.03.08-.07.12-.11.27-.27.41-.61.41-1.01s-.14-.74-.4-1.01c-.53-.53-1.49-.53-2.02,0-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.08.08.12.11-.04.03-.08.07-.12.11-.27.27-.41.61-.41,1.01s.14.75.4,1.01c.04.04.08.08.13.11-.04.03-.08.07-.12.11-.27.26-.41.61-.41,1.01s.14.74.41,1.01c.03.03.05.05.08.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.75.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.26-.41.61-.41,1.01s.14.75.4,1c.05.05.09.09.14.13-.05.04-.1.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.4,1.01c.06.06.12.11.19.16-.07.05-.13.1-.18.15-.27.26-.41.61-.41,1.01s.14.75.4,1c.03.03.06.06.09.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.09.09-.17.2-.23.31-.08-.04-.17-.07-.26-.09-.06-.01-.13-.03-.19-.03.02-.06.04-.12.06-.19.08-.36.03-.72-.2-1.12-.22-.3-.51-.5-.86-.58-.06-.01-.13-.03-.19-.03.02-.06.04-.12.06-.18.09-.37.03-.74-.19-1.08-.22-.33-.52-.54-.87-.63-.04,0-.08-.02-.12-.02.01-.03.02-.07.03-.11.08-.36.03-.73-.2-1.12-.22-.3-.51-.5-.86-.58-.08-.02-.17-.03-.25-.04.03-.07.06-.15.08-.23.11-.39.03-.78-.19-1.09-.2-.31-.49-.52-.85-.62-.07-.02-.14-.03-.21-.04.02-.05.04-.11.05-.17.11-.4.03-.8-.18-1.09-.2-.31-.49-.53-.86-.63-.07-.02-.14-.03-.21-.04.02-.05.04-.1.05-.15.11-.38.04-.77-.18-1.11-.2-.32-.51-.53-.88-.62-.04,0-.08-.02-.12-.02.01-.04.02-.07.04-.11.11-.39.03-.78-.19-1.08-.2-.31-.49-.52-.85-.62-.06-.02-.13-.03-.19-.04.02-.06.04-.12.05-.18.09-.37.03-.73-.2-1.1-.21-.29-.5-.49-.84-.58-.06-.02-.13-.03-.2-.04.02-.05.03-.1.05-.15.11-.39.03-.8-.19-1.09-.2-.31-.49-.52-.86-.63-.19-.05-.38-.06-.55-.03,0-.39-.14-.73-.41-1-.53-.53-1.49-.53-2.01,0-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.08.08.12.11-.04.03-.08.07-.12.11-.27.27-.41.61-.41,1.01s.14.75.4,1.01c.04.04.08.08.13.11-.04.03-.08.07-.12.11-.27.26-.41.61-.41,1.01s.14.74.41,1.01c.03.03.05.05.08.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.75.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.26-.41.61-.41,1.01s.14.75.4,1c.05.05.09.09.14.13-.05.04-.1.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.4,1.01c.06.06.12.11.19.16-.07.05-.13.1-.18.15-.27.26-.41.61-.41,1.01s.14.75.4,1c.03.03.06.06.09.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.26-.41.61-.41,1.01s.14.75.4,1c.53.53,1.49.53,2.01,0,.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.02.06-.05.08-.08.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.06-.06-.12-.11-.19-.16.07-.05.13-.1.19-.16.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.26.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.02.06-.05.08-.08.27-.27.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.08-.08-.13-.11.04-.03.08-.07.12-.11.14-.13.24-.29.31-.46.06.01.11.02.17.03-.02.06-.04.11-.05.17-.08.37-.02.74.18,1.06,0,.01.02.03.03.04.21.29.5.49.84.59.06.02.13.03.2.04-.02.05-.03.09-.05.14-.11.39-.04.78.2,1.11.2.3.49.51.84.61.05.01.09.02.14.03-.01.03-.02.06-.03.08-.11.38-.04.78.19,1.11.2.3.49.51.84.6.07.02.14.03.21.04-.02.05-.04.11-.05.17-.11.39-.04.78.2,1.11.2.3.49.51.84.61.07.02.14.03.21.04-.02.05-.04.11-.05.16-.11.39-.04.78.2,1.11.2.3.49.51.84.61.09.02.18.04.27.05-.03.07-.06.15-.08.23-.09.37-.03.74.18,1.07,0,.01.01.02.02.03.21.29.5.49.84.59.05.01.1.02.15.03-.01.04-.02.08-.03.12-.08.36-.03.73.17,1.06.01.02.02.04.04.06.22.3.52.5.86.58.06.02.13.03.2.03-.02.06-.04.12-.06.19-.09.37-.03.74.18,1.06,0,0,0,0,0,.01.22.32.52.54.88.63.06.02.13.03.19.03-.02.06-.04.12-.06.18-.09.37-.03.74.18,1.07,0,.01.01.02.02.03.21.29.5.49.84.59.27.08.55.06.78-.02-.02.1-.03.21-.03.32,0,.4.14.75.4,1,.26.27.61.41,1.01.41s.75-.14,1-.4c.27-.27.41-.61.41-1.01s-.14-.75-.4-1.01c-.05-.05-.09-.09-.14-.13.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.4-1.01c-.05-.05-.09-.09-.14-.13.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.06-.05-.08-.08.03-.02.06-.05.08-.08.27-.27.41-.61.41-1.01s-.14-.75-.4-1.01c-.06-.06-.12-.11-.19-.16.07-.05.13-.1.19-.16.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.75-.4-1.01c-.04-.05-.09-.09-.14-.13.05-.04.09-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.08.03-.02.06-.05.08-.08.27-.27.41-.61.41-1.01s-.14-.75-.4-1.01c-.04-.04-.08-.08-.13-.11.04-.03.08-.07.12-.11.27-.27.41-.61.41-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M106.8,56.15c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM106.8,58.39c0-.21.07-.38.2-.52.13-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM106.8,60.62c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM106.8,62.79c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM106.8,65.05c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52ZM106.8,67.31c0-.21.07-.38.2-.52s.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM106.8,69.64c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM106.8,71.81c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM106.8,74.07c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM106.8,76.34c0-.21.07-.39.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM109.92,77.06c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM112.16,77.06c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52-.31.2-.52.2ZM114.4,77.06c-.21,0-.38-.07-.52-.2-.13-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM116.57,77.06c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM118.78,77.06c-.21,0-.38-.07-.52-.2s-.2-.31-.2-.52.07-.39.2-.52.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M122.31,65.55c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2ZM122.4,64.94c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM122.44,67.56c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM122.76,62.88c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2ZM122.76,69.49c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2ZM123.66,60.78c-.21,0-.38-.07-.52-.2s-.2-.31-.2-.52.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2ZM123.66,71.59c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.13.31-.2.52-.2ZM125.02,58.95c-.21,0-.38-.07-.52-.2-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2ZM125.02,73.42c.21,0,.38.07.52.2.14.13.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2ZM126.58,57.5c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM126.58,74.87c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM128.86,56.64c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2ZM128.86,75.72c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2ZM131.19,56.33c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2ZM131.19,76.04c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.13.31-.2.52-.2ZM133.38,56.64c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2ZM133.38,75.72c.21,0,.38.07.52.2.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2ZM135.67,57.5c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM135.67,74.87c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM137.23,58.95c-.21,0-.38-.07-.52-.2s-.2-.31-.2-.52.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2ZM137.23,73.42c.21,0,.38.07.52.2.14.13.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2ZM138.58,60.78c-.21,0-.39-.07-.52-.2-.14-.13-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.13.14-.31.2-.52.2ZM138.58,71.59c.21,0,.38.07.52.2s.2.31.2.52-.07.38-.2.52c-.13.14-.31.2-.52.2s-.39-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.13.31-.2.52-.2ZM139.49,62.88c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2ZM139.49,69.49c.21,0,.39.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2ZM139.83,64.94c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM139.83,67.56c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM139.96,65.55c.21,0,.38.07.52.2.13.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M144.71,66.14c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM144.75,68.63c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.39-.07-.52-.2-.2-.31-.2-.52ZM144.89,63.86c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM145.3,70.91c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM145.43,61.66c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM146.34,73.01c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM146.43,59.63c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM147.74,74.87c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM147.9,57.82c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM149.73,76.13c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM149.75,56.53c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM152.01,55.76c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM152.08,76.7c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM154.5,55.7c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM154.57,76.7c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM156.87,56.06c0-.21.07-.39.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.13.13.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52ZM157.21,76c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM158.84,57.21c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM159.13,74.62c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.39-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM160.35,58.5c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM160.37,72.97c0-.21.07-.38.2-.52s.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM161.08,70.73c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M164.17,76.38c.08-.18.2-.31.38-.4.18-.08.36-.09.54-.01.21.08.35.2.42.38.07.18.06.37-.01.56-.06.2-.18.33-.37.4-.19.07-.38.06-.58-.01-.17-.08-.29-.2-.38-.37-.09-.17-.09-.36,0-.55ZM165.01,74.3c.08-.21.2-.35.38-.42.18-.07.37-.06.57.01.18.06.31.18.4.37.08.19.09.37.01.55-.09.18-.22.31-.4.4-.17.08-.36.09-.55.01-.18-.08-.31-.2-.4-.38-.08-.18-.09-.36-.01-.54ZM165.91,72.24c.08-.2.2-.33.38-.4.18-.07.37-.06.57.01.2.08.33.2.41.37.08.17.08.37,0,.58-.08.17-.2.29-.37.37-.17.08-.37.09-.58.01-.2-.08-.33-.2-.41-.37-.08-.17-.08-.37,0-.58ZM166.73,70.23c.07-.18.2-.31.38-.4.18-.08.36-.09.54-.01.21.07.35.2.42.38.07.18.06.37-.01.56-.06.2-.18.33-.37.4-.19.07-.38.06-.58-.01-.17-.07-.29-.2-.38-.37-.09-.17-.09-.36,0-.55ZM167.56,68.15c.07-.21.2-.35.38-.42.18-.07.37-.06.57.01.18.06.31.18.4.37.08.19.09.37.01.55-.09.18-.22.31-.4.4-.17.08-.36.09-.55.01-.18-.08-.31-.2-.4-.38-.08-.18-.09-.36-.01-.54ZM168.38,66.12c.07-.2.2-.33.38-.41.18-.07.36-.07.54,0,.2.08.33.2.41.38.08.18.08.37,0,.57-.08.2-.2.33-.37.41-.17.08-.37.07-.58-.02-.2-.08-.33-.2-.4-.37-.07-.17-.06-.36.01-.55ZM169.78,69.82c.2.01.36.09.5.24.14.14.21.32.23.53-.02.2-.09.36-.24.5-.14.14-.32.21-.53.23-.2-.01-.36-.09-.49-.24-.13-.14-.21-.32-.24-.53.03-.2.11-.36.25-.5.14-.14.31-.21.52-.23ZM169.17,64.06c.09-.2.23-.34.41-.42.18-.08.36-.09.54-.03.2.09.34.23.42.41.08.18.09.36.03.54-.09.2-.23.34-.41.42-.18.08-.36.09-.54.03-.2-.09-.34-.23-.42-.41-.08-.18-.09-.36-.03-.54ZM170,62.03c.08-.2.2-.33.38-.41.18-.07.37-.07.57,0,.18.09.31.22.38.4.07.17.07.36,0,.55-.08.18-.2.31-.37.4-.17.08-.37.09-.58.01-.18-.08-.31-.2-.38-.38-.08-.18-.08-.37,0-.57ZM170.84,59.92c.08-.18.2-.31.37-.4.17-.08.37-.09.58-.01.18.08.31.2.38.38.07.18.07.36,0,.54-.08.21-.2.35-.38.42-.18.07-.37.06-.57-.01-.17-.06-.29-.18-.38-.37-.09-.19-.09-.37,0-.55ZM172.11,69.85c.21,0,.38.06.52.19.14.13.2.3.2.51.01.23-.05.4-.18.53s-.31.2-.52.21c-.21-.01-.39-.09-.53-.21-.14-.13-.21-.3-.21-.51s.07-.39.2-.53c.14-.14.31-.21.52-.19ZM171.65,57.91c.06-.2.18-.33.37-.41.19-.08.37-.07.53.02.2.06.34.18.42.36.08.18.09.37.03.56-.09.18-.23.31-.41.4-.18.08-.36.09-.54.01-.21-.08-.35-.2-.42-.38-.07-.18-.06-.37.01-.57ZM172.47,55.81c.07-.17.2-.29.37-.37.17-.08.37-.09.58-.01.2.08.33.2.41.37.07.17.07.37,0,.58-.08.2-.2.33-.38.4-.18.07-.37.06-.57-.01-.2-.08-.33-.2-.41-.37-.08-.17-.08-.37,0-.58ZM175.07,57.91c.08.2.08.38.01.57-.07.18-.21.31-.42.38-.18.08-.36.07-.54-.01-.18-.08-.32-.21-.41-.4-.06-.2-.05-.38.03-.56.08-.18.22-.3.42-.36.17-.09.34-.1.53-.02.19.08.31.21.37.41ZM174.48,69.85c.2-.01.36.05.5.19.14.14.2.32.2.53.01.21-.05.38-.19.5s-.32.2-.53.23c-.2.02-.37-.05-.52-.2-.15-.15-.21-.32-.18-.52-.02-.21.05-.38.19-.52.14-.14.32-.2.53-.2ZM175.88,59.92c.09.18.09.37,0,.55-.09.19-.22.31-.38.37-.2.08-.38.08-.57.01-.18-.07-.31-.21-.38-.42-.08-.18-.08-.36,0-.54.08-.18.2-.31.38-.38.21-.07.4-.07.58.01.17.08.3.21.37.4ZM176.72,62.03c.07.2.07.39,0,.57-.08.18-.2.31-.38.38-.21.08-.4.07-.58-.01-.17-.08-.3-.21-.37-.4-.08-.2-.08-.38,0-.55.08-.17.2-.31.38-.4.2-.07.38-.07.57,0,.18.08.31.21.38.41ZM177.55,64.06c.06.18.05.36-.03.54-.08.18-.22.32-.42.41-.18.06-.36.05-.54-.03-.18-.08-.32-.22-.41-.42-.06-.18-.05-.36.03-.54.08-.18.22-.32.42-.41.18-.06.36-.05.54.03.18.08.32.22.41.42ZM176.88,69.82c.21-.02.38.05.52.2.14.15.2.32.2.5,0,.21-.07.39-.2.54-.14.15-.3.22-.5.2-.21,0-.39-.07-.53-.2-.14-.14-.21-.31-.21-.52.02-.2.09-.36.23-.5.14-.14.3-.21.5-.23ZM178.35,66.12c.08.2.08.38.01.55-.07.17-.2.3-.4.37-.21.09-.4.1-.58.02-.17-.07-.3-.21-.37-.41-.08-.2-.08-.38,0-.57.07-.18.21-.31.41-.38.18-.07.36-.07.54,0,.18.08.31.21.38.41ZM179.16,68.15c.08.18.07.36-.01.54-.08.18-.21.31-.4.38-.2.08-.38.07-.55-.01-.17-.08-.31-.21-.4-.4-.08-.18-.07-.37.01-.55.08-.19.21-.31.4-.37.2-.08.38-.08.56-.01.18.07.31.21.38.42ZM180,70.23c.09.2.09.38,0,.55-.09.17-.22.3-.38.37-.2.08-.39.08-.58.01-.19-.07-.31-.2-.37-.4-.08-.2-.08-.38-.01-.56.07-.18.21-.31.42-.38.18-.08.36-.07.54.01.18.08.31.21.38.4ZM180.81,72.24c.08.21.08.4,0,.58-.08.17-.21.3-.41.37-.21.08-.4.07-.58-.01-.17-.08-.3-.21-.37-.37-.08-.21-.08-.4,0-.58.08-.17.21-.3.41-.37.2-.07.39-.08.57-.01s.31.2.38.4ZM181.71,74.3c.08.18.07.36-.01.54-.08.18-.21.31-.4.38-.2.08-.38.07-.55-.01-.17-.08-.31-.21-.4-.4-.08-.18-.07-.37.01-.55.08-.19.21-.31.4-.37.2-.07.39-.08.57-.01.18.07.31.21.38.42ZM182.55,76.38c.09.2.09.38,0,.55-.09.17-.22.3-.38.37-.2.08-.39.08-.58.01-.19-.07-.31-.2-.37-.4-.08-.2-.08-.38-.01-.56.07-.18.21-.31.42-.38.18-.08.36-.07.54.01s.31.21.38.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M182.84,56.96c-.21,0-.38-.07-.52-.2s-.2-.31-.2-.52.07-.38.2-.52.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2ZM185.08,56.96c-.21,0-.38-.07-.52-.2-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM187.32,56.96c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM189.04,56.15c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM189.04,58.39c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM189.04,60.62c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM189.04,62.79c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM189.04,65.05c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52ZM189.04,67.31c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM189.04,69.64c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM189.04,71.81c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM189.04,74.07c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM189.04,76.34c0-.21.07-.39.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM192.02,56.87c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM194.26,56.87c-.21,0-.38-.07-.52-.2s-.2-.31-.2-.52.07-.38.2-.52c.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2ZM196.5,56.87c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M200.97,56.15c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM200.97,76.31c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM203.48,56.15c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM203.48,58.39c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM203.48,60.62c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM203.48,62.79c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM203.48,65.05c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.13-.2-.31-.2-.52ZM203.48,67.31c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM203.48,69.64c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM203.48,71.81c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM203.48,74.07c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM203.48,76.34c0-.21.07-.39.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM205.95,56.15c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM205.95,76.31c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M212.19,65.55c.21,0,.39.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2ZM212.28,64.94c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM212.32,67.56c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM212.64,62.88c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM212.64,69.49c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2ZM213.54,60.78c-.21,0-.38-.07-.52-.2-.13-.13-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2ZM213.54,71.59c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.13.31-.2.52-.2ZM214.9,58.95c-.21,0-.38-.07-.52-.2-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM214.9,73.42c.21,0,.38.07.52.2.14.13.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2ZM216.46,57.5c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2ZM216.46,74.87c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM218.74,56.64c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.13-.31.2-.52.2ZM218.74,75.72c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM221.07,56.33c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM221.07,76.04c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52.07-.38.2-.52c.14-.13.31-.2.52-.2ZM223.26,56.64c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2ZM223.26,75.72c.21,0,.38.07.52.2.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM225.55,57.5c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2ZM225.55,74.87c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM227.11,58.95c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2ZM227.11,73.42c.21,0,.38.07.52.2.14.13.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2ZM228.46,60.78c-.21,0-.39-.07-.52-.2-.14-.13-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.13.14-.31.2-.52.2ZM228.46,71.59c.21,0,.38.07.52.2s.2.31.2.52-.07.38-.2.52c-.13.14-.31.2-.52.2s-.39-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.13.31-.2.52-.2ZM229.37,62.88c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2ZM229.37,69.49c.21,0,.39.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2ZM229.71,64.94c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM229.71,67.56c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM229.84,65.55c.21,0,.38.07.52.2.13.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M235.83,56.15c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM235.83,58.39c0-.21.07-.38.2-.52.13-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM235.83,60.62c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM235.83,62.79c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM235.83,65.05c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52ZM235.83,67.31c0-.21.07-.38.2-.52s.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM235.83,69.64c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM235.83,71.81c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM235.83,74.07c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM235.83,76.34c0-.21.07-.39.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM237.57,57.93c-.12-.16-.15-.35-.1-.54.05-.2.16-.35.33-.45.17-.12.35-.15.54-.1.2.05.35.16.45.33.12.17.15.35.1.54-.05.2-.16.35-.33.45-.17.12-.35.15-.54.1-.2-.05-.35-.16-.45-.33ZM238.75,59.83c-.1-.17-.13-.35-.09-.54.05-.2.16-.35.34-.45.17-.12.34-.15.53-.1.19.05.34.16.46.33.1.17.14.34.09.53-.05.19-.15.34-.32.46-.18.12-.37.15-.55.1-.19-.05-.34-.16-.46-.33ZM239.95,61.73c-.12-.17-.15-.35-.1-.54.05-.2.16-.35.33-.45.17-.12.35-.15.54-.1.2.05.35.16.45.33.12.17.15.34.1.53-.05.19-.16.34-.33.46-.17.12-.35.15-.54.1-.2-.05-.35-.16-.45-.33ZM241.1,63.56c-.12-.17-.15-.34-.1-.53.05-.19.16-.34.33-.46.17-.11.35-.14.54-.09.2.05.35.15.45.32.12.18.15.37.1.55-.05.19-.16.34-.33.44-.17.12-.35.15-.54.1-.2-.05-.35-.16-.45-.33ZM242.3,65.48c-.12-.17-.15-.35-.1-.54.05-.2.16-.35.33-.45.17-.12.35-.15.54-.1.2.05.35.16.45.33.12.17.15.35.1.54-.05.2-.16.35-.33.45-.17.12-.35.15-.54.1-.2-.05-.35-.16-.45-.33ZM243.49,67.41c-.12-.17-.15-.35-.1-.54.05-.2.16-.35.33-.45.17-.12.35-.15.54-.1.2.05.35.16.45.33.12.17.15.34.1.53-.05.19-.16.34-.33.46-.17.12-.35.15-.54.1-.2-.05-.35-.16-.45-.33ZM244.71,69.37c-.11-.17-.14-.34-.09-.53.05-.19.16-.34.34-.46.17-.1.34-.13.53-.09.19.05.34.15.46.32.1.18.13.37.09.55-.05.19-.16.34-.34.44-.17.12-.34.15-.53.1-.19-.05-.34-.16-.46-.33ZM245.87,71.23c-.1-.18-.13-.37-.09-.55.05-.19.15-.34.32-.46.18-.11.37-.14.55-.09.19.05.34.16.46.34.1.17.14.34.09.53-.04.19-.16.34-.34.46-.17.11-.34.14-.53.09-.19-.04-.34-.15-.46-.32ZM247.07,73.13c-.11-.17-.13-.34-.09-.53.05-.19.15-.34.32-.46.18-.1.37-.14.55-.09.19.04.34.15.46.32.1.18.14.37.09.55-.05.19-.16.34-.34.46-.17.11-.34.14-.53.09-.19-.05-.34-.16-.46-.34ZM248.26,75.05c-.11-.17-.14-.34-.09-.53.05-.19.15-.34.32-.46.18-.1.37-.13.55-.09.19.05.34.15.46.32.1.18.13.37.09.55-.05.19-.16.34-.34.44-.17.12-.34.15-.53.1-.19-.05-.34-.16-.46-.33ZM249.98,56.15c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM249.98,58.39c0-.21.07-.38.2-.52.13-.13.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM249.98,60.62c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM249.98,62.79c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM249.98,65.05c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52ZM249.98,67.31c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.39.07.52.2.2.31.2.52-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM249.98,69.64c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM249.98,71.81c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM249.98,74.07c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM249.98,76.34c0-.21.07-.39.2-.52.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 693.98,
    y: 311.66,
    width: 169.42,
    height: 38.32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.98 311.66 699.44 317.13 699.44 311.66 693.98 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.98 317.13 699.44 322.61 699.44 317.13 693.98 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.98 322.61 699.44 328.08 699.44 322.61 693.98 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.98 328.08 699.44 333.56 699.44 328.08 693.98 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.98 333.56 699.44 339.03 699.44 333.56 693.98 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.98 339.03 699.44 344.51 699.44 339.03 693.98 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "693.98 344.51 699.44 349.98 699.44 344.51 693.98 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.44 311.66 704.91 317.13 704.91 311.66 699.44 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.44 317.13 704.91 322.61 704.91 317.13 699.44 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.44 322.61 704.91 328.08 704.91 322.61 699.44 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.44 328.08 704.91 333.56 704.91 328.08 699.44 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.44 333.56 704.91 339.03 704.91 333.56 699.44 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.44 339.03 704.91 344.51 704.91 339.03 699.44 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "699.44 344.51 704.91 349.98 704.91 344.51 699.44 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.91 311.66 710.37 317.13 710.37 311.66 704.91 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.91 317.13 710.37 322.61 710.37 317.13 704.91 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.91 322.61 710.37 328.08 710.37 322.61 704.91 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.91 328.08 710.37 333.56 710.37 328.08 704.91 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.91 333.56 710.37 339.03 710.37 333.56 704.91 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.91 339.03 710.37 344.51 710.37 339.03 704.91 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "704.91 344.51 710.37 349.98 710.37 344.51 704.91 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.37 311.66 715.84 317.13 715.84 311.66 710.37 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.37 317.13 715.84 322.61 715.84 317.13 710.37 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.37 322.61 715.84 328.08 715.84 322.61 710.37 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.37 328.08 715.84 333.56 715.84 328.08 710.37 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.37 333.56 715.84 339.03 715.84 333.56 710.37 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.37 339.03 715.84 344.51 715.84 339.03 710.37 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "710.37 344.51 715.84 349.98 715.84 344.51 710.37 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.84 311.66 721.3 317.13 721.3 311.66 715.84 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.84 317.13 721.3 322.61 721.3 317.13 715.84 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.84 322.61 721.3 328.08 721.3 322.61 715.84 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.84 328.08 721.3 333.56 721.3 328.08 715.84 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.84 333.56 721.3 339.03 721.3 333.56 715.84 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.84 339.03 721.3 344.51 721.3 339.03 715.84 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "715.84 344.51 721.3 349.98 721.3 344.51 715.84 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.3 311.66 726.77 317.13 726.77 311.66 721.3 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.3 317.13 726.77 322.61 726.77 317.13 721.3 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.3 322.61 726.77 328.08 726.77 322.61 721.3 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.3 328.08 726.77 333.56 726.77 328.08 721.3 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.3 333.56 726.77 339.03 726.77 333.56 721.3 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.3 339.03 726.77 344.51 726.77 339.03 721.3 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "721.3 344.51 726.77 349.98 726.77 344.51 721.3 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.77 311.66 732.23 317.13 732.23 311.66 726.77 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.77 317.13 732.23 322.61 732.23 317.13 726.77 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.77 322.61 732.23 328.08 732.23 322.61 726.77 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.77 328.08 732.23 333.56 732.23 328.08 726.77 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.77 333.56 732.23 339.03 732.23 333.56 726.77 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.77 339.03 732.23 344.51 732.23 339.03 726.77 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "726.77 344.51 732.23 349.98 732.23 344.51 726.77 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.23 311.66 737.7 317.13 737.7 311.66 732.23 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.23 317.13 737.7 322.61 737.7 317.13 732.23 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.23 322.61 737.7 328.08 737.7 322.61 732.23 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.23 328.08 737.7 333.56 737.7 328.08 732.23 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.23 333.56 737.7 339.03 737.7 333.56 732.23 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.23 339.03 737.7 344.51 737.7 339.03 732.23 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "732.23 344.51 737.7 349.98 737.7 344.51 732.23 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.7 311.66 743.16 317.13 743.16 311.66 737.7 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.7 317.13 743.16 322.61 743.16 317.13 737.7 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.7 322.61 743.16 328.08 743.16 322.61 737.7 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.7 328.08 743.16 333.56 743.16 328.08 737.7 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.7 333.56 743.16 339.03 743.16 333.56 737.7 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.7 339.03 743.16 344.51 743.16 339.03 737.7 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "737.7 344.51 743.16 349.98 743.16 344.51 737.7 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.16 311.66 748.63 317.13 748.63 311.66 743.16 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.16 317.13 748.63 322.61 748.63 317.13 743.16 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.16 322.61 748.63 328.08 748.63 322.61 743.16 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.16 328.08 748.63 333.56 748.63 328.08 743.16 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.16 333.56 748.63 339.03 748.63 333.56 743.16 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.16 339.03 748.63 344.51 748.63 339.03 743.16 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "743.16 344.51 748.63 349.98 748.63 344.51 743.16 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.63 311.66 754.09 317.13 754.09 311.66 748.63 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.63 317.13 754.09 322.61 754.09 317.13 748.63 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.63 322.61 754.09 328.08 754.09 322.61 748.63 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.63 328.08 754.09 333.56 754.09 328.08 748.63 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.63 333.56 754.09 339.03 754.09 333.56 748.63 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.63 339.03 754.09 344.51 754.09 339.03 748.63 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "748.63 344.51 754.09 349.98 754.09 344.51 748.63 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.09 311.66 759.56 317.13 759.56 311.66 754.09 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.09 317.13 759.56 322.61 759.56 317.13 754.09 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.09 322.61 759.56 328.08 759.56 322.61 754.09 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.09 328.08 759.56 333.56 759.56 328.08 754.09 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.09 333.56 759.56 339.03 759.56 333.56 754.09 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.09 339.03 759.56 344.51 759.56 339.03 754.09 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "754.09 344.51 759.56 349.98 759.56 344.51 754.09 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.56 311.66 765.02 317.13 765.02 311.66 759.56 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.56 317.13 765.02 322.61 765.02 317.13 759.56 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.56 322.61 765.02 328.08 765.02 322.61 759.56 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.56 328.08 765.02 333.56 765.02 328.08 759.56 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.56 333.56 765.02 339.03 765.02 333.56 759.56 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.56 339.03 765.02 344.51 765.02 339.03 759.56 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "759.56 344.51 765.02 349.98 765.02 344.51 759.56 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765.02 311.66 770.49 317.13 770.49 311.66 765.02 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765.02 317.13 770.49 322.61 770.49 317.13 765.02 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765.02 322.61 770.49 328.08 770.49 322.61 765.02 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765.02 328.08 770.49 333.56 770.49 328.08 765.02 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765.02 333.56 770.49 339.03 770.49 333.56 765.02 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765.02 339.03 770.49 344.51 770.49 339.03 765.02 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "765.02 344.51 770.49 349.98 770.49 344.51 765.02 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.49 311.66 775.95 317.13 775.95 311.66 770.49 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.49 317.13 775.95 322.61 775.95 317.13 770.49 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.49 322.61 775.95 328.08 775.95 322.61 770.49 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.49 328.08 775.95 333.56 775.95 328.08 770.49 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.49 333.56 775.95 339.03 775.95 333.56 770.49 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.49 339.03 775.95 344.51 775.95 339.03 770.49 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "770.49 344.51 775.95 349.98 775.95 344.51 770.49 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 311.66 781.42 317.13 781.42 311.66 775.95 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 317.13 781.42 322.61 781.42 317.13 775.95 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 322.61 781.42 328.08 781.42 322.61 775.95 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 328.08 781.42 333.56 781.42 328.08 775.95 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 333.56 781.42 339.03 781.42 333.56 775.95 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 339.03 781.42 344.51 781.42 339.03 775.95 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "775.95 344.51 781.42 349.98 781.42 344.51 775.95 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 311.66 786.88 317.13 786.88 311.66 781.42 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 317.13 786.88 322.61 786.88 317.13 781.42 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 322.61 786.88 328.08 786.88 322.61 781.42 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 328.08 786.88 333.56 786.88 328.08 781.42 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 333.56 786.88 339.03 786.88 333.56 781.42 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 339.03 786.88 344.51 786.88 339.03 781.42 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "781.42 344.51 786.88 349.98 786.88 344.51 781.42 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.88 311.66 792.35 317.13 792.35 311.66 786.88 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.88 317.13 792.35 322.61 792.35 317.13 786.88 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.88 322.61 792.35 328.08 792.35 322.61 786.88 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.88 328.08 792.35 333.56 792.35 328.08 786.88 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.88 333.56 792.35 339.03 792.35 333.56 786.88 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.88 339.03 792.35 344.51 792.35 339.03 786.88 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "786.88 344.51 792.35 349.98 792.35 344.51 786.88 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.35 311.66 797.81 317.13 797.81 311.66 792.35 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.35 317.13 797.81 322.61 797.81 317.13 792.35 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.35 322.61 797.81 328.08 797.81 322.61 792.35 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.35 328.08 797.81 333.56 797.81 328.08 792.35 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.35 333.56 797.81 339.03 797.81 333.56 792.35 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.35 339.03 797.81 344.51 797.81 339.03 792.35 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "792.35 344.51 797.81 349.98 797.81 344.51 792.35 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.81 311.66 803.28 317.13 803.28 311.66 797.81 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.81 317.13 803.28 322.61 803.28 317.13 797.81 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.81 322.61 803.28 328.08 803.28 322.61 797.81 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.81 328.08 803.28 333.56 803.28 328.08 797.81 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.81 333.56 803.28 339.03 803.28 333.56 797.81 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.81 339.03 803.28 344.51 803.28 339.03 797.81 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "797.81 344.51 803.28 349.98 803.28 344.51 797.81 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.28 311.66 808.74 317.13 808.74 311.66 803.28 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.28 317.13 808.74 322.61 808.74 317.13 803.28 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.28 322.61 808.74 328.08 808.74 322.61 803.28 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.28 328.08 808.74 333.56 808.74 328.08 803.28 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.28 333.56 808.74 339.03 808.74 333.56 803.28 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.28 339.03 808.74 344.51 808.74 339.03 803.28 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "803.28 344.51 808.74 349.98 808.74 344.51 803.28 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.74 311.66 814.21 317.13 814.21 311.66 808.74 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.74 317.13 814.21 322.61 814.21 317.13 808.74 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.74 322.61 814.21 328.08 814.21 322.61 808.74 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.74 328.08 814.21 333.56 814.21 328.08 808.74 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.74 333.56 814.21 339.03 814.21 333.56 808.74 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.74 339.03 814.21 344.51 814.21 339.03 808.74 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "808.74 344.51 814.21 349.98 814.21 344.51 808.74 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.21 311.66 819.67 317.13 819.67 311.66 814.21 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.21 317.13 819.67 322.61 819.67 317.13 814.21 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.21 322.61 819.67 328.08 819.67 322.61 814.21 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.21 328.08 819.67 333.56 819.67 328.08 814.21 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.21 333.56 819.67 339.03 819.67 333.56 814.21 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.21 339.03 819.67 344.51 819.67 339.03 814.21 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "814.21 344.51 819.67 349.98 819.67 344.51 814.21 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.67 311.66 825.14 317.13 825.14 311.66 819.67 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.67 317.13 825.14 322.61 825.14 317.13 819.67 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.67 322.61 825.14 328.08 825.14 322.61 819.67 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.67 328.08 825.14 333.56 825.14 328.08 819.67 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.67 333.56 825.14 339.03 825.14 333.56 819.67 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.67 339.03 825.14 344.51 825.14 339.03 819.67 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "819.67 344.51 825.14 349.98 825.14 344.51 819.67 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.14 311.66 830.6 317.13 830.6 311.66 825.14 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.14 317.13 830.6 322.61 830.6 317.13 825.14 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.14 322.61 830.6 328.08 830.6 322.61 825.14 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.14 328.08 830.6 333.56 830.6 328.08 825.14 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.14 333.56 830.6 339.03 830.6 333.56 825.14 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.14 339.03 830.6 344.51 830.6 339.03 825.14 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "825.14 344.51 830.6 349.98 830.6 344.51 825.14 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.6 311.66 836.07 317.13 836.07 311.66 830.6 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.6 317.13 836.07 322.61 836.07 317.13 830.6 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.6 322.61 836.07 328.08 836.07 322.61 830.6 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.6 328.08 836.07 333.56 836.07 328.08 830.6 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.6 333.56 836.07 339.03 836.07 333.56 830.6 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.6 339.03 836.07 344.51 836.07 339.03 830.6 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "830.6 344.51 836.07 349.98 836.07 344.51 830.6 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.07 311.66 841.54 317.13 841.54 311.66 836.07 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.07 317.13 841.54 322.61 841.54 317.13 836.07 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.07 322.61 841.54 328.08 841.54 322.61 836.07 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.07 328.08 841.54 333.56 841.54 328.08 836.07 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.07 333.56 841.54 339.03 841.54 333.56 836.07 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.07 339.03 841.54 344.51 841.54 339.03 836.07 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "836.07 344.51 841.54 349.98 841.54 344.51 836.07 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.54 311.66 847 317.13 847 311.66 841.54 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.54 317.13 847 322.61 847 317.13 841.54 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.54 322.61 847 328.08 847 322.61 841.54 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.54 328.08 847 333.56 847 328.08 841.54 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.54 333.56 847 339.03 847 333.56 841.54 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.54 339.03 847 344.51 847 339.03 841.54 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "841.54 344.51 847 349.98 847 344.51 841.54 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847 311.66 852.47 317.13 852.47 311.66 847 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847 317.13 852.47 322.61 852.47 317.13 847 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847 322.61 852.47 328.08 852.47 322.61 847 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847 328.08 852.47 333.56 852.47 328.08 847 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847 333.56 852.47 339.03 852.47 333.56 847 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847 339.03 852.47 344.51 852.47 339.03 847 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "847 344.51 852.47 349.98 852.47 344.51 847 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.47 311.66 857.93 317.13 857.93 311.66 852.47 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.47 317.13 857.93 322.61 857.93 317.13 852.47 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.47 322.61 857.93 328.08 857.93 322.61 852.47 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.47 328.08 857.93 333.56 857.93 328.08 852.47 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.47 333.56 857.93 339.03 857.93 333.56 852.47 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.47 339.03 857.93 344.51 857.93 339.03 852.47 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "852.47 344.51 857.93 349.98 857.93 344.51 852.47 344.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "857.93 311.66 863.4 317.13 863.4 311.66 857.93 311.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "857.93 317.13 863.4 322.61 863.4 317.13 857.93 317.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "857.93 322.61 863.4 328.08 863.4 322.61 857.93 322.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "857.93 328.08 863.4 333.56 863.4 328.08 857.93 328.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "857.93 333.56 863.4 339.03 863.4 333.56 857.93 333.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "857.93 339.03 863.4 344.51 863.4 339.03 857.93 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "857.93 344.51 863.4 349.98 863.4 344.51 857.93 344.51"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 693.98,
    y: 311.66,
    width: 169.42,
    height: 32.49,
    transform: "translate(1557.37 655.81) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M774.37,313.66c-1.18,0-2.14-.96-2.14-2.14,0-38.77-31.54-70.31-70.3-70.31-1.18,0-2.14-.96-2.14-2.14s.96-2.14,2.14-2.14c41.13,0,74.58,33.46,74.58,74.59,0,1.18-.96,2.14-2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M772.45,315.59c-1.18,0-2.14-.96-2.14-2.14,0-38.77-31.54-70.31-70.31-70.31-1.18,0-2.14-.96-2.14-2.14s.96-2.14,2.14-2.14c41.13,0,74.58,33.46,74.58,74.58,0,1.18-.96,2.14-2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M783,313.66c1.18,0,2.14-.96,2.14-2.14,0-38.77,31.54-70.31,70.31-70.31,1.18,0,2.14-.96,2.14-2.14s-.96-2.14-2.14-2.14c-41.13,0-74.58,33.46-74.58,74.59,0,1.18.96,2.14,2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M784.93,315.59c1.18,0,2.14-.96,2.14-2.14,0-38.77,31.54-70.31,70.31-70.31,1.18,0,2.14-.96,2.14-2.14s-.96-2.14-2.14-2.14c-41.13,0-74.58,33.46-74.58,74.58,0,1.18.96,2.14,2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 695.69,
    y: 86.54,
    width: 165.99,
    height: 257.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M695.69,86.54v257.6h165.99V86.54h-165.99ZM761.57,338.64h-48.76c-4.61,0-8.35-3.74-8.35-8.35V115.11c0-5.65,4.58-10.23,10.23-10.23h45c5.65,0,10.23,4.58,10.23,10.23v215.18c0,4.61-3.74,8.35-8.35,8.35ZM844.57,338.64h-48.76c-4.61,0-8.35-3.74-8.35-8.35V115.11c0-5.65,4.58-10.23,10.23-10.23h45c5.65,0,10.23,4.58,10.23,10.23v215.18c0,4.61-3.74,8.35-8.35,8.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "863.4 86.54 693.98 86.54 693.98 349.98 697.4 349.98 697.4 89.97 776.98 89.97 776.98 344.15 780.4 344.15 780.4 89.97 859.97 89.97 859.97 349.98 863.4 349.98 863.4 86.54"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M730.55,170.34l-9.16,3.64c-5.57,2.21-11.61-1.89-11.61-7.88v-45.25c0-4.68,3.8-8.48,8.48-8.48h37.38c4.68,0,8.48,3.8,8.48,8.48h0c0,21.81-13.3,41.42-33.57,49.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M814.96,170.34l-9.16,3.64c-5.57,2.21-11.61-1.89-11.61-7.88v-45.25c0-4.68,3.8-8.48,8.48-8.48h37.39c4.68,0,8.48,3.8,8.48,8.48h0c0,21.81-13.3,41.42-33.57,49.48Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 693.98,
    y: 48.21,
    width: 169.42,
    height: 35.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M716.33,75.32s-.07.07-.1.11c-.03-.04-.06-.07-.1-.11-.53-.53-1.49-.54-2.02,0-.03.03-.05.05-.08.08-.02-.03-.05-.06-.08-.08-.53-.53-1.5-.52-2.01,0-.04.04-.08.08-.11.13-.03-.04-.07-.09-.11-.13-.53-.53-1.49-.53-2.01,0-.04.04-.08.08-.11.13-.03-.04-.07-.08-.11-.12-.53-.53-1.49-.53-2.01,0-.07.07-.14.15-.19.24-.05-.09-.12-.16-.19-.24-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.02.06-.05.08-.08.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.06-.06-.12-.11-.19-.16.07-.05.13-.1.19-.16.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.26.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.02.06-.05.08-.08.27-.27.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.08-.08-.13-.11.04-.03.08-.07.12-.11.27-.26.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.08-.07-.12-.11.04-.03.08-.07.13-.11.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.53-.53-1.49-.53-2.01,0-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.08.08.12.11-.04.03-.08.07-.12.11-.27.27-.41.61-.41,1.01s.14.75.4,1.01c.04.04.08.08.13.11-.04.03-.08.07-.12.11-.27.26-.41.61-.41,1.01s.14.74.41,1.01c.03.03.05.05.08.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.75.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.26-.41.61-.41,1.01s.14.75.4,1c.05.05.09.09.14.13-.05.04-.1.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.4,1.01c.06.06.12.11.19.16-.07.05-.13.1-.18.15-.27.26-.41.61-.41,1.01s.14.75.4,1c.03.03.06.06.09.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.26-.41.61-.41,1.01s.14.75.4,1c.53.53,1.49.53,2.01,0,.07-.07.14-.15.19-.24.05.08.12.16.19.24.53.53,1.49.53,2.01,0,.04-.04.08-.08.11-.13.04.04.07.08.11.12.53.53,1.48.53,2.02,0,.04-.04.08-.08.11-.12.03.04.07.08.11.12.53.53,1.49.54,2.02,0,.03-.03.05-.05.08-.08.02.03.05.06.08.08.53.53,1.5.52,2.01,0,.04-.04.07-.07.1-.11.03.04.06.08.1.11.27.27.61.41,1.01.41s.75-.14,1.01-.4c.27-.26.41-.61.41-1.01s-.14-.75-.4-1.01c-.53-.53-1.48-.54-2.02,0ZM739.93,66.27c0-.39-.14-.74-.4-1.01-.03-.03-.06-.06-.09-.09.24-.26.36-.59.36-.96,0-.39-.14-.74-.41-1.01-.07-.07-.14-.13-.22-.18.19-.24.29-.54.29-.87,0-.39-.14-.74-.41-1.01-.19-.19-.42-.32-.68-.37.12-.21.19-.46.19-.72,0-.39-.14-.74-.41-1.01-.27-.26-.61-.4-1.01-.4.04-.13.06-.27.06-.42,0-.39-.14-.74-.41-1.01-.3-.3-.73-.44-1.15-.4v-.04c0-.39-.14-.74-.41-1.01-.49-.49-1.36-.53-1.9-.1-.05-.29-.18-.55-.38-.75-.51-.52-1.44-.54-1.98-.04-.06-.1-.13-.19-.22-.28-.53-.53-1.48-.53-2.02,0-.11.11-.2.23-.26.37-.01-.02-.03-.04-.05-.05-.53-.53-1.48-.53-2.02,0-.21.21-.34.46-.39.75-.53-.42-1.39-.39-1.9.11-.26.27-.4.61-.4,1.01v.04c-.42-.04-.85.1-1.15.4-.27.27-.41.61-.41,1.01,0,.15.02.29.06.42-.39,0-.74.14-1.01.41-.26.27-.4.61-.4,1.01,0,.27.06.51.19.72-.26.06-.49.18-.69.37-.26.27-.4.61-.4,1.01,0,.32.1.62.28.86-.08.05-.16.12-.23.19-.27.27-.41.61-.41,1.01s.13.72.38.98c-.02.02-.05.04-.07.06-.27.27-.41.61-.41,1.01s.14.75.4,1c.02.02.05.05.07.07-.22.26-.34.58-.34.94,0,.39.14.74.41,1.01.04.04.09.08.14.12-.15.23-.23.5-.23.79,0,.39.14.74.41,1.01.19.19.42.31.68.37-.12.21-.19.46-.19.72,0,.39.14.74.41,1.01.27.27.61.41,1.01.41-.04.13-.06.27-.06.42,0,.4.14.75.4,1,.3.3.74.44,1.16.4v.04c0,.39.14.74.41,1.01.5.49,1.36.53,1.9.1.05.29.18.55.39.75.53.53,1.48.53,2.01,0,.02-.02.04-.04.05-.05.06.13.15.26.26.37.27.27.61.41,1.01.41s.74-.14,1.01-.41c.08-.08.16-.18.22-.28.54.5,1.47.48,1.97-.04.21-.21.34-.46.39-.76.53.42,1.4.39,1.9-.11.27-.27.41-.61.41-1.01v-.04c.44.04.86-.1,1.15-.4.27-.26.41-.61.41-1.01,0-.15-.02-.29-.06-.42.39,0,.74-.14,1.01-.41.26-.27.4-.61.4-1.01,0-.26-.06-.51-.19-.72.26-.06.5-.18.69-.37.27-.27.41-.61.41-1.01,0-.29-.08-.55-.22-.78.05-.04.11-.08.15-.13.27-.27.41-.61.41-1.01,0-.36-.12-.68-.34-.94.02-.02.05-.04.07-.07.26-.26.4-.61.4-1.01ZM737.45,67.21s-.05.04-.07.07c-.27.27-.41.61-.41,1.01,0,.29.08.56.22.78-.06.04-.11.09-.16.14-.26.27-.4.61-.4,1.01,0,.26.06.51.19.72-.26.06-.49.18-.69.37-.26.27-.4.61-.4,1.01,0,.15.02.29.06.42-.4,0-.75.14-1.01.4-.27.26-.41.61-.41,1.01v.04c-.43-.04-.86.1-1.15.4-.21.21-.34.46-.39.75-.53-.43-1.4-.39-1.9.11-.08.08-.16.18-.22.28-.53-.49-1.45-.48-1.98.04-.02.02-.03.03-.05.05-.07-.13-.15-.26-.26-.37-.27-.27-.61-.41-1.01-.41-.34,0-.64.1-.89.3-.05-.29-.18-.55-.38-.75-.3-.3-.73-.44-1.16-.4v-.04c0-.39-.14-.74-.41-1.01-.27-.27-.61-.41-1.01-.41.04-.13.06-.27.06-.42,0-.39-.14-.74-.41-1.01-.19-.19-.42-.31-.68-.37.12-.21.19-.46.19-.72,0-.39-.14-.74-.41-1.01-.04-.04-.09-.08-.14-.12.15-.23.23-.5.23-.79,0-.39-.14-.74-.41-1.01-.02-.02-.04-.04-.07-.06.22-.25.34-.58.34-.94,0-.38-.13-.72-.38-.98.02-.02.05-.04.07-.07.26-.27.4-.61.4-1.01,0-.32-.09-.62-.28-.86.08-.05.16-.12.23-.19.27-.27.41-.61.41-1.01,0-.27-.06-.51-.19-.72.26-.06.49-.18.68-.37.27-.26.41-.61.41-1.01,0-.15-.02-.29-.06-.42.39,0,.74-.14,1.01-.41.26-.27.4-.61.4-1.01v-.04c.42.03.86-.1,1.15-.4.21-.21.34-.46.39-.75.54.43,1.4.39,1.9-.1.11-.11.2-.23.26-.37.02.02.03.04.05.05.52.52,1.43.53,1.97.03.06.1.13.2.22.28.49.49,1.36.53,1.9.1.05.29.18.55.39.75.3.3.72.43,1.15.4v.04c0,.39.14.74.4,1.01.26.27.61.41,1.01.41-.04.13-.06.27-.06.42,0,.39.14.74.41,1.01.19.19.42.32.68.37-.12.21-.19.46-.19.72,0,.39.14.74.41,1.01.07.07.14.13.22.18-.19.24-.29.54-.29.87,0,.39.14.74.41,1.01.03.03.06.06.09.09-.24.26-.37.59-.37.96s.12.69.34.94ZM759.35,69.72c-.27.27-.41.61-.41,1.01,0,.33.1.63.3.88-.22.06-.42.18-.59.35-.27.27-.41.61-.41,1.01,0,.08,0,.17.02.24-.33.03-.63.17-.85.4-.27.27-.41.61-.41,1.01,0,.02,0,.03,0,.05-.5-.18-1.13-.07-1.52.32-.26.26-.4.61-.4.99-.06-.11-.14-.21-.23-.3-.53-.53-1.47-.53-2.02,0-.09.09-.17.2-.23.31-.06-.11-.14-.22-.24-.32-.53-.53-1.48-.53-2.01,0-.07-.21-.18-.4-.34-.56-.4-.41-1.07-.51-1.58-.29,0-.38-.15-.71-.41-.97-.27-.27-.6-.44-1.06-.4.04-.14.06-.29.06-.44,0-.4-.14-.75-.4-1.01-.22-.22-.5-.36-.81-.4.11-.21.17-.44.17-.7,0-.39-.14-.74-.4-1.01-.14-.14-.31-.25-.49-.32.23-.26.36-.59.36-.96,0-.39-.14-.74-.41-1.01-.1-.1-.21-.18-.34-.25.11-.06.2-.13.29-.22.27-.27.41-.61.41-1.01s-.14-.74-.4-1.01c-.02-.02-.05-.05-.07-.07.09-.06.18-.12.25-.2.27-.27.41-.61.41-1.01,0-.34-.1-.64-.3-.89.16-.07.31-.17.43-.29.27-.26.41-.61.41-1.01,0-.23-.05-.45-.14-.65.28-.05.53-.18.73-.38.26-.26.4-.61.4-1.01,0-.14-.02-.27-.05-.4.41.03.83-.11,1.12-.4.25-.25.39-.58.4-.95.49.15,1.08.03,1.45-.34.18-.18.31-.41.37-.66.53.42,1.4.38,1.89-.11.11-.11.19-.22.25-.35.06.1.13.2.22.29.53.53,1.48.53,2.01,0,.02-.02.04-.05.07-.07.07.16.17.31.29.43.4.4,1.06.51,1.57.3.03.33.17.62.4.86.29.29.7.43,1.11.4.03.34.16.65.4.89.53.53,1.49.52,2.01,0,.27-.27.41-.61.41-1.01s-.14-.75-.4-1.01c-.29-.29-.7-.43-1.12-.41-.03-.34-.16-.65-.4-.89-.4-.4-1.06-.51-1.57-.3-.03-.33-.17-.63-.4-.85-.53-.53-1.49-.53-2.01,0-.02.02-.05.05-.07.07-.07-.16-.17-.31-.29-.43-.53-.53-1.48-.53-2.02,0-.1.1-.19.22-.25.35-.06-.1-.13-.19-.22-.28-.53-.54-1.49-.53-2.01,0-.19.18-.31.41-.37.66-.53-.42-1.4-.39-1.89.11-.25.25-.39.58-.4.95-.49-.15-1.08-.03-1.45.34-.27.27-.41.61-.41,1.01,0,.14.02.27.05.4-.41-.04-.82.11-1.11.4-.27.27-.41.61-.41,1.01,0,.23.05.45.14.65-.28.05-.53.18-.73.38-.27.27-.41.61-.41,1.01,0,.34.11.65.3.89-.16.07-.31.17-.44.3-.26.27-.4.61-.4,1.01s.14.74.41,1.01l.07.06c-.09.06-.17.12-.25.2-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.1.1.21.18.34.25-.11.06-.21.14-.29.23-.26.27-.4.61-.4,1.01s.14.74.41,1.01c.14.14.31.25.5.32-.23.26-.36.59-.36.96,0,.39.14.74.41,1.01.22.22.5.35.81.39-.11.21-.17.44-.17.7,0,.4.14.75.4,1,.28.28.65.44,1.06.41-.04.14-.06.29-.06.44,0,.39.14.74.4,1.01.4.41,1.07.51,1.59.3,0,.38.15.71.41.98.53.53,1.47.53,2.01,0,.07.21.18.4.34.56.53.53,1.48.54,2.02,0,.09-.09.17-.2.23-.31.06.11.14.22.23.32.27.27.61.41,1.01.41s.74-.14,1.01-.41c.26-.26.4-.61.41-1,.06.11.13.2.22.3.53.53,1.48.53,2.02,0,.27-.27.41-.61.41-1.01,0-.02,0-.04,0-.05.51.18,1.13.07,1.52-.32.27-.27.41-.61.41-1.01,0-.08,0-.17-.02-.24.33-.03.63-.17.86-.4.27-.27.41-.61.41-1.01,0-.33-.1-.64-.29-.88.22-.06.42-.18.59-.35.27-.27.41-.61.41-1.01s-.14-.75-.41-1.01c-.53-.53-1.48-.53-2.02,0ZM781.01,75.36c-.07-.03-.14-.06-.21-.08.03-.05.06-.1.08-.15.16-.35.17-.72.03-1.08-.18-.5-.53-.72-.79-.82-.06-.02-.11-.04-.17-.05.01-.03.03-.06.04-.09.14-.33.15-.71.02-1.08,0,0,0-.01,0-.02-.15-.38-.42-.65-.79-.8-.03-.01-.06-.02-.09-.03.01-.02.02-.04.03-.07.19-.36.19-.77.02-1.15-.14-.33-.39-.59-.73-.75-.07-.03-.13-.06-.2-.08.03-.05.06-.1.08-.15.16-.35.17-.72.03-1.08-.19-.5-.53-.72-.79-.82-.03,0-.05-.02-.08-.03.02-.04.04-.09.06-.14.13-.33.13-.69,0-1.05-.14-.37-.41-.65-.77-.8-.05-.02-.1-.04-.14-.05.02-.04.05-.09.07-.13.15-.34.18-.7.06-1.05,0-.02-.02-.05-.03-.07-.16-.34-.41-.6-.75-.75-.04-.02-.08-.04-.13-.05.02-.03.03-.07.05-.11.14-.34.15-.72,0-1.08,0,0,0,0,0,0-.14-.37-.41-.64-.76-.79-.06-.02-.12-.04-.18-.06.03-.05.06-.09.08-.15.18-.37.18-.77,0-1.14-.14-.33-.38-.58-.7-.73-.04-.02-.09-.04-.14-.06.02-.05.04-.09.06-.13.12-.33.12-.69,0-1.03-.12-.38-.39-.67-.77-.82-.19-.08-.37-.1-.54-.11.02-.05.05-.1.07-.15.13-.38.13-.75-.02-1.09-.15-.34-.42-.6-.81-.75-.38-.14-.77-.13-1.11.04-.32.15-.56.4-.7.71,0,.02-.01.03-.02.05-.13.38-.13.75.02,1.08.02.05.05.11.08.15-.05.01-.1.03-.15.05-.38.15-.64.44-.77.82-.13.34-.13.7,0,1.03.02.04.04.08.06.13-.05.02-.09.04-.13.06-.32.15-.56.41-.71.73-.17.36-.17.77,0,1.14.03.05.05.1.08.15-.06.02-.12.04-.18.06-.35.15-.62.42-.76.79,0,0,0,0,0,0-.14.36-.14.73,0,1.08.01.03.03.07.05.1-.04.01-.09.03-.13.05-.33.15-.58.41-.74.75-.01.02-.02.05-.03.07-.12.35-.09.71.06,1.05.02.05.04.09.07.13-.05.01-.1.03-.15.05-.36.15-.62.43-.77.8-.14.35-.14.72,0,1.05.02.05.04.1.06.14-.03,0-.05.02-.08.03-.37.14-.64.43-.79.82-.14.35-.13.72.03,1.08.02.05.05.1.08.15-.07.02-.14.04-.21.08-.34.16-.59.41-.73.75-.17.38-.16.79.02,1.15.01.02.02.04.04.07-.03,0-.07.02-.1.03-.37.14-.64.41-.78.79,0,0,0,.01,0,.02-.13.37-.13.75.02,1.08.01.03.03.06.04.09-.06.01-.12.03-.18.05-.26.1-.6.32-.78.82-.14.35-.13.73.03,1.08.02.05.05.1.08.15-.07.02-.14.04-.2.08-.33.15-.59.41-.73.75-.17.39-.17.79.02,1.15.16.31.41.54.75.7.18.07.37.1.55.1.17,0,.34-.03.51-.09.39-.14.67-.44.78-.8.14-.35.14-.72.01-1.06-.02-.06-.06-.13-.09-.2.07-.02.13-.05.2-.08.31-.15.56-.39.74-.75.15-.35.14-.73-.02-1.1-.01-.03-.03-.06-.04-.09.09-.02.17-.05.25-.09.32-.15.56-.4.72-.76.14-.38.13-.76-.02-1.09-.02-.04-.04-.08-.06-.11.03,0,.05-.02.08-.03.28-.1.5-.28.64-.5.05.08.1.15.17.22.25.27.57.44,1.05.46.37-.03.7-.17.96-.42.07-.07.14-.14.19-.23.06.08.13.16.21.23.26.23.59.36,1.03.39.37-.02.7-.16.95-.4.06-.05.11-.12.17-.19.05.06.1.13.16.19.3.3.67.44,1.11.4.34-.05.63-.18.88-.38.1-.08.18-.18.25-.28.06.09.13.18.21.26.27.25.61.39.94.39h0c.4.03.78-.12,1.06-.43.08-.09.15-.19.21-.29.15.27.39.47.69.58.02,0,.05.02.07.02-.02.04-.04.07-.06.11-.15.34-.15.71,0,1.14.14.31.39.56.7.71.08.04.17.07.26.09-.02.03-.03.06-.05.1-.16.36-.16.74,0,1.14.16.32.41.56.71.71.07.03.13.06.2.08-.04.07-.07.14-.1.2-.13.34-.12.7,0,1.01.12.4.41.7.8.85.34.12.7.11,1.09-.03.3-.14.55-.37.71-.68.19-.36.19-.76.02-1.15-.14-.34-.4-.59-.73-.74ZM775.38,69.13h0c-.36.03-.68.17-.94.43-.08.08-.15.17-.21.27-.06-.1-.12-.19-.2-.27-.25-.27-.58-.41-.95-.41-.03,0-.05,0-.08,0-.38,0-.71.14-.98.39-.07.07-.13.14-.18.21-.06-.08-.12-.16-.19-.23-.26-.24-.59-.37-.97-.38-.4-.02-.77.12-1.05.41-.06.06-.11.13-.16.2-.04-.06-.09-.13-.15-.18-.25-.27-.58-.42-.94-.45-.03,0-.07,0-.1,0-.11,0-.22.03-.32.06.05-.08.11-.16.15-.26.15-.35.14-.73-.02-1.1-.01-.03-.03-.06-.05-.09.04-.01.08-.03.12-.04.34-.15.6-.42.74-.79.14-.36.14-.73,0-1.08-.02-.05-.05-.11-.08-.16.06-.02.12-.04.18-.07.33-.15.59-.41.77-.83.12-.34.1-.71-.06-1.05l-.04-.08s.09-.04.14-.06c.32-.15.57-.41.72-.77.14-.36.13-.73-.01-1.08-.03-.06-.06-.12-.09-.18.05-.01.11-.03.16-.05.26-.1.61-.32.78-.8.15-.35.15-.72,0-1.07-.01-.04-.03-.07-.05-.1.04-.02.09-.03.13-.05.18-.08.33-.19.47-.34.13.14.29.25.47.34.04.02.09.04.13.05-.02.03-.03.07-.05.1-.15.35-.15.73-.01,1.05.18.51.53.73.79.83.05.02.1.03.15.05-.04.06-.07.12-.1.18-.15.34-.15.71,0,1.1.14.34.39.6.71.75.05.02.09.04.14.06-.01.03-.03.05-.04.08-.16.34-.18.7-.03,1.12.16.35.42.61.74.75.06.03.12.05.18.07-.03.05-.05.1-.08.15-.15.35-.15.72,0,1.08.14.37.39.65.74.8.04.01.08.03.12.04-.02.03-.03.06-.05.1-.16.36-.16.74,0,1.14.04.07.08.14.12.21-.15-.04-.31-.06-.48-.05ZM776.64,69.79s-.02-.03-.03-.05c.01,0,.03.01.05.01,0,.01-.01.02-.02.03ZM794.05,55.14s-.08.08-.11.13c-.03-.04-.07-.08-.11-.12-.53-.53-1.49-.53-2.02,0-.04.04-.08.08-.11.13-.03-.04-.07-.08-.11-.12-.53-.53-1.48-.54-2.02,0-.04.04-.08.09-.12.14-.04-.05-.08-.1-.12-.14-.53-.53-1.49-.53-2.02,0-.1.1-.18.2-.24.32-.05-.08-.11-.16-.19-.23-.53-.53-1.48-.53-2.02,0-.04.04-.08.08-.11.13-.03-.04-.07-.08-.11-.13-.53-.53-1.5-.53-2.02,0-.04.04-.08.08-.11.13-.03-.04-.07-.08-.11-.12-.53-.53-1.48-.53-2.02,0-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.53.53,1.49.53,2.01,0,.04-.04.08-.08.11-.13.03.04.07.08.11.12.53.53,1.48.54,2.02,0,.04-.04.08-.08.11-.12.03.04.07.08.11.13.53.53,1.48.53,2.02,0,.1-.1.17-.2.24-.32.05.08.12.16.19.23.04.04.08.08.12.11-.04.03-.08.07-.12.11-.27.27-.41.61-.41,1.01s.14.75.4,1.01c.04.04.08.08.13.11-.04.03-.08.07-.12.11-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.03.03.05.05.08.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.75.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.4,1c.05.05.09.09.14.13-.05.04-.1.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.4,1.01c.06.06.12.11.19.16-.07.05-.13.1-.18.15-.27.27-.41.61-.41,1.01s.14.74.4,1c.03.03.06.06.09.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.4,1c.26.27.61.41,1.01.41s.74-.14,1.01-.41c.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.13.26-.27.4-.61.4-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.13.26-.27.4-.61.4-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.03.06-.05.08-.08.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.06-.06-.12-.11-.19-.16.07-.05.13-.1.19-.16.26-.27.4-.61.4-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.03.06-.05.09-.08.26-.27.4-.61.4-1.01s-.14-.74-.41-1.01c-.04-.04-.08-.08-.13-.11.04-.03.08-.07.13-.11.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.08-.07-.12-.11.04-.04.09-.07.13-.11.04-.04.08-.09.12-.14.04.05.08.1.12.14.53.53,1.49.52,2.01,0,.04-.04.08-.08.11-.13.03.04.07.08.11.13.53.53,1.49.53,2.01,0,.04-.04.08-.08.11-.13.03.04.07.09.11.13.53.53,1.48.53,2.01,0,.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.53-.53-1.48-.53-2.02,0ZM804,56.86c.06.11.14.21.23.3.53.53,1.48.53,2.01,0,.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.53-.53-1.48-.53-2.02,0-.09.09-.16.19-.22.29-.06-.11-.14-.2-.22-.29-.53-.53-1.48-.53-2.02,0-.1.1-.18.21-.24.33-.06-.12-.15-.23-.25-.34-.53-.53-1.48-.53-2.02,0-.26.27-.4.61-.4,1.01s.14.74.41,1.01c.53.53,1.48.53,2.01,0,.1-.1.18-.21.25-.34.06.12.15.24.25.34.04.04.08.07.12.11-.04.04-.09.07-.13.11-.26.27-.4.61-.4,1.01s.14.74.4,1.01c.04.04.08.08.13.11-.04.03-.08.07-.13.11-.26.26-.4.61-.4,1.01s.14.74.41,1.01c.03.03.05.05.08.07-.03.03-.06.05-.09.08-.26.27-.4.61-.4,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.1.08-.14.12-.26.26-.4.61-.4,1.01s.14.74.4,1.01c.04.04.09.09.14.12-.05.04-.1.08-.14.12-.26.27-.4.61-.4,1.01s.14.74.4,1.01c.06.06.12.11.19.16-.07.05-.13.1-.19.16-.26.26-.4.61-.4,1.01s.14.74.4,1.01c.03.03.06.05.08.08-.03.02-.06.05-.09.08-.26.27-.4.61-.4,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.1.08-.14.13-.26.27-.4.61-.4,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.1.08-.14.12-.1.1-.18.21-.24.32-.07-.13-.15-.24-.26-.35-.53-.53-1.47-.53-2.02,0-.26.27-.4.61-.4,1.01s.14.74.41,1.01c.53.53,1.48.53,2.01,0,.1-.1.18-.21.24-.32.06.13.15.24.25.35.27.27.61.41,1.01.41s.74-.14,1.01-.4c.09-.09.17-.2.23-.31.06.1.13.2.22.29.53.53,1.48.53,2.01,0,.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.53-.53-1.48-.53-2.01,0-.09.09-.17.19-.23.3-.06-.1-.13-.2-.22-.28-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.02.06-.05.08-.08.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.06-.06-.12-.11-.19-.16.07-.05.13-.1.19-.16.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.26.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.02.06-.05.08-.08.27-.27.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.08-.08-.13-.11.04-.03.08-.07.12-.11.27-.26.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.08-.07-.12-.11.04-.03.08-.07.13-.11.09-.09.16-.19.22-.29ZM829.81,66.27c0-.39-.14-.74-.4-1.01-.03-.03-.06-.06-.09-.09.24-.26.36-.59.36-.96,0-.39-.14-.74-.41-1.01-.07-.07-.14-.13-.22-.18.19-.24.29-.54.29-.87,0-.39-.14-.74-.41-1.01-.19-.19-.42-.32-.68-.37.12-.21.19-.46.19-.72,0-.39-.14-.74-.41-1.01-.27-.27-.61-.41-1.01-.41.04-.13.06-.27.06-.42,0-.39-.14-.74-.41-1.01-.3-.3-.72-.44-1.15-.4v-.04c0-.39-.14-.74-.41-1.01-.49-.49-1.36-.53-1.9-.1-.05-.29-.18-.55-.38-.75-.52-.52-1.45-.53-1.98-.04-.06-.1-.13-.19-.22-.28-.53-.53-1.48-.53-2.02,0-.11.11-.2.23-.26.37-.01-.02-.03-.04-.05-.05-.53-.53-1.48-.53-2.02,0-.21.21-.34.46-.39.75-.53-.43-1.41-.39-1.9.11-.27.27-.41.61-.41,1.01v.04c-.42-.04-.85.1-1.16.4-.26.27-.4.61-.4,1.01,0,.15.02.29.06.42h0c-.39,0-.74.14-1.01.41-.26.27-.4.61-.4,1.01,0,.27.06.51.19.72-.26.06-.49.18-.68.37-.27.27-.41.61-.41,1.01,0,.33.1.62.28.86-.08.05-.16.12-.23.19-.27.27-.41.61-.41,1.01s.13.72.38.98c-.02.02-.05.04-.07.06-.27.27-.41.61-.41,1.01s.14.75.4,1c.02.02.05.05.07.07-.22.26-.34.58-.34.94,0,.39.14.74.4,1.01.04.04.09.08.14.12-.15.23-.23.5-.23.79,0,.39.14.74.41,1.01.19.19.42.32.68.37-.12.21-.19.46-.19.72,0,.39.14.74.41,1.01.27.27.61.41,1.01.41h0c-.04.13-.06.27-.06.42,0,.39.14.74.4,1,.3.3.74.44,1.16.4v.04c0,.39.14.74.41,1.01.49.49,1.36.53,1.9.11.05.29.18.55.39.75.53.53,1.48.53,2.01,0,.02-.02.03-.04.05-.05.06.13.15.26.26.37.27.27.61.41,1.01.41s.74-.14,1.01-.41c.08-.08.16-.18.22-.28.53.5,1.47.48,1.97-.04.21-.21.34-.46.39-.76.54.42,1.4.39,1.9-.11.27-.27.41-.61.41-1.01v-.04c.44.04.86-.1,1.15-.4.27-.26.41-.61.41-1.01,0-.15-.02-.29-.06-.42.4,0,.75-.14,1.01-.41.27-.27.41-.61.41-1.01,0-.27-.06-.51-.19-.72.26-.06.49-.18.68-.37.27-.27.41-.61.41-1.01,0-.29-.08-.55-.22-.78.05-.04.11-.08.15-.13.27-.27.41-.61.41-1.01,0-.36-.12-.68-.34-.94.02-.02.05-.04.07-.07.26-.26.4-.61.4-1.01ZM827.33,67.21s-.05.04-.07.07c-.27.27-.41.61-.41,1.01,0,.29.08.56.22.78-.05.04-.11.08-.15.13-.27.27-.41.61-.41,1.01,0,.27.06.51.19.72-.26.06-.49.18-.69.37-.26.27-.4.61-.4,1.01,0,.15.02.29.06.42-.39,0-.74.14-1.01.4-.27.26-.41.61-.41,1.01v.04c-.43-.04-.86.1-1.15.4-.21.21-.34.46-.39.75-.53-.43-1.41-.39-1.89.1-.09.08-.16.18-.22.28-.53-.49-1.45-.48-1.98.04-.02.02-.03.03-.05.05-.07-.13-.15-.26-.26-.37-.27-.27-.61-.41-1.01-.41-.34,0-.64.1-.89.3-.05-.29-.18-.55-.38-.75-.3-.3-.72-.44-1.16-.4v-.04c0-.39-.14-.74-.41-1.01-.27-.27-.61-.41-1.01-.41.04-.13.06-.27.06-.42,0-.39-.14-.74-.41-1.01-.19-.19-.42-.31-.68-.37.12-.21.19-.46.19-.72,0-.39-.14-.74-.41-1.01-.04-.04-.09-.08-.14-.12.15-.23.23-.5.23-.79,0-.39-.14-.74-.41-1.01-.02-.02-.04-.04-.07-.06.22-.25.34-.58.34-.94,0-.38-.13-.72-.38-.98.02-.02.05-.04.07-.07.26-.27.4-.61.4-1.01,0-.32-.09-.62-.28-.86.08-.05.16-.12.23-.19.27-.27.41-.61.41-1.01,0-.27-.06-.51-.19-.72.26-.06.49-.18.68-.37.27-.26.41-.61.41-1.01,0-.15-.02-.29-.06-.42.39,0,.74-.14,1.01-.41.26-.27.4-.61.4-1.01v-.04c.42.03.86-.1,1.15-.4.21-.21.34-.46.39-.75.54.43,1.4.39,1.9-.1.11-.11.2-.23.26-.37.02.02.03.04.05.05.52.52,1.43.53,1.97.03.06.1.13.2.22.28.49.49,1.36.53,1.9.11.05.29.18.55.39.75.3.3.72.43,1.15.4v.04c0,.39.14.74.41,1.01.27.27.61.41,1.01.41-.04.13-.06.27-.06.42,0,.39.14.74.41,1.01.19.19.42.32.69.37-.12.21-.19.46-.19.72,0,.39.14.74.4,1.01.07.07.14.13.22.18-.19.24-.29.54-.29.87,0,.39.14.74.41,1.01.03.03.06.06.09.09-.24.26-.36.59-.36.96s.12.68.34.94ZM850.68,58.38c0-.39-.14-.74-.41-1.01-.04-.04-.08-.08-.12-.11.04-.03.08-.07.12-.11.27-.27.41-.61.41-1.01s-.14-.74-.4-1.01c-.53-.53-1.49-.53-2.02,0-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.08.08.12.11-.04.03-.08.07-.12.11-.27.27-.41.61-.41,1.01s.14.75.4,1.01c.04.04.08.08.13.11-.04.03-.08.07-.12.11-.27.26-.41.61-.41,1.01s.14.74.41,1.01c.03.03.05.05.08.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.75.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.26-.41.61-.41,1.01s.14.75.4,1c.05.05.09.09.14.13-.05.04-.1.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.4,1.01c.06.06.12.11.19.16-.07.05-.13.1-.18.15-.27.26-.41.61-.41,1.01s.14.75.4,1c.03.03.06.06.09.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.09.09-.17.2-.23.31-.08-.04-.17-.07-.26-.09-.06-.01-.13-.03-.19-.03.02-.06.04-.12.06-.19.08-.36.03-.72-.2-1.12-.22-.3-.51-.5-.86-.58-.06-.01-.13-.03-.19-.03.02-.06.04-.12.06-.18.09-.37.03-.74-.19-1.08-.22-.33-.52-.54-.87-.63-.04,0-.08-.02-.12-.02.01-.03.02-.07.03-.11.08-.36.03-.73-.2-1.12-.22-.3-.51-.5-.86-.58-.08-.02-.17-.03-.25-.04.03-.07.06-.15.08-.23.11-.39.03-.78-.19-1.09-.2-.31-.49-.52-.85-.62-.07-.02-.14-.03-.21-.04.02-.05.04-.11.05-.17.11-.4.03-.8-.18-1.09-.2-.31-.49-.53-.86-.63-.07-.02-.14-.03-.21-.04.02-.05.04-.1.05-.15.11-.38.04-.77-.18-1.11-.2-.32-.51-.53-.88-.62-.04,0-.08-.02-.12-.02.01-.04.02-.07.04-.11.11-.39.03-.78-.19-1.08-.2-.31-.49-.52-.85-.62-.06-.02-.13-.03-.19-.04.02-.06.04-.12.05-.18.09-.37.03-.73-.2-1.1-.21-.29-.5-.49-.84-.58-.06-.02-.13-.03-.2-.04.02-.05.03-.1.05-.15.11-.39.03-.8-.19-1.09-.2-.31-.49-.52-.86-.63-.19-.05-.38-.06-.55-.03,0-.39-.14-.73-.41-1-.53-.53-1.49-.53-2.01,0-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.08.08.12.11-.04.03-.08.07-.12.11-.27.27-.41.61-.41,1.01s.14.75.4,1.01c.04.04.08.08.13.11-.04.03-.08.07-.12.11-.27.26-.41.61-.41,1.01s.14.74.41,1.01c.03.03.05.05.08.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.75.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.26-.41.61-.41,1.01s.14.75.4,1c.05.05.09.09.14.13-.05.04-.1.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.4,1.01c.06.06.12.11.19.16-.07.05-.13.1-.18.15-.27.26-.41.61-.41,1.01s.14.75.4,1c.03.03.06.06.09.08-.03.02-.06.05-.08.08-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.27-.41.61-.41,1.01s.14.74.41,1.01c.04.04.09.08.14.12-.05.04-.09.08-.14.12-.27.26-.41.61-.41,1.01s.14.75.4,1c.53.53,1.49.53,2.01,0,.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.09-.14-.12.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.02.06-.05.08-.08.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.06-.06-.12-.11-.19-.16.07-.05.13-.1.19-.16.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.26.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.26.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.07.03-.02.06-.05.08-.08.27-.27.41-.61.41-1.01s-.14-.75-.41-1.01c-.04-.04-.08-.08-.13-.11.04-.03.08-.07.12-.11.14-.13.24-.29.31-.46.06.01.11.02.17.03-.02.06-.04.11-.05.17-.08.37-.02.74.18,1.06,0,.01.02.03.03.04.21.29.5.49.84.59.06.02.13.03.2.04-.02.05-.03.09-.05.14-.11.39-.03.78.2,1.11.2.3.49.51.84.61.05.01.09.02.14.03-.01.03-.02.06-.03.08-.11.38-.04.78.19,1.11.2.3.49.51.84.6.07.02.14.03.21.04-.02.05-.04.11-.05.17-.11.39-.04.78.2,1.11.2.3.49.51.84.61.07.02.14.03.21.04-.02.05-.04.11-.05.16-.11.39-.04.78.2,1.11.2.3.49.51.84.61.09.02.18.04.27.05-.03.07-.06.15-.08.23-.09.37-.03.74.18,1.07,0,.01.01.02.02.03.21.29.5.49.84.59.05.01.1.02.15.03-.01.04-.02.08-.03.12-.09.36-.03.73.17,1.06.01.02.02.04.04.06.22.3.52.5.86.58.06.02.13.03.2.03-.02.06-.04.12-.06.19-.09.37-.03.74.18,1.06,0,0,0,0,0,.01.22.32.52.54.88.63.06.02.13.03.19.03-.02.06-.04.12-.06.18-.09.37-.03.74.18,1.07,0,.01.01.02.02.03.21.29.5.49.84.59.27.08.55.06.78-.02-.02.1-.03.21-.03.32,0,.4.14.75.4,1,.26.27.61.41,1.01.41s.75-.14,1-.4c.27-.27.41-.61.41-1.01s-.14-.75-.4-1.01c-.05-.05-.09-.09-.14-.13.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.4-1.01c-.05-.05-.09-.09-.14-.13.05-.04.1-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.06-.05-.08-.08.03-.02.06-.05.08-.08.27-.27.41-.61.41-1.01s-.14-.75-.4-1.01c-.06-.06-.12-.11-.19-.16.07-.05.13-.1.19-.16.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.04-.04-.09-.08-.14-.12.05-.04.09-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.75-.4-1.01c-.04-.05-.09-.09-.14-.13.05-.04.09-.08.14-.12.27-.27.41-.61.41-1.01s-.14-.74-.41-1.01c-.03-.03-.05-.05-.08-.08.03-.02.06-.05.08-.08.27-.27.41-.61.41-1.01s-.14-.75-.4-1.01c-.04-.04-.08-.08-.13-.11.04-.03.08-.07.12-.11.27-.27.41-.61.41-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M705.36,56.15c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM705.36,58.39c0-.21.07-.38.2-.52.13-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM705.36,60.62c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM705.36,62.79c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM705.36,65.05c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52ZM705.36,67.31c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM705.36,69.64c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM705.36,71.81c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM705.36,74.07c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM705.36,76.34c0-.21.07-.39.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM708.48,77.06c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM710.71,77.06c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM712.95,77.06c-.21,0-.38-.07-.52-.2-.13-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM715.12,77.06c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM717.34,77.06c-.21,0-.38-.07-.52-.2s-.2-.31-.2-.52.07-.39.2-.52.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M720.86,65.55c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2ZM720.95,64.94c-.21,0-.38-.07-.52-.2s-.2-.31-.2-.52.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM721,67.56c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM721.32,62.88c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM721.32,69.49c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2ZM722.22,60.78c-.21,0-.38-.07-.52-.2-.13-.13-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2ZM722.22,71.59c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.13.31-.2.52-.2ZM723.58,58.95c-.21,0-.38-.07-.52-.2-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM723.58,73.42c.21,0,.38.07.52.2.14.13.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2ZM725.14,57.5c-.21,0-.38-.07-.52-.2s-.2-.31-.2-.52.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2ZM725.14,74.87c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2ZM727.42,56.64c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2ZM727.42,75.72c.21,0,.38.07.52.2s.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM729.75,56.33c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM729.75,76.04c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52.07-.38.2-.52c.14-.13.31-.2.52-.2ZM731.94,56.64c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2ZM731.94,75.72c.21,0,.38.07.52.2.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM734.22,57.5c-.21,0-.38-.07-.52-.2s-.2-.31-.2-.52.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2ZM734.22,74.87c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2ZM735.78,58.95c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.13.14-.31.2-.52.2ZM735.78,73.42c.21,0,.38.07.52.2.14.13.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2ZM737.14,60.78c-.21,0-.39-.07-.52-.2-.14-.13-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.13.14-.31.2-.52.2ZM737.14,71.59c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.39-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.13.31-.2.52-.2ZM738.04,62.88c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2ZM738.04,69.49c.21,0,.39.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2ZM738.38,64.94c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM738.38,67.56c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM738.52,65.55c.21,0,.38.07.52.2.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M743.27,66.14c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM743.31,68.63c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.39-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM743.45,63.86c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM743.85,70.91c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM743.99,61.66c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2-.2-.31-.2-.52ZM744.89,73.01c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM744.98,59.63c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM746.29,74.87c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM746.45,57.82c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM748.28,76.13c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM748.31,56.53c0-.21.07-.38.2-.52s.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM750.57,55.76c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM750.64,76.7c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM753.05,55.7c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM753.12,76.7c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM755.43,56.06c0-.21.07-.39.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.13.13.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52ZM755.77,76c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM757.39,57.21c0-.21.07-.38.2-.52s.31-.2.52-.2.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM757.69,74.62c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.39-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM758.91,58.5c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM758.93,72.97c0-.21.07-.38.2-.52s.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM759.63,70.73c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.13-.2-.31-.2-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M762.73,76.38c.08-.18.2-.31.38-.4.18-.08.36-.09.54-.01.21.08.35.2.42.38.07.18.06.37-.01.56-.06.2-.18.33-.37.4-.19.07-.38.06-.58-.01-.17-.08-.29-.2-.38-.37-.09-.17-.09-.36,0-.55ZM763.57,74.3c.08-.21.2-.35.38-.42.18-.07.37-.06.57.01.18.06.31.18.4.37.08.19.09.37.01.55-.09.18-.22.31-.4.4-.17.08-.36.09-.55.01-.18-.08-.31-.2-.4-.38-.08-.18-.09-.36-.01-.54ZM764.47,72.24c.08-.2.2-.33.38-.4.18-.07.37-.06.57.01.2.08.33.2.41.37.08.17.08.37,0,.58-.08.17-.2.29-.37.37-.17.08-.37.09-.58.01-.2-.08-.33-.2-.41-.37-.08-.17-.08-.37,0-.58ZM765.28,70.23c.07-.18.2-.31.38-.4.18-.08.36-.09.54-.01.21.07.35.2.42.38.07.18.06.37-.01.56-.06.2-.18.33-.37.4-.19.07-.38.06-.58-.01-.17-.07-.29-.2-.38-.37-.09-.17-.09-.36,0-.55ZM766.12,68.15c.07-.21.2-.35.38-.42s.37-.06.57.01c.18.06.31.18.4.37.08.19.09.37.01.55-.09.18-.22.31-.4.4-.17.08-.36.09-.55.01-.18-.08-.31-.2-.4-.38-.08-.18-.09-.36-.01-.54ZM766.93,66.12c.07-.2.2-.33.38-.41.18-.07.36-.07.54,0,.2.08.33.2.41.38.08.18.08.37,0,.57-.08.2-.2.33-.37.41-.17.08-.37.07-.58-.02-.2-.08-.33-.2-.4-.37-.07-.17-.06-.36.01-.55ZM768.34,69.82c.2.01.36.09.5.24.14.14.21.32.23.53-.02.2-.09.36-.24.5-.14.14-.32.21-.53.23-.2-.01-.36-.09-.49-.24-.13-.14-.21-.32-.24-.53.03-.2.11-.36.25-.5.14-.14.31-.21.52-.23ZM767.72,64.06c.09-.2.23-.34.41-.42.18-.08.36-.09.54-.03.2.09.34.23.42.41.08.18.09.36.03.54-.09.2-.23.34-.41.42-.18.08-.36.09-.54.03-.2-.09-.34-.23-.42-.41-.08-.18-.09-.36-.03-.54ZM768.56,62.03c.08-.2.2-.33.38-.41.18-.07.37-.07.57,0,.18.09.31.22.38.4.07.17.07.36,0,.55-.08.18-.2.31-.37.4-.17.08-.37.09-.58.01-.18-.08-.31-.2-.38-.38-.08-.18-.08-.37,0-.57ZM769.4,59.92c.08-.18.2-.31.37-.4.17-.08.37-.09.58-.01.18.08.31.2.38.38.07.18.07.36,0,.54-.08.21-.2.35-.38.42-.18.07-.37.06-.57-.01-.17-.06-.29-.18-.38-.37-.09-.19-.09-.37,0-.55ZM770.66,69.85c.21,0,.38.06.52.19.14.13.2.3.2.51.01.23-.05.4-.18.53-.14.13-.31.2-.52.21-.21-.01-.39-.09-.53-.21-.14-.13-.21-.3-.21-.51s.07-.39.2-.53c.14-.14.31-.21.52-.19ZM770.21,57.91c.06-.2.18-.33.37-.41.19-.08.37-.07.53.02.2.06.34.18.42.36.08.18.09.37.03.56-.09.18-.23.31-.41.4-.18.08-.36.09-.54.01-.21-.08-.35-.2-.42-.38-.07-.18-.06-.37.01-.57ZM771.03,55.81c.07-.17.2-.29.37-.37.17-.08.37-.09.58-.01.2.08.33.2.41.37.07.17.07.37,0,.58-.08.2-.2.33-.38.4-.18.07-.37.06-.57-.01-.2-.08-.33-.2-.41-.37-.08-.17-.08-.37,0-.58ZM773.63,57.91c.08.2.08.38.01.57-.07.18-.21.31-.42.38-.18.08-.36.07-.54-.01-.18-.08-.32-.21-.41-.4-.06-.2-.05-.38.03-.56.08-.18.22-.3.42-.36.17-.09.34-.1.53-.02.19.08.31.21.37.41ZM773.04,69.85c.2-.01.36.05.5.19.14.14.2.32.2.53.01.21-.05.38-.19.5-.14.12-.32.2-.53.23-.2.02-.37-.05-.52-.2-.15-.15-.21-.32-.18-.52-.02-.21.05-.38.19-.52.14-.14.32-.2.53-.2ZM774.44,59.92c.09.18.09.37,0,.55-.09.19-.22.31-.38.37-.2.08-.38.08-.57.01-.18-.07-.31-.21-.38-.42-.08-.18-.08-.36,0-.54.08-.18.2-.31.38-.38.21-.07.4-.07.58.01.17.08.3.21.37.4ZM775.28,62.03c.07.2.07.39,0,.57-.08.18-.2.31-.38.38-.21.08-.4.07-.58-.01-.17-.08-.3-.21-.37-.4-.08-.2-.08-.38,0-.55.08-.17.2-.31.38-.4.2-.07.38-.07.57,0,.18.08.31.21.38.41ZM776.11,64.06c.06.18.05.36-.03.54-.08.18-.22.32-.42.41-.18.06-.36.05-.54-.03-.18-.08-.32-.22-.41-.42-.06-.18-.05-.36.03-.54.08-.18.22-.32.42-.41.18-.06.36-.05.54.03.18.08.32.22.41.42ZM775.43,69.82c.21-.02.38.05.52.2.14.15.2.32.2.5,0,.21-.07.39-.2.54-.14.15-.3.22-.5.2-.21,0-.39-.07-.53-.2-.14-.14-.21-.31-.21-.52.02-.2.09-.36.23-.5.14-.14.3-.21.5-.23ZM776.9,66.12c.08.2.08.38.01.55-.07.17-.2.3-.4.37-.21.09-.4.1-.58.02-.17-.07-.3-.21-.37-.41-.08-.2-.08-.38,0-.57.07-.18.21-.31.41-.38.18-.07.36-.07.54,0,.18.08.31.21.38.41ZM777.72,68.15c.08.18.07.36-.01.54-.08.18-.21.31-.4.38-.2.08-.38.07-.55-.01-.17-.08-.31-.21-.4-.4-.08-.18-.07-.37.01-.55.08-.19.21-.31.4-.37.2-.08.38-.08.56-.01.18.07.31.21.38.42ZM778.55,70.23c.09.2.09.38,0,.55-.09.17-.22.3-.38.37-.2.08-.39.08-.58.01-.19-.07-.31-.2-.37-.4-.08-.2-.08-.38-.01-.56.07-.18.21-.31.42-.38.18-.08.36-.07.54.01.18.08.31.21.38.4ZM779.37,72.24c.08.21.08.4,0,.58-.08.17-.21.3-.41.37-.21.08-.4.07-.58-.01-.17-.08-.3-.21-.37-.37-.08-.21-.08-.4,0-.58.08-.17.21-.3.41-.37.2-.07.39-.08.57-.01.18.07.31.2.38.4ZM780.27,74.3c.08.18.07.36-.01.54-.08.18-.21.31-.4.38-.2.08-.38.07-.55-.01-.17-.08-.31-.21-.4-.4-.08-.18-.07-.37.01-.55.08-.19.21-.31.4-.37.2-.07.38-.08.57-.01.18.07.31.21.38.42ZM781.11,76.38c.09.2.09.38,0,.55-.09.17-.22.3-.38.37-.2.08-.39.08-.58.01-.19-.07-.31-.2-.37-.4-.08-.2-.08-.38-.01-.56.07-.18.21-.31.42-.38.18-.08.36-.07.54.01.18.08.31.21.38.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M781.4,56.96c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2ZM783.64,56.96c-.21,0-.38-.07-.52-.2-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM785.88,56.96c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM787.59,56.15c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM787.59,58.39c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM787.59,60.62c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM787.59,62.79c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM787.59,65.05c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52ZM787.59,67.31c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM787.59,69.64c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM787.59,71.81c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM787.59,74.07c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM787.59,76.34c0-.21.07-.39.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM790.58,56.87c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM792.82,56.87c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2ZM795.05,56.87c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M799.53,56.15c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM799.53,76.31c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM802.04,56.15c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM802.04,58.39c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM802.04,60.62c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM802.04,62.79c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM802.04,65.05c0-.21.07-.38.2-.52s.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM802.04,67.31c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM802.04,69.64c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM802.04,71.81c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM802.04,74.07c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52ZM802.04,76.34c0-.21.07-.39.2-.52s.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM804.5,56.15c0-.21.07-.38.2-.52s.31-.2.52-.2.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM804.5,76.31c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M810.74,65.55c.21,0,.39.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2ZM810.83,64.94c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM810.88,67.56c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM811.19,62.88c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2ZM811.19,69.49c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2ZM812.1,60.78c-.21,0-.38-.07-.52-.2s-.2-.31-.2-.52.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2ZM812.1,71.59c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.13.31-.2.52-.2ZM813.46,58.95c-.21,0-.38-.07-.52-.2-.13-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM813.46,73.42c.21,0,.38.07.52.2.14.13.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.13-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2ZM815.02,57.5c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM815.02,74.87c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM817.3,56.64c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2ZM817.3,75.72c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2ZM819.63,56.33c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2.2.31.2.52-.07.38-.2.52c-.14.14-.31.2-.52.2ZM819.63,76.04c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52-.31.2-.52.2-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.13.31-.2.52-.2ZM821.82,56.64c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2.38.07.52.2c.13.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2ZM821.82,75.72c.21,0,.38.07.52.2.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52.07-.38.2-.52c.14-.14.31-.2.52-.2ZM824.1,57.5c-.21,0-.38-.07-.52-.2s-.2-.31-.2-.52.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM824.1,74.87c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.13-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52.31-.2.52-.2ZM825.66,58.95c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2ZM825.66,73.42c.21,0,.38.07.52.2.14.13.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.39.2-.52c.14-.14.31-.2.52-.2ZM827.02,60.78c-.21,0-.39-.07-.52-.2-.14-.13-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.13.14-.31.2-.52.2ZM827.02,71.59c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.39-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.13.31-.2.52-.2ZM827.92,62.88c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2s.39.07.52.2.2.31.2.52-.07.38-.2.52c-.13.14-.31.2-.52.2ZM827.92,69.49c.21,0,.39.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52s.07-.38.2-.52c.13-.14.31-.2.52-.2ZM828.26,64.94c-.21,0-.38-.07-.52-.2-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2ZM828.26,67.56c.21,0,.38.07.52.2.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2ZM828.4,65.55c.21,0,.38.07.52.2.13.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52s.07-.38.2-.52c.14-.14.31-.2.52-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M834.39,56.15c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM834.39,58.39c0-.21.07-.38.2-.52.13-.13.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM834.39,60.62c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM834.39,62.79c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM834.39,65.05c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52ZM834.39,67.31c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM834.39,69.64c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM834.39,71.81c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM834.39,74.07c0-.21.07-.38.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM834.39,76.34c0-.21.07-.39.2-.52.13-.14.31-.2.52-.2s.38.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.14.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM836.13,57.93c-.12-.16-.15-.35-.1-.54.05-.2.16-.35.33-.45.17-.12.35-.15.54-.1.2.05.35.16.45.33.12.17.15.35.1.54-.05.2-.16.35-.33.45-.17.12-.35.15-.54.1-.2-.05-.35-.16-.45-.33ZM837.3,59.83c-.1-.17-.14-.35-.09-.54.05-.2.16-.35.34-.45.17-.12.34-.15.53-.1.19.05.34.16.46.33.1.17.14.34.09.53-.05.19-.15.34-.32.46-.18.12-.37.15-.55.1-.19-.05-.34-.16-.46-.33ZM838.5,61.73c-.12-.17-.15-.35-.1-.54.05-.2.16-.35.33-.45.17-.12.35-.15.54-.1.2.05.35.16.45.33.12.17.15.34.1.53-.05.19-.16.34-.33.46-.17.12-.35.15-.54.1-.2-.05-.35-.16-.45-.33ZM839.66,63.56c-.12-.17-.15-.34-.1-.53.05-.19.16-.34.33-.46.17-.11.35-.14.54-.09.2.05.35.15.45.32.12.18.15.37.1.55-.05.19-.16.34-.33.44-.17.12-.35.15-.54.1-.2-.05-.35-.16-.45-.33ZM840.85,65.48c-.12-.17-.15-.35-.1-.54.05-.2.16-.35.33-.45.17-.12.35-.15.54-.1.2.05.35.16.45.33.12.17.15.35.1.54-.05.2-.16.35-.33.45-.17.12-.35.15-.54.1-.2-.05-.35-.16-.45-.33ZM842.05,67.41c-.12-.17-.15-.35-.1-.54.05-.2.16-.35.33-.45.17-.12.35-.15.54-.1.2.05.35.16.45.33.12.17.15.34.1.53-.05.19-.16.34-.33.46-.17.12-.35.15-.54.1-.2-.05-.35-.16-.45-.33ZM843.27,69.37c-.11-.17-.14-.34-.09-.53.05-.19.16-.34.34-.46.16-.1.34-.13.53-.09.19.05.34.15.46.32.1.18.13.37.09.55-.05.19-.16.34-.34.44-.17.12-.34.15-.53.1-.19-.05-.34-.16-.46-.33ZM844.42,71.23c-.1-.18-.13-.37-.09-.55.05-.19.15-.34.32-.46.18-.11.37-.14.55-.09.19.05.34.16.46.34.1.17.14.34.09.53-.04.19-.16.34-.34.46-.17.11-.34.14-.53.09-.19-.04-.34-.15-.46-.32ZM845.62,73.13c-.11-.17-.14-.34-.09-.53.05-.19.15-.34.32-.46.18-.1.37-.14.55-.09.19.04.34.15.46.32.1.18.14.37.09.55-.05.19-.16.34-.34.46-.17.11-.34.14-.53.09-.19-.05-.34-.16-.46-.34ZM846.82,75.05c-.11-.17-.14-.34-.09-.53.05-.19.15-.34.32-.46.18-.1.37-.13.55-.09.19.05.34.15.46.32.1.18.13.37.09.55-.05.19-.16.34-.34.44-.17.12-.34.15-.53.1-.19-.05-.34-.16-.46-.33ZM848.54,56.15c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM848.54,58.39c0-.21.07-.38.2-.52.14-.13.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM848.54,60.62c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM848.54,62.79c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM848.54,65.05c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.39-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.13-.2-.31-.2-.52ZM848.54,67.31c0-.21.07-.38.2-.52s.31-.2.52-.2.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM848.54,69.64c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52ZM848.54,71.81c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM848.54,74.07c0-.21.07-.38.2-.52.14-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2-.2-.31-.2-.52ZM848.54,76.34c0-.21.07-.39.2-.52.14-.14.31-.2.52-.2s.39.07.52.2c.14.14.2.31.2.52s-.07.38-.2.52c-.13.14-.31.2-.52.2s-.38-.07-.52-.2c-.14-.14-.2-.31-.2-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M47.1,246.26h-22.41c-.47,0-.86-.38-.86-.86s.38-.86.86-.86h22.41c15.91,0,28.85-12.94,28.85-28.84v-125.41c0-8.73-7.1-15.83-15.83-15.83h-9.72c-.47,0-.86-.38-.86-.86s.38-.86.86-.86h9.72c9.67,0,17.54,7.87,17.54,17.54v125.41c0,16.85-13.71,30.56-30.56,30.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M24.7,220.75h1.22l.7-12.47h-3.51l-4.82,36.01v2.57h-1.02v4.31h7.19c1.19,0,2.16-.97,2.16-2.16h0c0-1.19-.97-2.16-2.16-2.16h-1.41v-2.73l1.65-23.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M38.11,139.72c-.32.28-.63.77-.72,1.11-.31,1.19-.6,2.37-.9,3.55-.09.36.11.45.44.21.31-.23.62-.45.93-.68.33-.24.53-.14.44.23-5.88,25.35-8.9,47.81-9.63,66.62-.05,1.13,1.48,3.36,3.41,5,0-.43,0-.85,0-1.28,2.06,1.68,4.13,3.37,6.19,5.05.56.45.97,1.2.82,1.47-.43.76-.94,1.53-1.56,2.23t0,0c-.64-.02-.44.92.41,2.21,0,0,0,0,0,0,.09.13.15.25.25.39.26.36.54.71.83,1.03.91,1.01,1.88,1.75,2.41,1.75,6.72-.37,4.17-12.4,4.19-12.51-.24-1.15-1.35-2.57-2.5-3.2-.11-.06-.2-.07-.3-.12h0s0,0,0,0c-.48-.2-.87-.23-1.12-.08-.04.02-.06.07-.09.1-.07.07-.15.13-.18.24-.05.16-.07.36-.02.61.01.04-.11,1.84-1.02,4.43-.08.23-.4.19-.78-.1-2.24-1.72-4.47-3.44-6.71-5.16-.45-.34-.81-.87-.8-1.18.17-9.06.82-18.75,1.98-29.01.04-.34.38-.59.76-.54.95.12,1.91.24,2.86.35.38.05.66.39.62.77-.59,6.98-.97,13.77-1.14,20.35-.09,2.66,2.56,6.51,5.85,8.64-.01-.66-.03-1.33-.04-2,1.56-2.52,2.39-13.79,3.13-28.41.71-14.59,1.3-26.97.58-30.24.1-.73.2-1.47.31-2.2-2.59,1.33-5.12,4.89-5.59,7.9-1.13,7.4-2.03,14.63-2.71,21.68-.04.38-.37.67-.74.65-.94-.06-1.89-.12-2.83-.18-.37-.03-.64-.33-.6-.68,1.43-11.49,3.49-23.66,6.24-36.42.08-.39.42-.9.75-1.14,16.74-12.32,33.48-30.77,50.23-43.09v-10.23c-17.77,19.15-35.65,35.6-53.68,51.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 3.85,
    y: 185.82,
    width: 12.2,
    height: 3.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M12.37,197.8c-.26-.07-.51-.18-.75-.34-.96-.66-1.19-1.87-.52-2.69,5.64-6.85,4.13-15.53,4.12-15.62-.19-1.05.59-1.99,1.75-2.1,1.16-.12,2.26.65,2.46,1.7.08.42,1.85,10.3-4.84,18.42-.52.63-1.41.85-2.23.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M17.29,178.19c-.08-.41-.32-.76-.63-1.05-.98.24-1.62,1.07-1.44,2.01.02.09-.42,5.55-4.12,15.62-.33.91-.45,1.79.3,2.47.41-.1.78-.31,1.05-.64,6.68-8.12,4.91-18,4.84-18.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M6.06,190.96h0c-1.81,0-3.28-1.47-3.28-3.28v-91.5h3.28v94.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 3.85,
    y: 142.34,
    width: 12.2,
    height: 3.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-105",
    cx: 15.78,
    cy: 143.98,
    rx: 3.92,
    ry: 31.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M16.11,111.6h.78v64.75h-.78c-2.87,0-5.2-2.33-5.2-5.2v-54.34c0-2.87,2.33-5.2,5.2-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M10.91,117.9h.28c1.03,0,1.87.84,1.87,1.87v48.41c0,1.03-.84,1.87-1.87,1.87h-.28v-52.16h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "95.42 98.1 0 98.1 0 92.32 95.42 86.54 95.42 98.1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M310.58,77.49h159.89c0,27.77-22.55,50.32-50.32,50.32h-119.7v-40.19c0-5.59,4.54-10.13,10.13-10.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-127"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M498.7,77.49h170.02c0,27.77-22.55,50.32-50.32,50.32h-119.7v-50.32h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M890.78,77.49h170.02c0,27.77-22.55,50.32-50.32,50.32h-119.7v-50.32h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1086.82,77.49h170.02c0,27.77-22.55,50.32-50.32,50.32h-119.7v-50.32h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1284.86,77.49h170.02c0,27.77-22.55,50.32-50.32,50.32h-119.7v-50.32h0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/Bus.a19e4d0f82ed1b82d4e1647a880f2b3b.svg";
export { ForwardRef as ReactComponent };